[
  {
    "source": "ab-testing",
    "target": "suitable"
  },
  {
    "source": "ab-testing",
    "target": "usable"
  },
  {
    "source": "ab-testing",
    "target": "functional-appropriateness"
  },
  {
    "source": "ab-testing",
    "target": "effectiveness"
  },
  {
    "source": "ab-testing",
    "target": "user-experience"
  },
  {
    "source": "ab-testing",
    "target": "user-engagement"
  },
  {
    "source": "ab-testing",
    "target": "canary-deployment"
  },
  {
    "source": "access-control",
    "target": "secure"
  },
  {
    "source": "access-control",
    "target": "security"
  },
  {
    "source": "access-control",
    "target": "accountability"
  },
  {
    "source": "access-control",
    "target": "authenticity"
  },
  {
    "source": "access-control",
    "target": "confidentiality"
  },
  {
    "source": "access-control",
    "target": "privacy"
  },
  {
    "source": "access-control",
    "target": "intrusion-detection"
  },
  {
    "source": "access-control",
    "target": "intrusion-prevention"
  },
  {
    "source": "access-control-is-enforced",
    "target": "access-control"
  },
  {
    "source": "access-control-is-enforced",
    "target": "auditability"
  },
  {
    "source": "access-control-is-enforced",
    "target": "securability"
  },
  {
    "source": "access-control-via-sso",
    "target": "access-control"
  },
  {
    "source": "access-control-via-sso",
    "target": "auditability"
  },
  {
    "source": "access-find-function-quickly",
    "target": "usability"
  },
  {
    "source": "access-find-function-quickly",
    "target": "user-experience"
  },
  {
    "source": "access-find-function-quickly",
    "target": "ease-of-use"
  },
  {
    "source": "access-find-function-quickly",
    "target": "convenience"
  },
  {
    "source": "access-find-function-quickly",
    "target": "interaction-capability"
  },
  {
    "source": "accessibility",
    "target": "usable"
  },
  {
    "source": "accessibility",
    "target": "usability"
  },
  {
    "source": "accessibility",
    "target": "inclusivity"
  },
  {
    "source": "accessibility",
    "target": "interaction-capability"
  },
  {
    "source": "accessibility",
    "target": "ease-of-use"
  },
  {
    "source": "accessible-user-interface",
    "target": "usability"
  },
  {
    "source": "accessible-user-interface",
    "target": "inclusivity"
  },
  {
    "source": "accessible-user-interface",
    "target": "compliance"
  },
  {
    "source": "accessible-user-interface",
    "target": "accessibility"
  },
  {
    "source": "accessible-user-interface",
    "target": "interaction-capability"
  },
  {
    "source": "accountability",
    "target": "secure"
  },
  {
    "source": "accountability",
    "target": "authenticity"
  },
  {
    "source": "accountability",
    "target": "security"
  },
  {
    "source": "accountability",
    "target": "non-repudiation"
  },
  {
    "source": "accountability",
    "target": "auditability"
  },
  {
    "source": "accountability",
    "target": "access-control"
  },
  {
    "source": "accountability",
    "target": "traceability"
  },
  {
    "source": "accuracy",
    "target": "reliable"
  },
  {
    "source": "accuracy",
    "target": "usable"
  },
  {
    "source": "accuracy",
    "target": "correctness"
  },
  {
    "source": "accuracy",
    "target": "precision"
  },
  {
    "source": "accuracy",
    "target": "precision"
  },
  {
    "source": "accuracy",
    "target": "data-quality"
  },
  {
    "source": "accurate-estimate-of-insurance-rate",
    "target": "accuracy"
  },
  {
    "source": "accurate-estimate-of-insurance-rate",
    "target": "precision"
  },
  {
    "source": "accurate-estimate-of-insurance-rate",
    "target": "precision"
  },
  {
    "source": "accurate-estimate-of-insurance-rate",
    "target": "reliability"
  },
  {
    "source": "accurate-estimate-of-insurance-rate",
    "target": "correctness"
  },
  {
    "source": "accurate-estimate-of-insurance-rate",
    "target": "interaction-capability"
  },
  {
    "source": "accurate-vehicle-position-gps",
    "target": "precision"
  },
  {
    "source": "accurate-vehicle-position-gps",
    "target": "precision"
  },
  {
    "source": "accurate-vehicle-position-gps",
    "target": "reliability"
  },
  {
    "source": "accurate-vehicle-position-gps",
    "target": "correctness"
  },
  {
    "source": "adaptability",
    "target": "flexible"
  },
  {
    "source": "adaptability",
    "target": "usable"
  },
  {
    "source": "adaptability",
    "target": "changeability"
  },
  {
    "source": "adaptability",
    "target": "configurability"
  },
  {
    "source": "adaptability",
    "target": "maintainability"
  },
  {
    "source": "adaptability",
    "target": "flexibility"
  },
  {
    "source": "adaptability",
    "target": "usability"
  },
  {
    "source": "adaptability",
    "target": "scalability"
  },
  {
    "source": "adaptability",
    "target": "elasticity"
  },
  {
    "source": "add-new-product",
    "target": "efficiency"
  },
  {
    "source": "add-new-product",
    "target": "usability"
  },
  {
    "source": "add-new-product",
    "target": "extensibility"
  },
  {
    "source": "adding-entity-type-within-5-days",
    "target": "evolvability"
  },
  {
    "source": "adding-entity-type-within-5-days",
    "target": "modularity"
  },
  {
    "source": "adding-entity-type-within-5-days",
    "target": "maintainability"
  },
  {
    "source": "adding-entity-type-within-5-days",
    "target": "extensibility"
  },
  {
    "source": "affordability",
    "target": "suitable"
  },
  {
    "source": "affordability",
    "target": "usable"
  },
  {
    "source": "affordability",
    "target": "efficient"
  },
  {
    "source": "affordability",
    "target": "cost"
  },
  {
    "source": "affordability",
    "target": "profitability"
  },
  {
    "source": "affordability",
    "target": "resource-utilization"
  },
  {
    "source": "affordable-crm",
    "target": "affordability"
  },
  {
    "source": "affordable-crm",
    "target": "cost"
  },
  {
    "source": "affordable-crm",
    "target": "affordability"
  },
  {
    "source": "affordable-crm",
    "target": "profitability"
  },
  {
    "source": "agility",
    "target": "flexible"
  },
  {
    "source": "agility",
    "target": "flexibility"
  },
  {
    "source": "agility",
    "target": "changeability"
  },
  {
    "source": "agility",
    "target": "adaptability"
  },
  {
    "source": "agility",
    "target": "modifiability"
  },
  {
    "source": "agility",
    "target": "modularity"
  },
  {
    "source": "aiuc1",
    "target": "privacy"
  },
  {
    "source": "aiuc1",
    "target": "reliability"
  },
  {
    "source": "aiuc1",
    "target": "safety"
  },
  {
    "source": "aiuc1",
    "target": "security"
  },
  {
    "source": "aiuc1",
    "target": "accountability"
  },
  {
    "source": "aiuc1",
    "target": "secure"
  },
  {
    "source": "aiuc1",
    "target": "reliable"
  },
  {
    "source": "aiuc1",
    "target": "safe"
  },
  {
    "source": "analysability",
    "target": "reliable"
  },
  {
    "source": "analysability",
    "target": "maintainable"
  },
  {
    "source": "analysability",
    "target": "flexibility"
  },
  {
    "source": "analysability",
    "target": "maintainability"
  },
  {
    "source": "analysability",
    "target": "modifiability"
  },
  {
    "source": "analysability",
    "target": "testability"
  },
  {
    "source": "analysability",
    "target": "debuggability"
  },
  {
    "source": "annual-tax-update",
    "target": "efficiency"
  },
  {
    "source": "annual-tax-update",
    "target": "maintainability"
  },
  {
    "source": "annual-tax-update",
    "target": "changeability"
  },
  {
    "source": "anticipated-workplace-environment",
    "target": "usable"
  },
  {
    "source": "anticipated-workplace-environment",
    "target": "functional-appropriateness"
  },
  {
    "source": "anticipated-workplace-environment",
    "target": "expected-physical-environment"
  },
  {
    "source": "api-gateway",
    "target": "secure"
  },
  {
    "source": "api-gateway",
    "target": "operable"
  },
  {
    "source": "api-gateway",
    "target": "reliable"
  },
  {
    "source": "api-gateway",
    "target": "security"
  },
  {
    "source": "api-gateway",
    "target": "interoperability"
  },
  {
    "source": "api-gateway",
    "target": "observability"
  },
  {
    "source": "api-gateway",
    "target": "scalability"
  },
  {
    "source": "api-gateway",
    "target": "availability"
  },
  {
    "source": "api-gateway",
    "target": "modularity"
  },
  {
    "source": "appearance",
    "target": "usable"
  },
  {
    "source": "appearance",
    "target": "ease-of-use"
  },
  {
    "source": "appearance",
    "target": "learnability"
  },
  {
    "source": "appearance",
    "target": "self-descriptiveness"
  },
  {
    "source": "appearance",
    "target": "user-interface-aesthetics"
  },
  {
    "source": "appearance",
    "target": "attractiveness"
  },
  {
    "source": "appearance-requirements",
    "target": "appearance"
  },
  {
    "source": "appearance-requirements",
    "target": "usability"
  },
  {
    "source": "appearance-requirements",
    "target": "consistency"
  },
  {
    "source": "appearance-requirements",
    "target": "user-interface-aesthetics"
  },
  {
    "source": "appearance-requirements",
    "target": "interaction-capability"
  },
  {
    "source": "appropriateness-recognizability",
    "target": "usable"
  },
  {
    "source": "appropriateness-recognizability",
    "target": "operable"
  },
  {
    "source": "appropriateness-recognizability",
    "target": "usability"
  },
  {
    "source": "appropriateness-recognizability",
    "target": "attractiveness"
  },
  {
    "source": "appropriateness-recognizability",
    "target": "operability"
  },
  {
    "source": "appropriateness-recognizability",
    "target": "user-error-protection"
  },
  {
    "source": "appropriateness-recognizability",
    "target": "user-engagement"
  },
  {
    "source": "appropriateness-recognizability",
    "target": "ease-of-use"
  },
  {
    "source": "appropriateness-recognizability",
    "target": "understandability"
  },
  {
    "source": "assess-impact-of-proposed-change",
    "target": "analysability"
  },
  {
    "source": "assess-impact-of-proposed-change",
    "target": "reliability"
  },
  {
    "source": "asynchronous-messaging",
    "target": "efficient"
  },
  {
    "source": "asynchronous-messaging",
    "target": "flexible"
  },
  {
    "source": "asynchronous-messaging",
    "target": "responsiveness"
  },
  {
    "source": "asynchronous-messaging",
    "target": "throughput"
  },
  {
    "source": "asynchronous-messaging",
    "target": "scalability"
  },
  {
    "source": "asynchronous-messaging",
    "target": "loose-coupling"
  },
  {
    "source": "asynchronous-messaging",
    "target": "lead-time-for-changes"
  },
  {
    "source": "atomicity",
    "target": "reliable"
  },
  {
    "source": "atomicity",
    "target": "transactionality"
  },
  {
    "source": "atomicity",
    "target": "consistency"
  },
  {
    "source": "atomicity",
    "target": "durability"
  },
  {
    "source": "atomicity",
    "target": "data-integrity"
  },
  {
    "source": "atomicity",
    "target": "robustness"
  },
  {
    "source": "attractive-quality-knowledge-base",
    "target": "attractiveness"
  },
  {
    "source": "attractive-quality-knowledge-base",
    "target": "usability"
  },
  {
    "source": "attractive-quality-knowledge-base",
    "target": "appearance"
  },
  {
    "source": "attractive-quality-knowledge-base",
    "target": "user-interface-aesthetics"
  },
  {
    "source": "attractive-quality-knowledge-base",
    "target": "user-experience"
  },
  {
    "source": "attractiveness",
    "target": "usable"
  },
  {
    "source": "attractiveness",
    "target": "usability"
  },
  {
    "source": "attractiveness",
    "target": "clarity"
  },
  {
    "source": "attractiveness",
    "target": "user-interface-aesthetics"
  },
  {
    "source": "attractiveness",
    "target": "user-experience"
  },
  {
    "source": "attractiveness",
    "target": "user-assistance"
  },
  {
    "source": "attractiveness",
    "target": "appearance"
  },
  {
    "source": "auditability",
    "target": "operable"
  },
  {
    "source": "auditability",
    "target": "transparency"
  },
  {
    "source": "auditability",
    "target": "traceability"
  },
  {
    "source": "auditability",
    "target": "operability"
  },
  {
    "source": "auditability",
    "target": "observability"
  },
  {
    "source": "auditability",
    "target": "devops-metrics"
  },
  {
    "source": "auditability",
    "target": "accountability"
  },
  {
    "source": "auditability",
    "target": "certifiability"
  },
  {
    "source": "authenticity",
    "target": "secure"
  },
  {
    "source": "authenticity",
    "target": "integrity"
  },
  {
    "source": "authenticity",
    "target": "security"
  },
  {
    "source": "authenticity",
    "target": "non-repudiation"
  },
  {
    "source": "authenticity",
    "target": "accountability"
  },
  {
    "source": "authenticity",
    "target": "access-control"
  },
  {
    "source": "authenticity-of-digital-document",
    "target": "authenticity"
  },
  {
    "source": "authenticity-of-digital-document",
    "target": "integrity"
  },
  {
    "source": "autonomy",
    "target": "operable"
  },
  {
    "source": "autonomy",
    "target": "suitable"
  },
  {
    "source": "autonomy",
    "target": "independence"
  },
  {
    "source": "autonomy",
    "target": "self-containedness"
  },
  {
    "source": "autonomy",
    "target": "controllability"
  },
  {
    "source": "autonomy",
    "target": "composability"
  },
  {
    "source": "autonomy",
    "target": "flexibility"
  },
  {
    "source": "autonomy",
    "target": "configurability"
  },
  {
    "source": "autonomy",
    "target": "adaptability"
  },
  {
    "source": "autonomy",
    "target": "recoverability"
  },
  {
    "source": "autonomy",
    "target": "fault-tolerance"
  },
  {
    "source": "autonomy",
    "target": "resilience"
  },
  {
    "source": "availability",
    "target": "reliable"
  },
  {
    "source": "availability",
    "target": "usable"
  },
  {
    "source": "availability",
    "target": "availability"
  },
  {
    "source": "availability",
    "target": "robustness"
  },
  {
    "source": "availability",
    "target": "reliability"
  },
  {
    "source": "availability",
    "target": "usability"
  },
  {
    "source": "availability",
    "target": "fault-tolerance"
  },
  {
    "source": "availability",
    "target": "recoverability"
  },
  {
    "source": "availability",
    "target": "dependability"
  },
  {
    "source": "availability",
    "target": "faultlessness"
  },
  {
    "source": "availability",
    "target": "recoverability"
  },
  {
    "source": "availability",
    "target": "resilience"
  },
  {
    "source": "availability",
    "target": "graceful-degradation"
  },
  {
    "source": "available-7-24-99",
    "target": "availability"
  },
  {
    "source": "available-7-24-99",
    "target": "availability"
  },
  {
    "source": "available-7-24-99",
    "target": "reliability"
  },
  {
    "source": "available-7-24-99",
    "target": "operability"
  },
  {
    "source": "available-7-24-99",
    "target": "user-error-protection"
  },
  {
    "source": "available-7-24-99",
    "target": "interaction-capability"
  },
  {
    "source": "avoid-common-vulnerabilities",
    "target": "vulnerability"
  },
  {
    "source": "b-method",
    "target": "reliable"
  },
  {
    "source": "b-method",
    "target": "safe"
  },
  {
    "source": "b-method",
    "target": "provability"
  },
  {
    "source": "b-method",
    "target": "correctness"
  },
  {
    "source": "b-method",
    "target": "safety"
  },
  {
    "source": "b-method",
    "target": "reliability"
  },
  {
    "source": "b-method",
    "target": "verifiability"
  },
  {
    "source": "backends-for-frontends",
    "target": "flexible"
  },
  {
    "source": "backends-for-frontends",
    "target": "efficient"
  },
  {
    "source": "backends-for-frontends",
    "target": "evolvability"
  },
  {
    "source": "backends-for-frontends",
    "target": "autonomy"
  },
  {
    "source": "backends-for-frontends",
    "target": "loose-coupling"
  },
  {
    "source": "backends-for-frontends",
    "target": "response-time"
  },
  {
    "source": "backends-for-frontends",
    "target": "api-gateway"
  },
  {
    "source": "backends-for-frontends",
    "target": "microservice-architecture"
  },
  {
    "source": "backpressure-propagation",
    "target": "reliable"
  },
  {
    "source": "backpressure-propagation",
    "target": "stability"
  },
  {
    "source": "backpressure-propagation",
    "target": "availability"
  },
  {
    "source": "backpressure-propagation",
    "target": "latency"
  },
  {
    "source": "backpressure-propagation",
    "target": "reliability"
  },
  {
    "source": "backpressure-propagation",
    "target": "asynchronous-messaging"
  },
  {
    "source": "backpressure-propagation",
    "target": "rate-limiting"
  },
  {
    "source": "backpressure-propagation",
    "target": "limit-event-response"
  },
  {
    "source": "backup-patient-monitoring-sensor",
    "target": "safety"
  },
  {
    "source": "backup-patient-monitoring-sensor",
    "target": "efficiency"
  },
  {
    "source": "backup-patient-monitoring-sensor",
    "target": "reliability"
  },
  {
    "source": "backup-patient-monitoring-sensor",
    "target": "patient-safety"
  },
  {
    "source": "backward-compatibility",
    "target": "usable"
  },
  {
    "source": "backward-compatibility",
    "target": "operable"
  },
  {
    "source": "backward-compatibility",
    "target": "reliable"
  },
  {
    "source": "backward-compatibility",
    "target": "portability"
  },
  {
    "source": "backward-compatibility",
    "target": "flexibility"
  },
  {
    "source": "backward-compatibility",
    "target": "compatibility"
  },
  {
    "source": "backward-compatibility",
    "target": "interoperability"
  },
  {
    "source": "backward-compatibility",
    "target": "updateability"
  },
  {
    "source": "bias-mitigation",
    "target": "reliable"
  },
  {
    "source": "bias-mitigation",
    "target": "safe"
  },
  {
    "source": "bias-mitigation",
    "target": "suitable"
  },
  {
    "source": "bias-mitigation",
    "target": "fairness"
  },
  {
    "source": "bias-mitigation",
    "target": "explainability"
  },
  {
    "source": "bias-mitigation",
    "target": "transparency"
  },
  {
    "source": "bias-mitigation",
    "target": "accountability"
  },
  {
    "source": "bias-mitigation",
    "target": "safety"
  },
  {
    "source": "bias-mitigation",
    "target": "data-quality"
  },
  {
    "source": "blue-green-deployment",
    "target": "operable"
  },
  {
    "source": "blue-green-deployment",
    "target": "reliable"
  },
  {
    "source": "blue-green-deployment",
    "target": "availability"
  },
  {
    "source": "blue-green-deployment",
    "target": "deployability"
  },
  {
    "source": "blue-green-deployment",
    "target": "releasability"
  },
  {
    "source": "blue-green-deployment",
    "target": "recoverability"
  },
  {
    "source": "blue-green-deployment",
    "target": "canary-deployment"
  },
  {
    "source": "budget-constraint-library-update",
    "target": "affordability"
  },
  {
    "source": "budget-constraint-library-update",
    "target": "cost"
  },
  {
    "source": "budget-constraint-library-update",
    "target": "time-to-market"
  },
  {
    "source": "bulkheads",
    "target": "reliable"
  },
  {
    "source": "bulkheads",
    "target": "fault-tolerance"
  },
  {
    "source": "bulkheads",
    "target": "availability"
  },
  {
    "source": "bulkheads",
    "target": "resilience"
  },
  {
    "source": "bulkheads",
    "target": "stability"
  },
  {
    "source": "bulkheads",
    "target": "graceful-degradation"
  },
  {
    "source": "c3a",
    "target": "data-residency"
  },
  {
    "source": "c3a",
    "target": "data-sovereignty"
  },
  {
    "source": "c3a",
    "target": "auditability"
  },
  {
    "source": "c3a",
    "target": "autonomy"
  },
  {
    "source": "c3a",
    "target": "suitable"
  },
  {
    "source": "c3a",
    "target": "secure"
  },
  {
    "source": "c3a",
    "target": "operable"
  },
  {
    "source": "caching",
    "target": "efficient"
  },
  {
    "source": "caching",
    "target": "reliable"
  },
  {
    "source": "caching",
    "target": "performance"
  },
  {
    "source": "caching",
    "target": "scalability"
  },
  {
    "source": "caching",
    "target": "responsiveness"
  },
  {
    "source": "caching",
    "target": "content-delivery-network"
  },
  {
    "source": "calibrated-medical-triage-confidence",
    "target": "calibration"
  },
  {
    "source": "calibrated-medical-triage-confidence",
    "target": "safety"
  },
  {
    "source": "calibrated-medical-triage-confidence",
    "target": "accuracy"
  },
  {
    "source": "calibrated-medical-triage-confidence",
    "target": "reliability"
  },
  {
    "source": "calibration",
    "target": "reliable"
  },
  {
    "source": "calibration",
    "target": "suitable"
  },
  {
    "source": "calibration",
    "target": "groundedness"
  },
  {
    "source": "calibration",
    "target": "accuracy"
  },
  {
    "source": "calibration",
    "target": "precision"
  },
  {
    "source": "calibration",
    "target": "correctness"
  },
  {
    "source": "calibration",
    "target": "model-transparency"
  },
  {
    "source": "calibration",
    "target": "explainability"
  },
  {
    "source": "calibration",
    "target": "fairness"
  },
  {
    "source": "calibration",
    "target": "reliability"
  },
  {
    "source": "canary-deployment",
    "target": "operable"
  },
  {
    "source": "canary-deployment",
    "target": "reliable"
  },
  {
    "source": "canary-deployment",
    "target": "releasability"
  },
  {
    "source": "canary-deployment",
    "target": "deployability"
  },
  {
    "source": "canary-deployment",
    "target": "recoverability"
  },
  {
    "source": "canary-deployment",
    "target": "availability"
  },
  {
    "source": "capacity",
    "target": "efficient"
  },
  {
    "source": "capacity",
    "target": "reliable"
  },
  {
    "source": "capacity",
    "target": "efficiency"
  },
  {
    "source": "capacity",
    "target": "resource-efficiency"
  },
  {
    "source": "capacity",
    "target": "scalability"
  },
  {
    "source": "capacity",
    "target": "performance"
  },
  {
    "source": "capacity",
    "target": "resource-utilization"
  },
  {
    "source": "capacity-to-process-sensor-inputs",
    "target": "time-behaviour"
  },
  {
    "source": "capacity-to-process-sensor-inputs",
    "target": "speed"
  },
  {
    "source": "capacity-to-process-sensor-inputs",
    "target": "performance"
  },
  {
    "source": "capture-unresolved-business-semantics-without-structural-commitment",
    "target": "evolvability"
  },
  {
    "source": "capture-unresolved-business-semantics-without-structural-commitment",
    "target": "traceability"
  },
  {
    "source": "carbon-efficiency-save",
    "target": "efficiency"
  },
  {
    "source": "carbon-efficiency-save",
    "target": "carbon-emission-efficiency"
  },
  {
    "source": "carbon-efficiency-save",
    "target": "energy-efficiency"
  },
  {
    "source": "carbon-emission-efficiency",
    "target": "efficient"
  },
  {
    "source": "carbon-emission-efficiency",
    "target": "sustainability"
  },
  {
    "source": "carbon-emission-efficiency",
    "target": "energy-efficiency"
  },
  {
    "source": "certifiability",
    "target": "suitable"
  },
  {
    "source": "certifiability",
    "target": "reliable"
  },
  {
    "source": "certifiability",
    "target": "safe"
  },
  {
    "source": "certifiability",
    "target": "compliance"
  },
  {
    "source": "certifiability",
    "target": "testability"
  },
  {
    "source": "certifiability",
    "target": "auditability"
  },
  {
    "source": "certifiability",
    "target": "traceability"
  },
  {
    "source": "certifiability",
    "target": "verifiability"
  },
  {
    "source": "certifiability",
    "target": "safety"
  },
  {
    "source": "certifiability",
    "target": "analysability"
  },
  {
    "source": "change-cloud-provider",
    "target": "flexibility"
  },
  {
    "source": "change-cloud-provider",
    "target": "portability"
  },
  {
    "source": "change-cloud-provider",
    "target": "maintainability"
  },
  {
    "source": "change-cloud-provider",
    "target": "adaptability"
  },
  {
    "source": "change-failure-rate",
    "target": "operable"
  },
  {
    "source": "change-failure-rate",
    "target": "controllability"
  },
  {
    "source": "change-failure-rate",
    "target": "operability"
  },
  {
    "source": "change-failure-rate",
    "target": "testability"
  },
  {
    "source": "change-failure-rate",
    "target": "analysability"
  },
  {
    "source": "change-failure-rate",
    "target": "deployability"
  },
  {
    "source": "change-failure-rate",
    "target": "devops-metrics"
  },
  {
    "source": "change-failure-rate",
    "target": "reliability"
  },
  {
    "source": "changeability",
    "target": "flexible"
  },
  {
    "source": "changeability",
    "target": "maintainable"
  },
  {
    "source": "changeability",
    "target": "flexibility"
  },
  {
    "source": "changeability",
    "target": "adaptability"
  },
  {
    "source": "changeability",
    "target": "modifiability"
  },
  {
    "source": "changeability",
    "target": "configurability"
  },
  {
    "source": "changeability",
    "target": "modularity"
  },
  {
    "source": "changeability",
    "target": "evolvability"
  },
  {
    "source": "changeability",
    "target": "maintainability"
  },
  {
    "source": "circuit-breaker",
    "target": "reliable"
  },
  {
    "source": "circuit-breaker",
    "target": "operable"
  },
  {
    "source": "circuit-breaker",
    "target": "resilience"
  },
  {
    "source": "circuit-breaker",
    "target": "stability"
  },
  {
    "source": "circuit-breaker",
    "target": "fault-tolerance"
  },
  {
    "source": "circuit-breaker",
    "target": "availability"
  },
  {
    "source": "circuit-breaker",
    "target": "bulkheads"
  },
  {
    "source": "circuit-breaker-failure-transparency",
    "target": "failure-transparency"
  },
  {
    "source": "circuit-breaker-failure-transparency",
    "target": "availability"
  },
  {
    "source": "circuit-breaker-failure-transparency",
    "target": "resilience"
  },
  {
    "source": "circuit-breaker-failure-transparency",
    "target": "fault-tolerance"
  },
  {
    "source": "clarity",
    "target": "usable"
  },
  {
    "source": "clarity",
    "target": "reliable"
  },
  {
    "source": "clarity",
    "target": "coherence"
  },
  {
    "source": "clarity",
    "target": "transparency"
  },
  {
    "source": "clarity",
    "target": "understandability"
  },
  {
    "source": "clarity",
    "target": "legibility"
  },
  {
    "source": "clarity",
    "target": "communicability"
  },
  {
    "source": "clarity-in-technical-documentation",
    "target": "clarity"
  },
  {
    "source": "clarity-in-technical-documentation",
    "target": "coherence"
  },
  {
    "source": "clarity-in-technical-documentation",
    "target": "understandability"
  },
  {
    "source": "clarity-in-technical-documentation",
    "target": "legibility"
  },
  {
    "source": "co-existence",
    "target": "flexible"
  },
  {
    "source": "co-existence",
    "target": "compatibility"
  },
  {
    "source": "co-existence",
    "target": "interoperability"
  },
  {
    "source": "co-existence",
    "target": "portability"
  },
  {
    "source": "code-complexity",
    "target": "efficient"
  },
  {
    "source": "code-complexity",
    "target": "usable"
  },
  {
    "source": "code-complexity",
    "target": "understandability"
  },
  {
    "source": "code-complexity",
    "target": "legibility"
  },
  {
    "source": "code-complexity",
    "target": "clarity"
  },
  {
    "source": "code-complexity",
    "target": "conciseness"
  },
  {
    "source": "code-complexity",
    "target": "consistency"
  },
  {
    "source": "code-complexity",
    "target": "readability"
  },
  {
    "source": "code-complexity",
    "target": "maintainability"
  },
  {
    "source": "code-readability",
    "target": "usable"
  },
  {
    "source": "code-readability",
    "target": "efficient"
  },
  {
    "source": "code-readability",
    "target": "understandability"
  },
  {
    "source": "code-readability",
    "target": "legibility"
  },
  {
    "source": "code-readability",
    "target": "clarity"
  },
  {
    "source": "code-readability",
    "target": "conciseness"
  },
  {
    "source": "code-readability",
    "target": "consistency"
  },
  {
    "source": "code-readability",
    "target": "readability"
  },
  {
    "source": "coherence",
    "target": "usable"
  },
  {
    "source": "coherence",
    "target": "maintainable"
  },
  {
    "source": "coherence",
    "target": "consistency"
  },
  {
    "source": "coherence",
    "target": "cohesion"
  },
  {
    "source": "coherence",
    "target": "simplicity"
  },
  {
    "source": "coherence",
    "target": "understandability"
  },
  {
    "source": "coherence",
    "target": "clarity"
  },
  {
    "source": "cohesion",
    "target": "efficient"
  },
  {
    "source": "cohesion",
    "target": "suitable"
  },
  {
    "source": "cohesion",
    "target": "maintainable"
  },
  {
    "source": "cohesion",
    "target": "coherence"
  },
  {
    "source": "cohesion",
    "target": "modularity"
  },
  {
    "source": "cohesion",
    "target": "loose-coupling"
  },
  {
    "source": "communicability",
    "target": "usable"
  },
  {
    "source": "communicability",
    "target": "usability"
  },
  {
    "source": "communicability",
    "target": "learnability"
  },
  {
    "source": "communicability",
    "target": "understandability"
  },
  {
    "source": "communicability",
    "target": "user-error-protection"
  },
  {
    "source": "communicability",
    "target": "ease-of-use"
  },
  {
    "source": "compatibility",
    "target": "usable"
  },
  {
    "source": "compatibility",
    "target": "operable"
  },
  {
    "source": "compatibility",
    "target": "reliable"
  },
  {
    "source": "compatibility",
    "target": "portability"
  },
  {
    "source": "compatibility",
    "target": "flexibility"
  },
  {
    "source": "compatibility",
    "target": "backward-compatibility"
  },
  {
    "source": "compatible-with-5-battery-providers",
    "target": "flexibility"
  },
  {
    "source": "compatible-with-5-battery-providers",
    "target": "adaptability"
  },
  {
    "source": "compatible-with-5-battery-providers",
    "target": "interoperability"
  },
  {
    "source": "compatible-with-5-battery-providers",
    "target": "compatibility"
  },
  {
    "source": "completeness",
    "target": "reliable"
  },
  {
    "source": "completeness",
    "target": "suitable"
  },
  {
    "source": "completeness",
    "target": "data-quality"
  },
  {
    "source": "completeness",
    "target": "accuracy"
  },
  {
    "source": "completeness",
    "target": "consistency"
  },
  {
    "source": "completeness",
    "target": "integrity"
  },
  {
    "source": "completeness",
    "target": "correctness"
  },
  {
    "source": "compliance",
    "target": "secure"
  },
  {
    "source": "compliance",
    "target": "safe"
  },
  {
    "source": "compliance",
    "target": "usable"
  },
  {
    "source": "compliance",
    "target": "reliable"
  },
  {
    "source": "compliance",
    "target": "efficient"
  },
  {
    "source": "compliance",
    "target": "suitable"
  },
  {
    "source": "compliance",
    "target": "security"
  },
  {
    "source": "compliance",
    "target": "safety"
  },
  {
    "source": "compliance",
    "target": "usability"
  },
  {
    "source": "compliance",
    "target": "reliability"
  },
  {
    "source": "compliance",
    "target": "efficiency"
  },
  {
    "source": "compliance",
    "target": "testability"
  },
  {
    "source": "compliance",
    "target": "auditability"
  },
  {
    "source": "compliance",
    "target": "traceability"
  },
  {
    "source": "compliance",
    "target": "accountability"
  },
  {
    "source": "compliance",
    "target": "certifiability"
  },
  {
    "source": "compliance-to-wcag",
    "target": "accessibility"
  },
  {
    "source": "compliance-to-wcag",
    "target": "user-experience"
  },
  {
    "source": "compliance-to-wcag",
    "target": "user-assistance"
  },
  {
    "source": "compliance-to-wcag",
    "target": "interaction-capability"
  },
  {
    "source": "compliance-with-ui-styleguide",
    "target": "usability"
  },
  {
    "source": "compliance-with-ui-styleguide",
    "target": "user-experience"
  },
  {
    "source": "compliance-with-ui-styleguide",
    "target": "compliance"
  },
  {
    "source": "compliance-with-ui-styleguide",
    "target": "interaction-capability"
  },
  {
    "source": "composability",
    "target": "flexible"
  },
  {
    "source": "composability",
    "target": "modularity"
  },
  {
    "source": "composability",
    "target": "autonomy"
  },
  {
    "source": "composability",
    "target": "reusability"
  },
  {
    "source": "composability",
    "target": "interoperability"
  },
  {
    "source": "composability",
    "target": "loose-coupling"
  },
  {
    "source": "computational-overhead-reduction",
    "target": "efficient"
  },
  {
    "source": "computational-overhead-reduction",
    "target": "latency"
  },
  {
    "source": "computational-overhead-reduction",
    "target": "throughput"
  },
  {
    "source": "computational-overhead-reduction",
    "target": "resource-efficiency"
  },
  {
    "source": "computational-overhead-reduction",
    "target": "energy-efficiency"
  },
  {
    "source": "computational-overhead-reduction",
    "target": "caching"
  },
  {
    "source": "computational-overhead-reduction",
    "target": "limit-event-response"
  },
  {
    "source": "conciseness",
    "target": "usable"
  },
  {
    "source": "conciseness",
    "target": "efficient"
  },
  {
    "source": "conciseness",
    "target": "understandability"
  },
  {
    "source": "conciseness",
    "target": "clarity"
  },
  {
    "source": "conciseness",
    "target": "coherence"
  },
  {
    "source": "confidentiality",
    "target": "secure"
  },
  {
    "source": "confidentiality",
    "target": "integrity"
  },
  {
    "source": "confidentiality",
    "target": "accountability"
  },
  {
    "source": "confidentiality",
    "target": "privacy"
  },
  {
    "source": "confidentiality",
    "target": "access-control"
  },
  {
    "source": "confidentiality",
    "target": "authenticity"
  },
  {
    "source": "confidentiality-by-multitenance",
    "target": "confidentiality"
  },
  {
    "source": "confidentiality-by-multitenance",
    "target": "security"
  },
  {
    "source": "confidentiality-by-multitenance",
    "target": "privacy"
  },
  {
    "source": "configurability",
    "target": "flexible"
  },
  {
    "source": "configurability",
    "target": "usable"
  },
  {
    "source": "configurability",
    "target": "flexibility"
  },
  {
    "source": "configurability",
    "target": "changeability"
  },
  {
    "source": "configurability",
    "target": "adaptability"
  },
  {
    "source": "configurability",
    "target": "modifiability"
  },
  {
    "source": "configurability",
    "target": "versatility"
  },
  {
    "source": "configurability",
    "target": "customizability"
  },
  {
    "source": "configurable-ui-theme",
    "target": "flexibility"
  },
  {
    "source": "configurable-ui-theme",
    "target": "changeability"
  },
  {
    "source": "configurable-ui-theme",
    "target": "adaptability"
  },
  {
    "source": "configurable-ui-theme",
    "target": "configurability"
  },
  {
    "source": "configurable-ui-theme",
    "target": "customizability"
  },
  {
    "source": "configurable-ui-theme",
    "target": "themability"
  },
  {
    "source": "consent-management",
    "target": "secure"
  },
  {
    "source": "consent-management",
    "target": "usable"
  },
  {
    "source": "consent-management",
    "target": "privacy"
  },
  {
    "source": "consent-management",
    "target": "data-protection"
  },
  {
    "source": "consent-management",
    "target": "compliance"
  },
  {
    "source": "consent-management",
    "target": "transparency"
  },
  {
    "source": "consent-management",
    "target": "accountability"
  },
  {
    "source": "consistency",
    "target": "usable"
  },
  {
    "source": "consistency",
    "target": "efficient"
  },
  {
    "source": "consistency",
    "target": "determinism"
  },
  {
    "source": "consistency",
    "target": "atomicity"
  },
  {
    "source": "consistency",
    "target": "durability"
  },
  {
    "source": "consistency",
    "target": "transactionality"
  },
  {
    "source": "consistency",
    "target": "understandability"
  },
  {
    "source": "consistency",
    "target": "coherence"
  },
  {
    "source": "consistent-keyboard-shortcuts",
    "target": "usability"
  },
  {
    "source": "consistent-keyboard-shortcuts",
    "target": "consistency"
  },
  {
    "source": "consistent-keyboard-shortcuts",
    "target": "user-experience"
  },
  {
    "source": "consistent-keyboard-shortcuts",
    "target": "user-assistance"
  },
  {
    "source": "consistent-keyboard-shortcuts",
    "target": "interaction-capability"
  },
  {
    "source": "consumer-driven-contracts",
    "target": "flexible"
  },
  {
    "source": "consumer-driven-contracts",
    "target": "reliable"
  },
  {
    "source": "consumer-driven-contracts",
    "target": "maintainable"
  },
  {
    "source": "consumer-driven-contracts",
    "target": "backward-compatibility"
  },
  {
    "source": "consumer-driven-contracts",
    "target": "testability"
  },
  {
    "source": "consumer-driven-contracts",
    "target": "interoperability"
  },
  {
    "source": "consumer-driven-contracts",
    "target": "evolvability"
  },
  {
    "source": "consumer-driven-contracts",
    "target": "tolerant-reader"
  },
  {
    "source": "consumer-driven-contracts",
    "target": "open-host-service"
  },
  {
    "source": "content-delivery-network",
    "target": "efficient"
  },
  {
    "source": "content-delivery-network",
    "target": "operable"
  },
  {
    "source": "content-delivery-network",
    "target": "latency"
  },
  {
    "source": "content-delivery-network",
    "target": "response-time"
  },
  {
    "source": "content-delivery-network",
    "target": "throughput"
  },
  {
    "source": "content-delivery-network",
    "target": "availability"
  },
  {
    "source": "content-delivery-network",
    "target": "scalability"
  },
  {
    "source": "content-moderation-fairness",
    "target": "fairness"
  },
  {
    "source": "content-moderation-fairness",
    "target": "bias-mitigation"
  },
  {
    "source": "content-moderation-fairness",
    "target": "transparency"
  },
  {
    "source": "content-moderation-fairness",
    "target": "accountability"
  },
  {
    "source": "controllability",
    "target": "usable"
  },
  {
    "source": "controllability",
    "target": "operable"
  },
  {
    "source": "controllability",
    "target": "usability"
  },
  {
    "source": "controllability",
    "target": "autonomy"
  },
  {
    "source": "controllability",
    "target": "operability"
  },
  {
    "source": "controllability",
    "target": "interaction-capability"
  },
  {
    "source": "controllability",
    "target": "governability"
  },
  {
    "source": "controllability",
    "target": "intervenability"
  },
  {
    "source": "controllability",
    "target": "auditability"
  },
  {
    "source": "convenience",
    "target": "usable"
  },
  {
    "source": "convenience",
    "target": "usability"
  },
  {
    "source": "convenience",
    "target": "ease-of-use"
  },
  {
    "source": "convenience",
    "target": "user-assistance"
  },
  {
    "source": "convenient-online-banking",
    "target": "user-experience"
  },
  {
    "source": "convenient-online-banking",
    "target": "convenience"
  },
  {
    "source": "convenient-online-banking",
    "target": "interaction-capability"
  },
  {
    "source": "convenient-online-banking",
    "target": "clarity"
  },
  {
    "source": "convenient-online-banking",
    "target": "ease-of-use"
  },
  {
    "source": "core-functions-on-mac-win-linux",
    "target": "flexibility"
  },
  {
    "source": "core-functions-on-mac-win-linux",
    "target": "portability"
  },
  {
    "source": "core-functions-on-mac-win-linux",
    "target": "compatibility"
  },
  {
    "source": "core-functions-on-mac-win-linux",
    "target": "interaction-capability"
  },
  {
    "source": "correctness",
    "target": "usable"
  },
  {
    "source": "correctness",
    "target": "reliable"
  },
  {
    "source": "correctness",
    "target": "suitable"
  },
  {
    "source": "correctness",
    "target": "usability"
  },
  {
    "source": "correctness",
    "target": "functionality"
  },
  {
    "source": "correctness",
    "target": "functional-suitability"
  },
  {
    "source": "correctness",
    "target": "correctness"
  },
  {
    "source": "correctness",
    "target": "accuracy"
  },
  {
    "source": "correctness",
    "target": "precision"
  },
  {
    "source": "correctness",
    "target": "functional-appropriateness"
  },
  {
    "source": "cost",
    "target": "suitable"
  },
  {
    "source": "cost",
    "target": "efficient"
  },
  {
    "source": "cost",
    "target": "affordability"
  },
  {
    "source": "cost",
    "target": "profitability"
  },
  {
    "source": "cqrs",
    "target": "efficient"
  },
  {
    "source": "cqrs",
    "target": "flexible"
  },
  {
    "source": "cqrs",
    "target": "scalability"
  },
  {
    "source": "cqrs",
    "target": "throughput"
  },
  {
    "source": "cqrs",
    "target": "performance"
  },
  {
    "source": "cqrs",
    "target": "extensibility"
  },
  {
    "source": "cqrs",
    "target": "responsiveness"
  },
  {
    "source": "cqrs",
    "target": "event-sourcing"
  },
  {
    "source": "cra",
    "target": "compliance"
  },
  {
    "source": "cra",
    "target": "confidentiality"
  },
  {
    "source": "cra",
    "target": "dependability"
  },
  {
    "source": "cra",
    "target": "integrity"
  },
  {
    "source": "cra",
    "target": "interoperability"
  },
  {
    "source": "cra",
    "target": "maintainability"
  },
  {
    "source": "cra",
    "target": "modularity"
  },
  {
    "source": "cra",
    "target": "observability"
  },
  {
    "source": "cra",
    "target": "recoverability"
  },
  {
    "source": "cra",
    "target": "reliability"
  },
  {
    "source": "cra",
    "target": "resilience"
  },
  {
    "source": "cra",
    "target": "risk-identification"
  },
  {
    "source": "cra",
    "target": "traceability"
  },
  {
    "source": "cra",
    "target": "transparency"
  },
  {
    "source": "cra",
    "target": "securability"
  },
  {
    "source": "cra",
    "target": "security"
  },
  {
    "source": "cra",
    "target": "updateability"
  },
  {
    "source": "cra",
    "target": "upgradeability"
  },
  {
    "source": "cra",
    "target": "accountability"
  },
  {
    "source": "cra",
    "target": "auditability"
  },
  {
    "source": "cra",
    "target": "authenticity"
  },
  {
    "source": "cra",
    "target": "availability"
  },
  {
    "source": "cra",
    "target": "secure"
  },
  {
    "source": "cra",
    "target": "safe"
  },
  {
    "source": "cra",
    "target": "usable"
  },
  {
    "source": "cra",
    "target": "reliable"
  },
  {
    "source": "cra",
    "target": "efficient"
  },
  {
    "source": "cra",
    "target": "suitable"
  },
  {
    "source": "cra",
    "target": "operable"
  },
  {
    "source": "cra",
    "target": "maintainable"
  },
  {
    "source": "credibility",
    "target": "reliable"
  },
  {
    "source": "credibility",
    "target": "accountability"
  },
  {
    "source": "credibility",
    "target": "usability"
  },
  {
    "source": "credibility",
    "target": "user-engagement"
  },
  {
    "source": "credit-scoring-fairness",
    "target": "fairness"
  },
  {
    "source": "credit-scoring-fairness",
    "target": "bias-mitigation"
  },
  {
    "source": "credit-scoring-fairness",
    "target": "transparency"
  },
  {
    "source": "credit-scoring-fairness",
    "target": "accountability"
  },
  {
    "source": "crm-data-synchronization",
    "target": "integrability"
  },
  {
    "source": "crm-data-synchronization",
    "target": "interoperability"
  },
  {
    "source": "crm-data-synchronization",
    "target": "data-quality"
  },
  {
    "source": "crm-data-synchronization",
    "target": "consistency"
  },
  {
    "source": "cultural-sensitivity-in-content",
    "target": "usability"
  },
  {
    "source": "cultural-sensitivity-in-content",
    "target": "inclusivity"
  },
  {
    "source": "cultural-sensitivity-in-content",
    "target": "internationalization"
  },
  {
    "source": "cultural-sensitivity-in-content",
    "target": "internationalization"
  },
  {
    "source": "cultural-sensitivity-in-content",
    "target": "interaction-capability"
  },
  {
    "source": "customizability",
    "target": "flexible"
  },
  {
    "source": "customizability",
    "target": "usable"
  },
  {
    "source": "customizability",
    "target": "configurability"
  },
  {
    "source": "customizability",
    "target": "flexibility"
  },
  {
    "source": "customizability",
    "target": "adaptability"
  },
  {
    "source": "customizability",
    "target": "changeability"
  },
  {
    "source": "customizability",
    "target": "themability"
  },
  {
    "source": "cyber-security",
    "target": "secure"
  },
  {
    "source": "cyber-security",
    "target": "security"
  },
  {
    "source": "cyber-security",
    "target": "security"
  },
  {
    "source": "cyber-security",
    "target": "authenticity"
  },
  {
    "source": "cyber-security",
    "target": "confidentiality"
  },
  {
    "source": "cycle-time",
    "target": "operable"
  },
  {
    "source": "cycle-time",
    "target": "suitable"
  },
  {
    "source": "cycle-time",
    "target": "efficient"
  },
  {
    "source": "cycle-time",
    "target": "controllability"
  },
  {
    "source": "cycle-time",
    "target": "testability"
  },
  {
    "source": "cycle-time",
    "target": "deployability"
  },
  {
    "source": "cycle-time",
    "target": "devops-metrics"
  },
  {
    "source": "cycle-time",
    "target": "lead-time-for-changes"
  },
  {
    "source": "data-integrity",
    "target": "reliable"
  },
  {
    "source": "data-integrity",
    "target": "secure"
  },
  {
    "source": "data-integrity",
    "target": "integrity"
  },
  {
    "source": "data-integrity",
    "target": "data-quality"
  },
  {
    "source": "data-integrity",
    "target": "accuracy"
  },
  {
    "source": "data-integrity",
    "target": "correctness"
  },
  {
    "source": "data-integrity",
    "target": "consistency"
  },
  {
    "source": "data-integrity",
    "target": "authenticity"
  },
  {
    "source": "data-integrity",
    "target": "non-repudiation"
  },
  {
    "source": "data-integrity",
    "target": "transactionality"
  },
  {
    "source": "data-localization",
    "target": "suitable"
  },
  {
    "source": "data-localization",
    "target": "secure"
  },
  {
    "source": "data-localization",
    "target": "data-sovereignty"
  },
  {
    "source": "data-localization",
    "target": "data-residency"
  },
  {
    "source": "data-localization",
    "target": "compliance"
  },
  {
    "source": "data-localization",
    "target": "privacy"
  },
  {
    "source": "data-localization-for-citizen-records",
    "target": "data-localization"
  },
  {
    "source": "data-localization-for-citizen-records",
    "target": "data-sovereignty"
  },
  {
    "source": "data-localization-for-citizen-records",
    "target": "compliance"
  },
  {
    "source": "data-localization-for-citizen-records",
    "target": "privacy"
  },
  {
    "source": "data-localization-for-citizen-records",
    "target": "data-residency"
  },
  {
    "source": "data-minimization",
    "target": "secure"
  },
  {
    "source": "data-minimization",
    "target": "privacy"
  },
  {
    "source": "data-minimization",
    "target": "data-protection"
  },
  {
    "source": "data-minimization",
    "target": "compliance"
  },
  {
    "source": "data-minimization",
    "target": "data-quality"
  },
  {
    "source": "data-protection",
    "target": "secure"
  },
  {
    "source": "data-protection",
    "target": "privacy"
  },
  {
    "source": "data-protection",
    "target": "security"
  },
  {
    "source": "data-protection",
    "target": "compliance"
  },
  {
    "source": "data-protection",
    "target": "data-integrity"
  },
  {
    "source": "data-protection",
    "target": "data-sovereignty"
  },
  {
    "source": "data-quality",
    "target": "reliable"
  },
  {
    "source": "data-quality",
    "target": "suitable"
  },
  {
    "source": "data-quality",
    "target": "usable"
  },
  {
    "source": "data-quality",
    "target": "accuracy"
  },
  {
    "source": "data-quality",
    "target": "correctness"
  },
  {
    "source": "data-quality",
    "target": "precision"
  },
  {
    "source": "data-quality",
    "target": "integrity"
  },
  {
    "source": "data-quality",
    "target": "consistency"
  },
  {
    "source": "data-quality",
    "target": "data-integrity"
  },
  {
    "source": "data-replication",
    "target": "reliable"
  },
  {
    "source": "data-replication",
    "target": "efficient"
  },
  {
    "source": "data-replication",
    "target": "availability"
  },
  {
    "source": "data-replication",
    "target": "durability"
  },
  {
    "source": "data-replication",
    "target": "scalability"
  },
  {
    "source": "data-replication",
    "target": "n-version-redundancy"
  },
  {
    "source": "data-residency",
    "target": "suitable"
  },
  {
    "source": "data-residency",
    "target": "data-sovereignty"
  },
  {
    "source": "data-residency",
    "target": "data-localization"
  },
  {
    "source": "data-residency",
    "target": "compliance"
  },
  {
    "source": "data-residency",
    "target": "privacy"
  },
  {
    "source": "data-sovereignty",
    "target": "secure"
  },
  {
    "source": "data-sovereignty",
    "target": "suitable"
  },
  {
    "source": "data-sovereignty",
    "target": "privacy"
  },
  {
    "source": "data-sovereignty",
    "target": "security"
  },
  {
    "source": "data-sovereignty",
    "target": "compliance"
  },
  {
    "source": "data-sovereignty",
    "target": "data-protection"
  },
  {
    "source": "data-sovereignty",
    "target": "data-residency"
  },
  {
    "source": "data-sovereignty",
    "target": "data-localization"
  },
  {
    "source": "data-throughput-for-visual-test-system",
    "target": "throughput"
  },
  {
    "source": "data-throughput-for-visual-test-system",
    "target": "efficiency"
  },
  {
    "source": "data-throughput-for-visual-test-system",
    "target": "performance"
  },
  {
    "source": "data-throughput-for-visual-test-system",
    "target": "capacity"
  },
  {
    "source": "database-sharding",
    "target": "efficient"
  },
  {
    "source": "database-sharding",
    "target": "reliable"
  },
  {
    "source": "database-sharding",
    "target": "scalability"
  },
  {
    "source": "database-sharding",
    "target": "capacity"
  },
  {
    "source": "database-sharding",
    "target": "throughput"
  },
  {
    "source": "database-sharding",
    "target": "availability"
  },
  {
    "source": "database-sharding",
    "target": "distributability"
  },
  {
    "source": "dead-mans-switch",
    "target": "safe"
  },
  {
    "source": "dead-mans-switch",
    "target": "operable"
  },
  {
    "source": "dead-mans-switch",
    "target": "safety"
  },
  {
    "source": "dead-mans-switch",
    "target": "fail-safe"
  },
  {
    "source": "dead-mans-switch",
    "target": "controllability"
  },
  {
    "source": "dead-mans-switch",
    "target": "user-error-protection"
  },
  {
    "source": "dead-mans-switch",
    "target": "recoverability"
  },
  {
    "source": "dead-mans-switch",
    "target": "watchdog-supervision"
  },
  {
    "source": "dead-mans-switch",
    "target": "fail-safe-defaults"
  },
  {
    "source": "dead-mans-switch",
    "target": "safety-interlocks"
  },
  {
    "source": "debuggability",
    "target": "operable"
  },
  {
    "source": "debuggability",
    "target": "maintainable"
  },
  {
    "source": "debuggability",
    "target": "analysability"
  },
  {
    "source": "debuggability",
    "target": "maintainability"
  },
  {
    "source": "debuggability",
    "target": "operability"
  },
  {
    "source": "debuggability",
    "target": "observability"
  },
  {
    "source": "debuggability",
    "target": "testability"
  },
  {
    "source": "debuggability",
    "target": "transparency"
  },
  {
    "source": "defer-binding",
    "target": "flexible"
  },
  {
    "source": "defer-binding",
    "target": "maintainable"
  },
  {
    "source": "defer-binding",
    "target": "configurability"
  },
  {
    "source": "defer-binding",
    "target": "adaptability"
  },
  {
    "source": "defer-binding",
    "target": "evolvability"
  },
  {
    "source": "defer-binding",
    "target": "portability"
  },
  {
    "source": "defer-binding",
    "target": "reduce-coupling"
  },
  {
    "source": "dependability",
    "target": "reliable"
  },
  {
    "source": "dependability",
    "target": "availability"
  },
  {
    "source": "dependability",
    "target": "robustness"
  },
  {
    "source": "dependability",
    "target": "fault-tolerance"
  },
  {
    "source": "dependability",
    "target": "reliability"
  },
  {
    "source": "deploy-to-production-within-15-minutes",
    "target": "deployability"
  },
  {
    "source": "deploy-to-production-within-15-minutes",
    "target": "releasability"
  },
  {
    "source": "deploy-to-production-within-15-minutes",
    "target": "testability"
  },
  {
    "source": "deployability",
    "target": "operable"
  },
  {
    "source": "deployability",
    "target": "suitable"
  },
  {
    "source": "deployability",
    "target": "releasability"
  },
  {
    "source": "deployability",
    "target": "operability"
  },
  {
    "source": "deployability",
    "target": "testability"
  },
  {
    "source": "deployability",
    "target": "analysability"
  },
  {
    "source": "deployability",
    "target": "devops-metrics"
  },
  {
    "source": "deployment-frequency",
    "target": "operable"
  },
  {
    "source": "deployment-frequency",
    "target": "suitable"
  },
  {
    "source": "deployment-frequency",
    "target": "controllability"
  },
  {
    "source": "deployment-frequency",
    "target": "operability"
  },
  {
    "source": "deployment-frequency",
    "target": "testability"
  },
  {
    "source": "deployment-frequency",
    "target": "analysability"
  },
  {
    "source": "deployment-frequency",
    "target": "deployability"
  },
  {
    "source": "deployment-frequency",
    "target": "devops-metrics"
  },
  {
    "source": "deployment-frequency",
    "target": "releasability"
  },
  {
    "source": "detailed-audit-log",
    "target": "accountability"
  },
  {
    "source": "detect-inconsistent-user-input",
    "target": "usability"
  },
  {
    "source": "detect-inconsistent-user-input",
    "target": "consistency"
  },
  {
    "source": "detect-inconsistent-user-input",
    "target": "user-experience"
  },
  {
    "source": "detect-inconsistent-user-input",
    "target": "user-assistance"
  },
  {
    "source": "detect-inconsistent-user-input",
    "target": "interaction-capability"
  },
  {
    "source": "determinism",
    "target": "reliable"
  },
  {
    "source": "determinism",
    "target": "efficient"
  },
  {
    "source": "determinism",
    "target": "reproducibility"
  },
  {
    "source": "determinism",
    "target": "consistency"
  },
  {
    "source": "determinism",
    "target": "testability"
  },
  {
    "source": "determinism",
    "target": "reliability"
  },
  {
    "source": "determinism",
    "target": "time-behaviour"
  },
  {
    "source": "determinism",
    "target": "transactionality"
  },
  {
    "source": "determinism",
    "target": "explainability"
  },
  {
    "source": "deterministic-behavior-for-medical-imaging",
    "target": "determinism"
  },
  {
    "source": "deterministic-behavior-for-medical-imaging",
    "target": "explainability"
  },
  {
    "source": "deterministic-behavior-for-medical-imaging",
    "target": "reproducibility"
  },
  {
    "source": "devops-metrics",
    "target": "operable"
  },
  {
    "source": "devops-metrics",
    "target": "controllability"
  },
  {
    "source": "devops-metrics",
    "target": "operability"
  },
  {
    "source": "devops-metrics",
    "target": "testability"
  },
  {
    "source": "devops-metrics",
    "target": "analysability"
  },
  {
    "source": "devops-metrics",
    "target": "deployability"
  },
  {
    "source": "diagnosability",
    "target": "operable"
  },
  {
    "source": "diagnosability",
    "target": "reliable"
  },
  {
    "source": "diagnosability",
    "target": "analysability"
  },
  {
    "source": "diagnosability",
    "target": "debuggability"
  },
  {
    "source": "diagnosability",
    "target": "observability"
  },
  {
    "source": "diagnosability",
    "target": "recoverability"
  },
  {
    "source": "diagnosability",
    "target": "fault-tolerance"
  },
  {
    "source": "dicom",
    "target": "compatibility"
  },
  {
    "source": "dicom",
    "target": "confidentiality"
  },
  {
    "source": "dicom",
    "target": "data-integrity"
  },
  {
    "source": "dicom",
    "target": "data-quality"
  },
  {
    "source": "dicom",
    "target": "flexibility"
  },
  {
    "source": "dicom",
    "target": "extensibility"
  },
  {
    "source": "dicom",
    "target": "integrity"
  },
  {
    "source": "dicom",
    "target": "interoperability"
  },
  {
    "source": "dicom",
    "target": "maintainability"
  },
  {
    "source": "dicom",
    "target": "performance"
  },
  {
    "source": "dicom",
    "target": "portability"
  },
  {
    "source": "dicom",
    "target": "reliability"
  },
  {
    "source": "dicom",
    "target": "traceability"
  },
  {
    "source": "dicom",
    "target": "scalability"
  },
  {
    "source": "dicom",
    "target": "security"
  },
  {
    "source": "dicom",
    "target": "auditability"
  },
  {
    "source": "dicom",
    "target": "availability"
  },
  {
    "source": "dicom",
    "target": "usable"
  },
  {
    "source": "dicom",
    "target": "operable"
  },
  {
    "source": "dicom",
    "target": "reliable"
  },
  {
    "source": "dicom",
    "target": "secure"
  },
  {
    "source": "dicom",
    "target": "suitable"
  },
  {
    "source": "dicom",
    "target": "flexible"
  },
  {
    "source": "dicom",
    "target": "maintainable"
  },
  {
    "source": "dicom",
    "target": "efficient"
  },
  {
    "source": "discoverability",
    "target": "usable"
  },
  {
    "source": "discoverability",
    "target": "learnability"
  },
  {
    "source": "discoverability",
    "target": "usability"
  },
  {
    "source": "discoverability",
    "target": "intuitiveness"
  },
  {
    "source": "display-data-based-on-context",
    "target": "adaptability"
  },
  {
    "source": "display-data-based-on-context",
    "target": "functional-appropriateness"
  },
  {
    "source": "distributability",
    "target": "flexible"
  },
  {
    "source": "distributability",
    "target": "efficient"
  },
  {
    "source": "distributability",
    "target": "scalability"
  },
  {
    "source": "distributability",
    "target": "deployability"
  },
  {
    "source": "distributability",
    "target": "modularity"
  },
  {
    "source": "distributability",
    "target": "portability"
  },
  {
    "source": "distributability",
    "target": "elasticity"
  },
  {
    "source": "distributability",
    "target": "performance"
  },
  {
    "source": "do178c",
    "target": "certifiability"
  },
  {
    "source": "do178c",
    "target": "compliance"
  },
  {
    "source": "do178c",
    "target": "fault-isolation"
  },
  {
    "source": "do178c",
    "target": "integrity"
  },
  {
    "source": "do178c",
    "target": "maintainability"
  },
  {
    "source": "do178c",
    "target": "modularity"
  },
  {
    "source": "do178c",
    "target": "reliability"
  },
  {
    "source": "do178c",
    "target": "reproducibility"
  },
  {
    "source": "do178c",
    "target": "robustness"
  },
  {
    "source": "do178c",
    "target": "testability"
  },
  {
    "source": "do178c",
    "target": "traceability"
  },
  {
    "source": "do178c",
    "target": "safety"
  },
  {
    "source": "do178c",
    "target": "security"
  },
  {
    "source": "do178c",
    "target": "verifiability"
  },
  {
    "source": "do178c",
    "target": "auditability"
  },
  {
    "source": "do178c",
    "target": "suitable"
  },
  {
    "source": "do178c",
    "target": "reliable"
  },
  {
    "source": "do178c",
    "target": "safe"
  },
  {
    "source": "do178c",
    "target": "secure"
  },
  {
    "source": "do178c",
    "target": "usable"
  },
  {
    "source": "do178c",
    "target": "efficient"
  },
  {
    "source": "do178c",
    "target": "maintainable"
  },
  {
    "source": "do178c",
    "target": "operable"
  },
  {
    "source": "drift-detectability",
    "target": "reliable"
  },
  {
    "source": "drift-detectability",
    "target": "operable"
  },
  {
    "source": "drift-detectability",
    "target": "observability"
  },
  {
    "source": "drift-detectability",
    "target": "diagnosability"
  },
  {
    "source": "drift-detectability",
    "target": "reliability"
  },
  {
    "source": "drift-detectability",
    "target": "robustness"
  },
  {
    "source": "drift-detectability",
    "target": "data-quality"
  },
  {
    "source": "drift-detectability",
    "target": "model-transparency"
  },
  {
    "source": "drift-detectability",
    "target": "traceability"
  },
  {
    "source": "drift-detectability",
    "target": "fairness"
  },
  {
    "source": "drift-detectability",
    "target": "bias-mitigation"
  },
  {
    "source": "durability",
    "target": "reliable"
  },
  {
    "source": "durability",
    "target": "atomicity"
  },
  {
    "source": "durability",
    "target": "consistency"
  },
  {
    "source": "durability",
    "target": "transactionality"
  },
  {
    "source": "durability",
    "target": "reliability"
  },
  {
    "source": "durability",
    "target": "availability"
  },
  {
    "source": "durability",
    "target": "robustness"
  },
  {
    "source": "durability",
    "target": "data-integrity"
  },
  {
    "source": "ease-of-use",
    "target": "operable"
  },
  {
    "source": "ease-of-use",
    "target": "usable"
  },
  {
    "source": "ease-of-use",
    "target": "attractiveness"
  },
  {
    "source": "ease-of-use",
    "target": "operability"
  },
  {
    "source": "ease-of-use",
    "target": "user-error-protection"
  },
  {
    "source": "ease-of-use",
    "target": "user-engagement"
  },
  {
    "source": "ease-of-use",
    "target": "user-experience"
  },
  {
    "source": "ease-of-use",
    "target": "user-interface-aesthetics"
  },
  {
    "source": "ease-of-use",
    "target": "user-assistance"
  },
  {
    "source": "ease-of-use",
    "target": "usability"
  },
  {
    "source": "easy-ui",
    "target": "ease-of-use"
  },
  {
    "source": "easy-ui",
    "target": "user-experience"
  },
  {
    "source": "easy-ui",
    "target": "usability"
  },
  {
    "source": "easy-ui",
    "target": "interaction-capability"
  },
  {
    "source": "effectiveness",
    "target": "usable"
  },
  {
    "source": "effectiveness",
    "target": "suitable"
  },
  {
    "source": "effectiveness",
    "target": "usability"
  },
  {
    "source": "effectiveness",
    "target": "functional-suitability"
  },
  {
    "source": "effectiveness",
    "target": "efficiency"
  },
  {
    "source": "efficiency",
    "target": "efficient"
  },
  {
    "source": "efficiency",
    "target": "performance"
  },
  {
    "source": "efficiency",
    "target": "effectiveness"
  },
  {
    "source": "efficient",
    "target": "quality-root"
  },
  {
    "source": "efficient-generation-of-test-data",
    "target": "efficiency"
  },
  {
    "source": "efficient-generation-of-test-data",
    "target": "time-behaviour"
  },
  {
    "source": "efficient-generation-of-test-data",
    "target": "capacity"
  },
  {
    "source": "efficient-save-function",
    "target": "efficiency"
  },
  {
    "source": "efficient-save-function",
    "target": "time-behaviour"
  },
  {
    "source": "efficient-save-function",
    "target": "capacity"
  },
  {
    "source": "elasticity",
    "target": "flexible"
  },
  {
    "source": "elasticity",
    "target": "adaptability"
  },
  {
    "source": "elasticity",
    "target": "scalability"
  },
  {
    "source": "elasticity",
    "target": "flexibility"
  },
  {
    "source": "employee-attempts-to-modify-pay-rate",
    "target": "security"
  },
  {
    "source": "employee-attempts-to-modify-pay-rate",
    "target": "privacy"
  },
  {
    "source": "employee-attempts-to-modify-pay-rate",
    "target": "traceability"
  },
  {
    "source": "employee-attempts-to-modify-pay-rate",
    "target": "integrity"
  },
  {
    "source": "en301549",
    "target": "compliance"
  },
  {
    "source": "en301549",
    "target": "consistency"
  },
  {
    "source": "en301549",
    "target": "flexibility"
  },
  {
    "source": "en301549",
    "target": "inclusivity"
  },
  {
    "source": "en301549",
    "target": "interaction-capability"
  },
  {
    "source": "en301549",
    "target": "interoperability"
  },
  {
    "source": "en301549",
    "target": "operability"
  },
  {
    "source": "en301549",
    "target": "robustness"
  },
  {
    "source": "en301549",
    "target": "understandability"
  },
  {
    "source": "en301549",
    "target": "usability"
  },
  {
    "source": "en301549",
    "target": "user-error-protection"
  },
  {
    "source": "en301549",
    "target": "accessibility"
  },
  {
    "source": "en301549",
    "target": "secure"
  },
  {
    "source": "en301549",
    "target": "safe"
  },
  {
    "source": "en301549",
    "target": "usable"
  },
  {
    "source": "en301549",
    "target": "reliable"
  },
  {
    "source": "en301549",
    "target": "efficient"
  },
  {
    "source": "en301549",
    "target": "suitable"
  },
  {
    "source": "en301549",
    "target": "flexible"
  },
  {
    "source": "en301549",
    "target": "operable"
  },
  {
    "source": "encrypted-storage",
    "target": "confidentiality"
  },
  {
    "source": "encrypted-storage",
    "target": "security"
  },
  {
    "source": "encrypted-storage",
    "target": "privacy"
  },
  {
    "source": "encryption-at-rest-and-in-transit",
    "target": "secure"
  },
  {
    "source": "encryption-at-rest-and-in-transit",
    "target": "confidentiality"
  },
  {
    "source": "encryption-at-rest-and-in-transit",
    "target": "data-integrity"
  },
  {
    "source": "encryption-at-rest-and-in-transit",
    "target": "data-protection"
  },
  {
    "source": "encryption-at-rest-and-in-transit",
    "target": "privacy"
  },
  {
    "source": "encryption-at-rest-and-in-transit",
    "target": "compliance"
  },
  {
    "source": "energy-efficiency",
    "target": "efficient"
  },
  {
    "source": "energy-efficiency",
    "target": "carbon-emission-efficiency"
  },
  {
    "source": "energy-efficiency",
    "target": "sustainability"
  },
  {
    "source": "energy-efficiency",
    "target": "energy-proportionality"
  },
  {
    "source": "energy-proportionality",
    "target": "efficient"
  },
  {
    "source": "energy-proportionality",
    "target": "energy-efficiency"
  },
  {
    "source": "energy-proportionality",
    "target": "resource-utilization"
  },
  {
    "source": "energy-proportionality",
    "target": "elasticity"
  },
  {
    "source": "energy-proportionality",
    "target": "scalability"
  },
  {
    "source": "energy-proportionality",
    "target": "sustainability"
  },
  {
    "source": "energy-proportionality",
    "target": "carbon-emission-efficiency"
  },
  {
    "source": "etsien304223",
    "target": "confidentiality"
  },
  {
    "source": "etsien304223",
    "target": "drift-detectability"
  },
  {
    "source": "etsien304223",
    "target": "injection-resistance"
  },
  {
    "source": "etsien304223",
    "target": "integrity"
  },
  {
    "source": "etsien304223",
    "target": "maintainability"
  },
  {
    "source": "etsien304223",
    "target": "recoverability"
  },
  {
    "source": "etsien304223",
    "target": "resilience"
  },
  {
    "source": "etsien304223",
    "target": "robustness"
  },
  {
    "source": "etsien304223",
    "target": "traceability"
  },
  {
    "source": "etsien304223",
    "target": "transparency"
  },
  {
    "source": "etsien304223",
    "target": "security"
  },
  {
    "source": "etsien304223",
    "target": "accountability"
  },
  {
    "source": "etsien304223",
    "target": "auditability"
  },
  {
    "source": "etsien304223",
    "target": "availability"
  },
  {
    "source": "etsien304223",
    "target": "secure"
  },
  {
    "source": "etsien304223",
    "target": "reliable"
  },
  {
    "source": "etsien304223",
    "target": "operable"
  },
  {
    "source": "etsien304223",
    "target": "maintainable"
  },
  {
    "source": "etsien304223",
    "target": "usable"
  },
  {
    "source": "eucsf",
    "target": "compliance"
  },
  {
    "source": "eucsf",
    "target": "data-residency"
  },
  {
    "source": "eucsf",
    "target": "data-sovereignty"
  },
  {
    "source": "eucsf",
    "target": "portability"
  },
  {
    "source": "eucsf",
    "target": "secure"
  },
  {
    "source": "eucsf",
    "target": "safe"
  },
  {
    "source": "eucsf",
    "target": "usable"
  },
  {
    "source": "eucsf",
    "target": "reliable"
  },
  {
    "source": "eucsf",
    "target": "efficient"
  },
  {
    "source": "eucsf",
    "target": "suitable"
  },
  {
    "source": "eucsf",
    "target": "flexible"
  },
  {
    "source": "eucsf",
    "target": "operable"
  },
  {
    "source": "event-driven-architecture",
    "target": "flexible"
  },
  {
    "source": "event-driven-architecture",
    "target": "operable"
  },
  {
    "source": "event-driven-architecture",
    "target": "loose-coupling"
  },
  {
    "source": "event-driven-architecture",
    "target": "extensibility"
  },
  {
    "source": "event-driven-architecture",
    "target": "evolvability"
  },
  {
    "source": "event-driven-architecture",
    "target": "autonomy"
  },
  {
    "source": "event-driven-architecture",
    "target": "integrability"
  },
  {
    "source": "event-driven-architecture",
    "target": "asynchronous-messaging"
  },
  {
    "source": "event-sourcing",
    "target": "flexible"
  },
  {
    "source": "event-sourcing",
    "target": "auditability"
  },
  {
    "source": "event-sourcing",
    "target": "traceability"
  },
  {
    "source": "event-sourcing",
    "target": "evolvability"
  },
  {
    "source": "event-sourcing",
    "target": "recoverability"
  },
  {
    "source": "event-sourcing",
    "target": "debuggability"
  },
  {
    "source": "event-sourcing",
    "target": "event-driven-architecture"
  },
  {
    "source": "every-data-modification-is-logged",
    "target": "security"
  },
  {
    "source": "every-data-modification-is-logged",
    "target": "privacy"
  },
  {
    "source": "every-data-modification-is-logged",
    "target": "traceability"
  },
  {
    "source": "every-data-modification-is-logged",
    "target": "recoverability"
  },
  {
    "source": "evolvability",
    "target": "flexible"
  },
  {
    "source": "evolvability",
    "target": "maintainable"
  },
  {
    "source": "evolvability",
    "target": "adaptability"
  },
  {
    "source": "evolvability",
    "target": "maintainability"
  },
  {
    "source": "evolvability",
    "target": "extensibility"
  },
  {
    "source": "evolvability",
    "target": "scalability"
  },
  {
    "source": "evolvability",
    "target": "modularity"
  },
  {
    "source": "evolvability",
    "target": "traceability"
  },
  {
    "source": "evolvability",
    "target": "auditability"
  },
  {
    "source": "expected-physical-environment",
    "target": "suitable"
  },
  {
    "source": "expected-physical-environment",
    "target": "operable"
  },
  {
    "source": "expected-physical-environment",
    "target": "anticipated-workplace-environment"
  },
  {
    "source": "explainability",
    "target": "safe"
  },
  {
    "source": "explainability",
    "target": "suitable"
  },
  {
    "source": "explainability",
    "target": "accountability"
  },
  {
    "source": "explainability",
    "target": "analysability"
  },
  {
    "source": "explainability",
    "target": "clarity"
  },
  {
    "source": "explainability",
    "target": "determinism"
  },
  {
    "source": "explainability",
    "target": "groundedness"
  },
  {
    "source": "expressive-error-messages",
    "target": "usability"
  },
  {
    "source": "expressive-error-messages",
    "target": "user-experience"
  },
  {
    "source": "expressive-error-messages",
    "target": "fault-isolation"
  },
  {
    "source": "expressive-error-messages",
    "target": "graceful-degradation"
  },
  {
    "source": "expressive-error-messages",
    "target": "hazard-warning"
  },
  {
    "source": "expressive-error-messages",
    "target": "user-assistance"
  },
  {
    "source": "expressive-error-messages",
    "target": "interaction-capability"
  },
  {
    "source": "extensibility",
    "target": "flexible"
  },
  {
    "source": "extensibility",
    "target": "maintainable"
  },
  {
    "source": "extensibility",
    "target": "adaptability"
  },
  {
    "source": "extensibility",
    "target": "modifiability"
  },
  {
    "source": "extensibility",
    "target": "changeability"
  },
  {
    "source": "extensibility",
    "target": "flexibility"
  },
  {
    "source": "externalized-business-rules",
    "target": "flexible"
  },
  {
    "source": "externalized-business-rules",
    "target": "changeability"
  },
  {
    "source": "externalized-business-rules",
    "target": "adaptability"
  },
  {
    "source": "externalized-business-rules",
    "target": "time-to-market"
  },
  {
    "source": "externalized-business-rules",
    "target": "explainability"
  },
  {
    "source": "externalized-business-rules",
    "target": "auditability"
  },
  {
    "source": "facial-recognition-bias-mitigation",
    "target": "bias-mitigation"
  },
  {
    "source": "facial-recognition-bias-mitigation",
    "target": "fairness"
  },
  {
    "source": "facial-recognition-bias-mitigation",
    "target": "accountability"
  },
  {
    "source": "facial-recognition-bias-mitigation",
    "target": "transparency"
  },
  {
    "source": "fail-safe",
    "target": "safe"
  },
  {
    "source": "fail-safe",
    "target": "reliable"
  },
  {
    "source": "fail-safe",
    "target": "safety"
  },
  {
    "source": "fail-safe",
    "target": "robustness"
  },
  {
    "source": "fail-safe-defaults",
    "target": "safe"
  },
  {
    "source": "fail-safe-defaults",
    "target": "reliable"
  },
  {
    "source": "fail-safe-defaults",
    "target": "safety"
  },
  {
    "source": "fail-safe-defaults",
    "target": "fault-tolerance"
  },
  {
    "source": "fail-safe-defaults",
    "target": "fail-safe"
  },
  {
    "source": "fail-safe-defaults",
    "target": "robustness"
  },
  {
    "source": "fail-safe-defaults",
    "target": "predictability"
  },
  {
    "source": "fail-safe-defaults",
    "target": "controllability"
  },
  {
    "source": "failure-transparency",
    "target": "reliable"
  },
  {
    "source": "failure-transparency",
    "target": "safe"
  },
  {
    "source": "failure-transparency",
    "target": "availability"
  },
  {
    "source": "failure-transparency",
    "target": "fault-tolerance"
  },
  {
    "source": "failure-transparency",
    "target": "resilience"
  },
  {
    "source": "failure-transparency",
    "target": "reliability"
  },
  {
    "source": "fairness",
    "target": "reliable"
  },
  {
    "source": "fairness",
    "target": "safe"
  },
  {
    "source": "fairness",
    "target": "suitable"
  },
  {
    "source": "fairness",
    "target": "bias-mitigation"
  },
  {
    "source": "fairness",
    "target": "explainability"
  },
  {
    "source": "fairness",
    "target": "transparency"
  },
  {
    "source": "fairness",
    "target": "accountability"
  },
  {
    "source": "fast-accurate-sensor",
    "target": "efficiency"
  },
  {
    "source": "fast-accurate-sensor",
    "target": "precision"
  },
  {
    "source": "fast-accurate-sensor",
    "target": "accuracy"
  },
  {
    "source": "fast-creation-of-sales-report",
    "target": "efficiency"
  },
  {
    "source": "fast-creation-of-sales-report",
    "target": "performance"
  },
  {
    "source": "fast-creation-of-sales-report",
    "target": "time-behaviour"
  },
  {
    "source": "fast-creation-of-sales-report",
    "target": "speed"
  },
  {
    "source": "fast-creation-of-sales-report",
    "target": "responsiveness"
  },
  {
    "source": "fast-deployment",
    "target": "time-behaviour"
  },
  {
    "source": "fast-deployment",
    "target": "operability"
  },
  {
    "source": "fast-deployment",
    "target": "deployment-frequency"
  },
  {
    "source": "fast-deployment",
    "target": "extensibility"
  },
  {
    "source": "fast-deployment",
    "target": "lead-time-for-changes"
  },
  {
    "source": "fast-deployment",
    "target": "cycle-time"
  },
  {
    "source": "fast-deployment",
    "target": "devops-metrics"
  },
  {
    "source": "fast-rollout-of-changes",
    "target": "efficiency"
  },
  {
    "source": "fast-rollout-of-changes",
    "target": "operability"
  },
  {
    "source": "fast-rollout-of-changes",
    "target": "speed"
  },
  {
    "source": "fast-rollout-of-changes",
    "target": "time-to-market"
  },
  {
    "source": "fast-rollout-of-changes",
    "target": "time-to-market"
  },
  {
    "source": "fast-shutdown-time",
    "target": "time-behaviour"
  },
  {
    "source": "fast-shutdown-time",
    "target": "speed"
  },
  {
    "source": "fast-shutdown-time",
    "target": "shutdown-time"
  },
  {
    "source": "fast-startup-time",
    "target": "time-behaviour"
  },
  {
    "source": "fast-startup-time",
    "target": "speed"
  },
  {
    "source": "fast-startup-time",
    "target": "performance"
  },
  {
    "source": "fast-startup-time",
    "target": "startup-time"
  },
  {
    "source": "fast-startup-time",
    "target": "elasticity"
  },
  {
    "source": "fast-startup-time",
    "target": "scalability"
  },
  {
    "source": "fault-isolation",
    "target": "safe"
  },
  {
    "source": "fault-isolation",
    "target": "reliable"
  },
  {
    "source": "fault-isolation",
    "target": "safety"
  },
  {
    "source": "fault-isolation",
    "target": "fail-safe"
  },
  {
    "source": "fault-isolation",
    "target": "fault-tolerance"
  },
  {
    "source": "fault-isolation",
    "target": "faultlessness"
  },
  {
    "source": "fault-isolation",
    "target": "risk-identification"
  },
  {
    "source": "fault-isolation",
    "target": "hazard-warning"
  },
  {
    "source": "fault-tolerance",
    "target": "reliable"
  },
  {
    "source": "fault-tolerance",
    "target": "usable"
  },
  {
    "source": "fault-tolerance",
    "target": "robustness"
  },
  {
    "source": "fault-tolerance",
    "target": "reliability"
  },
  {
    "source": "fault-tolerance",
    "target": "usability"
  },
  {
    "source": "fault-tolerance",
    "target": "availability"
  },
  {
    "source": "fault-tolerance",
    "target": "recoverability"
  },
  {
    "source": "fault-tolerance",
    "target": "faultlessness"
  },
  {
    "source": "fault-tolerance",
    "target": "graceful-degradation"
  },
  {
    "source": "fault-tolerance",
    "target": "autonomy"
  },
  {
    "source": "faultlessness",
    "target": "reliable"
  },
  {
    "source": "faultlessness",
    "target": "usable"
  },
  {
    "source": "faultlessness",
    "target": "secure"
  },
  {
    "source": "faultlessness",
    "target": "dependability"
  },
  {
    "source": "faultlessness",
    "target": "reliability"
  },
  {
    "source": "faultlessness",
    "target": "availability"
  },
  {
    "source": "feature-degradation",
    "target": "reliable"
  },
  {
    "source": "feature-degradation",
    "target": "usable"
  },
  {
    "source": "feature-degradation",
    "target": "graceful-degradation"
  },
  {
    "source": "feature-degradation",
    "target": "availability"
  },
  {
    "source": "feature-degradation",
    "target": "resilience"
  },
  {
    "source": "feature-degradation",
    "target": "recoverability"
  },
  {
    "source": "feature-toggles",
    "target": "flexible"
  },
  {
    "source": "feature-toggles",
    "target": "operable"
  },
  {
    "source": "feature-toggles",
    "target": "deployability"
  },
  {
    "source": "feature-toggles",
    "target": "flexibility"
  },
  {
    "source": "feature-toggles",
    "target": "testability"
  },
  {
    "source": "feature-toggles",
    "target": "changeability"
  },
  {
    "source": "feature-toggles",
    "target": "modifiability"
  },
  {
    "source": "features",
    "target": "usable"
  },
  {
    "source": "features",
    "target": "functionality"
  },
  {
    "source": "features",
    "target": "functional-completeness"
  },
  {
    "source": "features",
    "target": "usability"
  },
  {
    "source": "features",
    "target": "functional-suitability"
  },
  {
    "source": "financial-data-accuracy",
    "target": "data-quality"
  },
  {
    "source": "financial-data-accuracy",
    "target": "accuracy"
  },
  {
    "source": "financial-data-accuracy",
    "target": "correctness"
  },
  {
    "source": "financial-data-accuracy",
    "target": "integrity"
  },
  {
    "source": "financial-transactions-are-acid-compliant",
    "target": "data-integrity"
  },
  {
    "source": "financial-transactions-are-acid-compliant",
    "target": "transactionality"
  },
  {
    "source": "financial-transactions-are-acid-compliant",
    "target": "consistency"
  },
  {
    "source": "financial-transactions-are-acid-compliant",
    "target": "correctness"
  },
  {
    "source": "financial-transactions-are-acid-compliant",
    "target": "durability"
  },
  {
    "source": "fine-grained-authorization",
    "target": "secure"
  },
  {
    "source": "fine-grained-authorization",
    "target": "security"
  },
  {
    "source": "fine-grained-authorization",
    "target": "access-control"
  },
  {
    "source": "fine-grained-authorization",
    "target": "confidentiality"
  },
  {
    "source": "fine-grained-authorization",
    "target": "integrity"
  },
  {
    "source": "fine-grained-authorization",
    "target": "compliance"
  },
  {
    "source": "fine-grained-authorization",
    "target": "governability"
  },
  {
    "source": "fine-grained-authorization",
    "target": "auditability"
  },
  {
    "source": "first-time-onboarding-without-errors",
    "target": "intuitiveness"
  },
  {
    "source": "first-time-onboarding-without-errors",
    "target": "usability"
  },
  {
    "source": "first-time-onboarding-without-errors",
    "target": "learnability"
  },
  {
    "source": "first-time-onboarding-without-errors",
    "target": "understandability"
  },
  {
    "source": "fleet-ota-updates-with-safe-rollback",
    "target": "updateability"
  },
  {
    "source": "fleet-ota-updates-with-safe-rollback",
    "target": "upgradeability"
  },
  {
    "source": "fleet-ota-updates-with-safe-rollback",
    "target": "maintainability"
  },
  {
    "source": "fleet-ota-updates-with-safe-rollback",
    "target": "recoverability"
  },
  {
    "source": "fleet-ota-updates-with-safe-rollback",
    "target": "availability"
  },
  {
    "source": "fleet-ota-updates-with-safe-rollback",
    "target": "security"
  },
  {
    "source": "flexibility",
    "target": "flexible"
  },
  {
    "source": "flexibility",
    "target": "maintainability"
  },
  {
    "source": "flexibility",
    "target": "modularity"
  },
  {
    "source": "flexibility",
    "target": "adaptability"
  },
  {
    "source": "flexibility",
    "target": "configurability"
  },
  {
    "source": "flexibility",
    "target": "changeability"
  },
  {
    "source": "flexibility",
    "target": "agility"
  },
  {
    "source": "flexibility",
    "target": "autonomy"
  },
  {
    "source": "flexible",
    "target": "quality-root"
  },
  {
    "source": "fraud-detection-drift-detected-within-1-hour",
    "target": "drift-detectability"
  },
  {
    "source": "fraud-detection-drift-detected-within-1-hour",
    "target": "reliability"
  },
  {
    "source": "fraud-detection-drift-detected-within-1-hour",
    "target": "diagnosability"
  },
  {
    "source": "fraud-detection-drift-detected-within-1-hour",
    "target": "data-quality"
  },
  {
    "source": "functional-adaptability",
    "target": "suitable"
  },
  {
    "source": "functional-adaptability",
    "target": "functionality"
  },
  {
    "source": "functional-adaptability",
    "target": "functional-suitability"
  },
  {
    "source": "functional-adaptability",
    "target": "suitability"
  },
  {
    "source": "functional-appropriateness",
    "target": "usable"
  },
  {
    "source": "functional-appropriateness",
    "target": "reliable"
  },
  {
    "source": "functional-appropriateness",
    "target": "suitable"
  },
  {
    "source": "functional-appropriateness",
    "target": "usability"
  },
  {
    "source": "functional-appropriateness",
    "target": "functionality"
  },
  {
    "source": "functional-appropriateness",
    "target": "functional-suitability"
  },
  {
    "source": "functional-appropriateness",
    "target": "suitability"
  },
  {
    "source": "functional-completeness",
    "target": "usable"
  },
  {
    "source": "functional-completeness",
    "target": "reliable"
  },
  {
    "source": "functional-completeness",
    "target": "suitable"
  },
  {
    "source": "functional-completeness",
    "target": "usability"
  },
  {
    "source": "functional-completeness",
    "target": "functionality"
  },
  {
    "source": "functional-completeness",
    "target": "functional-suitability"
  },
  {
    "source": "functional-completeness",
    "target": "correctness"
  },
  {
    "source": "functional-suitability",
    "target": "usable"
  },
  {
    "source": "functional-suitability",
    "target": "reliable"
  },
  {
    "source": "functional-suitability",
    "target": "suitable"
  },
  {
    "source": "functional-suitability",
    "target": "usability"
  },
  {
    "source": "functional-suitability",
    "target": "functionality"
  },
  {
    "source": "functional-suitability",
    "target": "functional-completeness"
  },
  {
    "source": "functional-suitability",
    "target": "suitability"
  },
  {
    "source": "functionality",
    "target": "usable"
  },
  {
    "source": "functionality",
    "target": "reliable"
  },
  {
    "source": "functionality",
    "target": "suitable"
  },
  {
    "source": "functionality",
    "target": "usability"
  },
  {
    "source": "functionality",
    "target": "functional-suitability"
  },
  {
    "source": "functionality",
    "target": "correctness"
  },
  {
    "source": "functionality",
    "target": "functional-completeness"
  },
  {
    "source": "gdpr",
    "target": "confidentiality"
  },
  {
    "source": "gdpr",
    "target": "consent-management"
  },
  {
    "source": "gdpr",
    "target": "data-integrity"
  },
  {
    "source": "gdpr",
    "target": "data-minimization"
  },
  {
    "source": "gdpr",
    "target": "data-protection"
  },
  {
    "source": "gdpr",
    "target": "privacy"
  },
  {
    "source": "gdpr",
    "target": "traceability"
  },
  {
    "source": "gdpr",
    "target": "transparency"
  },
  {
    "source": "gdpr",
    "target": "security"
  },
  {
    "source": "gdpr",
    "target": "access-control"
  },
  {
    "source": "gdpr",
    "target": "accountability"
  },
  {
    "source": "gdpr",
    "target": "auditability"
  },
  {
    "source": "gdpr",
    "target": "authenticity"
  },
  {
    "source": "gdpr",
    "target": "secure"
  },
  {
    "source": "gdpr",
    "target": "usable"
  },
  {
    "source": "gdpr",
    "target": "reliable"
  },
  {
    "source": "gdpr",
    "target": "operable"
  },
  {
    "source": "global-explainability",
    "target": "explainability"
  },
  {
    "source": "good-code-readability-score",
    "target": "readability"
  },
  {
    "source": "good-code-readability-score",
    "target": "legibility"
  },
  {
    "source": "good-code-readability-score",
    "target": "code-readability"
  },
  {
    "source": "good-code-readability-score",
    "target": "code-complexity"
  },
  {
    "source": "good-code-readability-score",
    "target": "maintainability"
  },
  {
    "source": "good-code-readability-score",
    "target": "simplicity"
  },
  {
    "source": "governability",
    "target": "operable"
  },
  {
    "source": "governability",
    "target": "secure"
  },
  {
    "source": "governability",
    "target": "compliance"
  },
  {
    "source": "governability",
    "target": "accountability"
  },
  {
    "source": "governability",
    "target": "auditability"
  },
  {
    "source": "governability",
    "target": "controllability"
  },
  {
    "source": "governability",
    "target": "operability"
  },
  {
    "source": "governability",
    "target": "traceability"
  },
  {
    "source": "governability",
    "target": "security"
  },
  {
    "source": "governance-policy-enforcement",
    "target": "governability"
  },
  {
    "source": "governance-policy-enforcement",
    "target": "compliance"
  },
  {
    "source": "governance-policy-enforcement",
    "target": "accountability"
  },
  {
    "source": "governance-policy-enforcement",
    "target": "auditability"
  },
  {
    "source": "governance-policy-enforcement",
    "target": "security"
  },
  {
    "source": "graceful-degradation",
    "target": "reliable"
  },
  {
    "source": "graceful-degradation",
    "target": "usable"
  },
  {
    "source": "graceful-degradation",
    "target": "robustness"
  },
  {
    "source": "graceful-degradation",
    "target": "reliability"
  },
  {
    "source": "graceful-degradation",
    "target": "usability"
  },
  {
    "source": "graceful-degradation",
    "target": "availability"
  },
  {
    "source": "graceful-degradation",
    "target": "recoverability"
  },
  {
    "source": "graceful-degradation",
    "target": "faultlessness"
  },
  {
    "source": "graceful-degradation",
    "target": "fault-tolerance"
  },
  {
    "source": "grounded-customer-support-answer",
    "target": "groundedness"
  },
  {
    "source": "grounded-customer-support-answer",
    "target": "correctness"
  },
  {
    "source": "grounded-customer-support-answer",
    "target": "traceability"
  },
  {
    "source": "grounded-explainable-loan-decision",
    "target": "groundedness"
  },
  {
    "source": "grounded-explainable-loan-decision",
    "target": "explainability"
  },
  {
    "source": "grounded-explainable-loan-decision",
    "target": "traceability"
  },
  {
    "source": "grounded-explainable-loan-decision",
    "target": "accountability"
  },
  {
    "source": "grounded-medical-triage-draft",
    "target": "groundedness"
  },
  {
    "source": "grounded-medical-triage-draft",
    "target": "correctness"
  },
  {
    "source": "grounded-medical-triage-draft",
    "target": "traceability"
  },
  {
    "source": "grounded-medical-triage-draft",
    "target": "safety"
  },
  {
    "source": "groundedness",
    "target": "reliable"
  },
  {
    "source": "groundedness",
    "target": "suitable"
  },
  {
    "source": "groundedness",
    "target": "correctness"
  },
  {
    "source": "groundedness",
    "target": "verifiability"
  },
  {
    "source": "groundedness",
    "target": "traceability"
  },
  {
    "source": "groundedness",
    "target": "reliability"
  },
  {
    "source": "groundedness",
    "target": "explainability"
  },
  {
    "source": "groundedness",
    "target": "model-transparency"
  },
  {
    "source": "groundedness",
    "target": "data-quality"
  },
  {
    "source": "handle-sudden-increase-in-traffic",
    "target": "resilience"
  },
  {
    "source": "handle-sudden-increase-in-traffic",
    "target": "reliability"
  },
  {
    "source": "handle-sudden-increase-in-traffic",
    "target": "elasticity"
  },
  {
    "source": "handle-sudden-increase-in-traffic",
    "target": "scalability"
  },
  {
    "source": "hazard-warning",
    "target": "safe"
  },
  {
    "source": "hazard-warning",
    "target": "reliable"
  },
  {
    "source": "hazard-warning",
    "target": "safety"
  },
  {
    "source": "hazard-warning",
    "target": "robustness"
  },
  {
    "source": "hexagonal-architecture",
    "target": "maintainable"
  },
  {
    "source": "hexagonal-architecture",
    "target": "flexible"
  },
  {
    "source": "hexagonal-architecture",
    "target": "testability"
  },
  {
    "source": "hexagonal-architecture",
    "target": "evolvability"
  },
  {
    "source": "hexagonal-architecture",
    "target": "loose-coupling"
  },
  {
    "source": "hexagonal-architecture",
    "target": "modularity"
  },
  {
    "source": "hexagonal-architecture",
    "target": "plugin-architecture"
  },
  {
    "source": "high-precision-calculation",
    "target": "reliability"
  },
  {
    "source": "high-precision-calculation",
    "target": "precision"
  },
  {
    "source": "high-precision-calculation",
    "target": "accuracy"
  },
  {
    "source": "high-precision-calculation",
    "target": "correctness"
  },
  {
    "source": "hiring-algorithm-bias-mitigation",
    "target": "bias-mitigation"
  },
  {
    "source": "hiring-algorithm-bias-mitigation",
    "target": "fairness"
  },
  {
    "source": "hiring-algorithm-bias-mitigation",
    "target": "transparency"
  },
  {
    "source": "hiring-algorithm-bias-mitigation",
    "target": "accountability"
  },
  {
    "source": "hiring-algorithm-bias-mitigation",
    "target": "explainability"
  },
  {
    "source": "hl7",
    "target": "compatibility"
  },
  {
    "source": "hl7",
    "target": "compliance"
  },
  {
    "source": "hl7",
    "target": "confidentiality"
  },
  {
    "source": "hl7",
    "target": "data-integrity"
  },
  {
    "source": "hl7",
    "target": "data-quality"
  },
  {
    "source": "hl7",
    "target": "flexibility"
  },
  {
    "source": "hl7",
    "target": "extensibility"
  },
  {
    "source": "hl7",
    "target": "integrity"
  },
  {
    "source": "hl7",
    "target": "interoperability"
  },
  {
    "source": "hl7",
    "target": "maintainability"
  },
  {
    "source": "hl7",
    "target": "portability"
  },
  {
    "source": "hl7",
    "target": "reliability"
  },
  {
    "source": "hl7",
    "target": "traceability"
  },
  {
    "source": "hl7",
    "target": "scalability"
  },
  {
    "source": "hl7",
    "target": "security"
  },
  {
    "source": "hl7",
    "target": "auditability"
  },
  {
    "source": "hl7",
    "target": "availability"
  },
  {
    "source": "hl7",
    "target": "usable"
  },
  {
    "source": "hl7",
    "target": "operable"
  },
  {
    "source": "hl7",
    "target": "reliable"
  },
  {
    "source": "hl7",
    "target": "secure"
  },
  {
    "source": "hl7",
    "target": "safe"
  },
  {
    "source": "hl7",
    "target": "efficient"
  },
  {
    "source": "hl7",
    "target": "suitable"
  },
  {
    "source": "hl7",
    "target": "flexible"
  },
  {
    "source": "hl7",
    "target": "maintainable"
  },
  {
    "source": "iec61508",
    "target": "certifiability"
  },
  {
    "source": "iec61508",
    "target": "fault-tolerance"
  },
  {
    "source": "iec61508",
    "target": "maintainability"
  },
  {
    "source": "iec61508",
    "target": "reliability"
  },
  {
    "source": "iec61508",
    "target": "testability"
  },
  {
    "source": "iec61508",
    "target": "safety"
  },
  {
    "source": "iec61508",
    "target": "updateability"
  },
  {
    "source": "iec61508",
    "target": "suitable"
  },
  {
    "source": "iec61508",
    "target": "reliable"
  },
  {
    "source": "iec61508",
    "target": "safe"
  },
  {
    "source": "iec61508",
    "target": "usable"
  },
  {
    "source": "iec61508",
    "target": "maintainable"
  },
  {
    "source": "iec61508",
    "target": "secure"
  },
  {
    "source": "iec61508",
    "target": "operable"
  },
  {
    "source": "iec62304",
    "target": "certifiability"
  },
  {
    "source": "iec62304",
    "target": "maintainability"
  },
  {
    "source": "iec62304",
    "target": "reliability"
  },
  {
    "source": "iec62304",
    "target": "traceability"
  },
  {
    "source": "iec62304",
    "target": "safety"
  },
  {
    "source": "iec62304",
    "target": "security"
  },
  {
    "source": "iec62304",
    "target": "updateability"
  },
  {
    "source": "iec62304",
    "target": "usability"
  },
  {
    "source": "iec62304",
    "target": "suitable"
  },
  {
    "source": "iec62304",
    "target": "reliable"
  },
  {
    "source": "iec62304",
    "target": "safe"
  },
  {
    "source": "iec62304",
    "target": "maintainable"
  },
  {
    "source": "iec62304",
    "target": "operable"
  },
  {
    "source": "iec62304",
    "target": "secure"
  },
  {
    "source": "iec62304",
    "target": "usable"
  },
  {
    "source": "iec62443",
    "target": "confidentiality"
  },
  {
    "source": "iec62443",
    "target": "integrity"
  },
  {
    "source": "iec62443",
    "target": "robustness"
  },
  {
    "source": "iec62443",
    "target": "security"
  },
  {
    "source": "iec62443",
    "target": "access-control"
  },
  {
    "source": "iec62443",
    "target": "auditability"
  },
  {
    "source": "iec62443",
    "target": "availability"
  },
  {
    "source": "iec62443",
    "target": "secure"
  },
  {
    "source": "iec62443",
    "target": "reliable"
  },
  {
    "source": "iec62443",
    "target": "operable"
  },
  {
    "source": "iec62443",
    "target": "usable"
  },
  {
    "source": "ieee2857",
    "target": "compliance"
  },
  {
    "source": "ieee2857",
    "target": "confidentiality"
  },
  {
    "source": "ieee2857",
    "target": "configurability"
  },
  {
    "source": "ieee2857",
    "target": "consent-management"
  },
  {
    "source": "ieee2857",
    "target": "controllability"
  },
  {
    "source": "ieee2857",
    "target": "data-integrity"
  },
  {
    "source": "ieee2857",
    "target": "data-minimization"
  },
  {
    "source": "ieee2857",
    "target": "data-protection"
  },
  {
    "source": "ieee2857",
    "target": "flexibility"
  },
  {
    "source": "ieee2857",
    "target": "integrity"
  },
  {
    "source": "ieee2857",
    "target": "interoperability"
  },
  {
    "source": "ieee2857",
    "target": "learnability"
  },
  {
    "source": "ieee2857",
    "target": "maintainability"
  },
  {
    "source": "ieee2857",
    "target": "modularity"
  },
  {
    "source": "ieee2857",
    "target": "observability"
  },
  {
    "source": "ieee2857",
    "target": "privacy"
  },
  {
    "source": "ieee2857",
    "target": "transparency"
  },
  {
    "source": "ieee2857",
    "target": "scalability"
  },
  {
    "source": "ieee2857",
    "target": "security"
  },
  {
    "source": "ieee2857",
    "target": "access-control"
  },
  {
    "source": "ieee2857",
    "target": "accountability"
  },
  {
    "source": "ieee2857",
    "target": "accessibility"
  },
  {
    "source": "ieee2857",
    "target": "auditability"
  },
  {
    "source": "ieee2857",
    "target": "authenticity"
  },
  {
    "source": "ieee2857",
    "target": "secure"
  },
  {
    "source": "ieee2857",
    "target": "safe"
  },
  {
    "source": "ieee2857",
    "target": "usable"
  },
  {
    "source": "ieee2857",
    "target": "reliable"
  },
  {
    "source": "ieee2857",
    "target": "efficient"
  },
  {
    "source": "ieee2857",
    "target": "suitable"
  },
  {
    "source": "ieee2857",
    "target": "flexible"
  },
  {
    "source": "ieee2857",
    "target": "operable"
  },
  {
    "source": "ieee2857",
    "target": "maintainable"
  },
  {
    "source": "ieee7000",
    "target": "bias-mitigation"
  },
  {
    "source": "ieee7000",
    "target": "fairness"
  },
  {
    "source": "ieee7000",
    "target": "explainability"
  },
  {
    "source": "ieee7000",
    "target": "traceability"
  },
  {
    "source": "ieee7000",
    "target": "transparency"
  },
  {
    "source": "ieee7000",
    "target": "accountability"
  },
  {
    "source": "ieee7000",
    "target": "auditability"
  },
  {
    "source": "ieee7000",
    "target": "reliable"
  },
  {
    "source": "ieee7000",
    "target": "safe"
  },
  {
    "source": "ieee7000",
    "target": "suitable"
  },
  {
    "source": "ieee7000",
    "target": "operable"
  },
  {
    "source": "ieee7000",
    "target": "secure"
  },
  {
    "source": "ihe",
    "target": "certifiability"
  },
  {
    "source": "ihe",
    "target": "compatibility"
  },
  {
    "source": "ihe",
    "target": "confidentiality"
  },
  {
    "source": "ihe",
    "target": "data-integrity"
  },
  {
    "source": "ihe",
    "target": "data-quality"
  },
  {
    "source": "ihe",
    "target": "flexibility"
  },
  {
    "source": "ihe",
    "target": "extensibility"
  },
  {
    "source": "ihe",
    "target": "integrity"
  },
  {
    "source": "ihe",
    "target": "interoperability"
  },
  {
    "source": "ihe",
    "target": "maintainability"
  },
  {
    "source": "ihe",
    "target": "portability"
  },
  {
    "source": "ihe",
    "target": "reliability"
  },
  {
    "source": "ihe",
    "target": "testability"
  },
  {
    "source": "ihe",
    "target": "traceability"
  },
  {
    "source": "ihe",
    "target": "security"
  },
  {
    "source": "ihe",
    "target": "verifiability"
  },
  {
    "source": "ihe",
    "target": "auditability"
  },
  {
    "source": "ihe",
    "target": "availability"
  },
  {
    "source": "ihe",
    "target": "suitable"
  },
  {
    "source": "ihe",
    "target": "reliable"
  },
  {
    "source": "ihe",
    "target": "safe"
  },
  {
    "source": "ihe",
    "target": "usable"
  },
  {
    "source": "ihe",
    "target": "operable"
  },
  {
    "source": "ihe",
    "target": "secure"
  },
  {
    "source": "ihe",
    "target": "flexible"
  },
  {
    "source": "ihe",
    "target": "maintainable"
  },
  {
    "source": "immunity",
    "target": "secure"
  },
  {
    "source": "immunity",
    "target": "reliable"
  },
  {
    "source": "immunity",
    "target": "vulnerability"
  },
  {
    "source": "immunity",
    "target": "intrusion-detection"
  },
  {
    "source": "immunity",
    "target": "intrusion-prevention"
  },
  {
    "source": "inclusive-user-testing",
    "target": "usability"
  },
  {
    "source": "inclusive-user-testing",
    "target": "inclusivity"
  },
  {
    "source": "inclusive-user-testing",
    "target": "interaction-capability"
  },
  {
    "source": "inclusivity",
    "target": "usable"
  },
  {
    "source": "inclusivity",
    "target": "usability"
  },
  {
    "source": "inclusivity",
    "target": "functionality"
  },
  {
    "source": "inclusivity",
    "target": "attractiveness"
  },
  {
    "source": "inclusivity",
    "target": "user-error-protection"
  },
  {
    "source": "inclusivity",
    "target": "ease-of-use"
  },
  {
    "source": "increase-cohesion",
    "target": "maintainable"
  },
  {
    "source": "increase-cohesion",
    "target": "flexible"
  },
  {
    "source": "increase-cohesion",
    "target": "modularity"
  },
  {
    "source": "increase-cohesion",
    "target": "analysability"
  },
  {
    "source": "increase-cohesion",
    "target": "modifiability"
  },
  {
    "source": "increase-cohesion",
    "target": "testability"
  },
  {
    "source": "independence",
    "target": "flexible"
  },
  {
    "source": "independence",
    "target": "maintainability"
  },
  {
    "source": "independence",
    "target": "modularity"
  },
  {
    "source": "independence",
    "target": "adaptability"
  },
  {
    "source": "independence",
    "target": "configurability"
  },
  {
    "source": "independence",
    "target": "changeability"
  },
  {
    "source": "independence",
    "target": "agility"
  },
  {
    "source": "independence",
    "target": "flexibility"
  },
  {
    "source": "independence",
    "target": "autonomy"
  },
  {
    "source": "independent-enhancement-of-subsystem",
    "target": "efficiency"
  },
  {
    "source": "independent-enhancement-of-subsystem",
    "target": "maintainability"
  },
  {
    "source": "independent-enhancement-of-subsystem",
    "target": "changeability"
  },
  {
    "source": "independent-enhancement-of-subsystem",
    "target": "adaptability"
  },
  {
    "source": "independent-enhancement-of-subsystem",
    "target": "agility"
  },
  {
    "source": "independent-replacement-of-subsystem",
    "target": "adaptability"
  },
  {
    "source": "independent-replacement-of-subsystem",
    "target": "agility"
  },
  {
    "source": "independent-replacement-of-subsystem",
    "target": "changeability"
  },
  {
    "source": "independent-replacement-of-subsystem",
    "target": "efficiency"
  },
  {
    "source": "independent-replacement-of-subsystem",
    "target": "maintainability"
  },
  {
    "source": "injection-resistance",
    "target": "secure"
  },
  {
    "source": "injection-resistance",
    "target": "security"
  },
  {
    "source": "injection-resistance",
    "target": "resistance"
  },
  {
    "source": "injection-resistance",
    "target": "integrity"
  },
  {
    "source": "injection-resistance",
    "target": "intrusion-prevention"
  },
  {
    "source": "injection-resistance",
    "target": "robustness"
  },
  {
    "source": "input-sanitization-output-encoding",
    "target": "secure"
  },
  {
    "source": "input-sanitization-output-encoding",
    "target": "security"
  },
  {
    "source": "input-sanitization-output-encoding",
    "target": "integrity"
  },
  {
    "source": "input-sanitization-output-encoding",
    "target": "robustness"
  },
  {
    "source": "input-sanitization-output-encoding",
    "target": "data-integrity"
  },
  {
    "source": "input-sanitization-output-encoding",
    "target": "compliance"
  },
  {
    "source": "installability",
    "target": "operable"
  },
  {
    "source": "installability",
    "target": "flexible"
  },
  {
    "source": "installability",
    "target": "maintainability"
  },
  {
    "source": "installability",
    "target": "analysability"
  },
  {
    "source": "installability",
    "target": "operability"
  },
  {
    "source": "installability",
    "target": "deployability"
  },
  {
    "source": "integrability",
    "target": "flexible"
  },
  {
    "source": "integrability",
    "target": "operable"
  },
  {
    "source": "integrability",
    "target": "interoperability"
  },
  {
    "source": "integrability",
    "target": "modularity"
  },
  {
    "source": "integrability",
    "target": "composability"
  },
  {
    "source": "integrability",
    "target": "compatibility"
  },
  {
    "source": "integrability",
    "target": "integrity"
  },
  {
    "source": "integrity",
    "target": "secure"
  },
  {
    "source": "integrity",
    "target": "confidentiality"
  },
  {
    "source": "integrity",
    "target": "security"
  },
  {
    "source": "interaction-capability",
    "target": "usable"
  },
  {
    "source": "interaction-capability",
    "target": "operable"
  },
  {
    "source": "interaction-capability",
    "target": "usability"
  },
  {
    "source": "interaction-capability",
    "target": "functionality"
  },
  {
    "source": "interaction-capability",
    "target": "inclusivity"
  },
  {
    "source": "interaction-capability",
    "target": "attractiveness"
  },
  {
    "source": "interaction-capability",
    "target": "operability"
  },
  {
    "source": "interaction-capability",
    "target": "user-error-protection"
  },
  {
    "source": "interaction-capability",
    "target": "user-engagement"
  },
  {
    "source": "interaction-capability",
    "target": "ease-of-use"
  },
  {
    "source": "interchangeability",
    "target": "flexible"
  },
  {
    "source": "interchangeability",
    "target": "operable"
  },
  {
    "source": "interchangeability",
    "target": "replaceability"
  },
  {
    "source": "interchangeability",
    "target": "modularity"
  },
  {
    "source": "interchangeability",
    "target": "compatibility"
  },
  {
    "source": "interchangeability",
    "target": "portability"
  },
  {
    "source": "interchangeability",
    "target": "compliance"
  },
  {
    "source": "interchangeability",
    "target": "configurability"
  },
  {
    "source": "interchangeability",
    "target": "composability"
  },
  {
    "source": "interchangeability",
    "target": "flexibility"
  },
  {
    "source": "internationalization",
    "target": "flexible"
  },
  {
    "source": "internationalization",
    "target": "usable"
  },
  {
    "source": "internationalization",
    "target": "localizability"
  },
  {
    "source": "internationalization",
    "target": "adaptability"
  },
  {
    "source": "internationalization",
    "target": "modifiability"
  },
  {
    "source": "internationalization",
    "target": "maintainability"
  },
  {
    "source": "internationalization",
    "target": "internationalization"
  },
  {
    "source": "interoperability",
    "target": "usable"
  },
  {
    "source": "interoperability",
    "target": "operable"
  },
  {
    "source": "interoperability",
    "target": "co-existence"
  },
  {
    "source": "interoperability",
    "target": "compatibility"
  },
  {
    "source": "interoperable-with-java-12",
    "target": "compatibility"
  },
  {
    "source": "interoperable-with-java-12",
    "target": "interoperability"
  },
  {
    "source": "interoperable-with-java-12",
    "target": "backward-compatibility"
  },
  {
    "source": "interruptable-backend-process",
    "target": "usability"
  },
  {
    "source": "interruptable-backend-process",
    "target": "user-experience"
  },
  {
    "source": "interruptable-backend-process",
    "target": "time-behaviour"
  },
  {
    "source": "interruptable-backend-process",
    "target": "interaction-capability"
  },
  {
    "source": "interruptable-backend-process",
    "target": "controllability"
  },
  {
    "source": "intervenability",
    "target": "safe"
  },
  {
    "source": "intervenability",
    "target": "safety"
  },
  {
    "source": "intervenability",
    "target": "fail-safe"
  },
  {
    "source": "intervenability",
    "target": "controllability"
  },
  {
    "source": "intervenability",
    "target": "operational-constraint"
  },
  {
    "source": "intrusion-detection",
    "target": "secure"
  },
  {
    "source": "intrusion-detection",
    "target": "intrusion-prevention"
  },
  {
    "source": "intrusion-prevention",
    "target": "secure"
  },
  {
    "source": "intrusion-prevention",
    "target": "intrusion-detection"
  },
  {
    "source": "intuitiveness",
    "target": "usable"
  },
  {
    "source": "intuitiveness",
    "target": "usability"
  },
  {
    "source": "intuitiveness",
    "target": "learnability"
  },
  {
    "source": "intuitiveness",
    "target": "user-experience"
  },
  {
    "source": "intuitiveness",
    "target": "clarity"
  },
  {
    "source": "intuitiveness",
    "target": "simplicity"
  },
  {
    "source": "intuitiveness",
    "target": "self-descriptiveness"
  },
  {
    "source": "intuitiveness",
    "target": "understandability"
  },
  {
    "source": "iso12207",
    "target": "clarity"
  },
  {
    "source": "iso12207",
    "target": "coherence"
  },
  {
    "source": "iso12207",
    "target": "compatibility"
  },
  {
    "source": "iso12207",
    "target": "consistency"
  },
  {
    "source": "iso12207",
    "target": "correctness"
  },
  {
    "source": "iso12207",
    "target": "deployability"
  },
  {
    "source": "iso12207",
    "target": "flexibility"
  },
  {
    "source": "iso12207",
    "target": "functional-completeness"
  },
  {
    "source": "iso12207",
    "target": "interoperability"
  },
  {
    "source": "iso12207",
    "target": "maintainability"
  },
  {
    "source": "iso12207",
    "target": "modularity"
  },
  {
    "source": "iso12207",
    "target": "performance"
  },
  {
    "source": "iso12207",
    "target": "reliability"
  },
  {
    "source": "iso12207",
    "target": "traceability"
  },
  {
    "source": "iso12207",
    "target": "scalability"
  },
  {
    "source": "iso12207",
    "target": "security"
  },
  {
    "source": "iso12207",
    "target": "usability"
  },
  {
    "source": "iso12207",
    "target": "availability"
  },
  {
    "source": "iso12207",
    "target": "usable"
  },
  {
    "source": "iso12207",
    "target": "reliable"
  },
  {
    "source": "iso12207",
    "target": "maintainable"
  },
  {
    "source": "iso12207",
    "target": "operable"
  },
  {
    "source": "iso12207",
    "target": "efficient"
  },
  {
    "source": "iso12207",
    "target": "suitable"
  },
  {
    "source": "iso12207",
    "target": "flexible"
  },
  {
    "source": "iso12207",
    "target": "secure"
  },
  {
    "source": "iso14756",
    "target": "capacity"
  },
  {
    "source": "iso14756",
    "target": "latency"
  },
  {
    "source": "iso14756",
    "target": "performance"
  },
  {
    "source": "iso14756",
    "target": "reliability"
  },
  {
    "source": "iso14756",
    "target": "resource-utilization"
  },
  {
    "source": "iso14756",
    "target": "throughput"
  },
  {
    "source": "iso14756",
    "target": "time-behaviour"
  },
  {
    "source": "iso14756",
    "target": "efficient"
  },
  {
    "source": "iso14756",
    "target": "reliable"
  },
  {
    "source": "iso14756",
    "target": "usable"
  },
  {
    "source": "iso14756",
    "target": "operable"
  },
  {
    "source": "iso15408",
    "target": "compliance"
  },
  {
    "source": "iso15408",
    "target": "confidentiality"
  },
  {
    "source": "iso15408",
    "target": "data-integrity"
  },
  {
    "source": "iso15408",
    "target": "integrity"
  },
  {
    "source": "iso15408",
    "target": "reliability"
  },
  {
    "source": "iso15408",
    "target": "testability"
  },
  {
    "source": "iso15408",
    "target": "traceability"
  },
  {
    "source": "iso15408",
    "target": "security"
  },
  {
    "source": "iso15408",
    "target": "auditability"
  },
  {
    "source": "iso15408",
    "target": "authenticity"
  },
  {
    "source": "iso15408",
    "target": "availability"
  },
  {
    "source": "iso15408",
    "target": "secure"
  },
  {
    "source": "iso15408",
    "target": "safe"
  },
  {
    "source": "iso15408",
    "target": "usable"
  },
  {
    "source": "iso15408",
    "target": "reliable"
  },
  {
    "source": "iso15408",
    "target": "efficient"
  },
  {
    "source": "iso15408",
    "target": "suitable"
  },
  {
    "source": "iso15408",
    "target": "maintainable"
  },
  {
    "source": "iso15408",
    "target": "operable"
  },
  {
    "source": "iso24028",
    "target": "calibration"
  },
  {
    "source": "iso24028",
    "target": "compliance"
  },
  {
    "source": "iso24028",
    "target": "drift-detectability"
  },
  {
    "source": "iso24028",
    "target": "fairness"
  },
  {
    "source": "iso24028",
    "target": "explainability"
  },
  {
    "source": "iso24028",
    "target": "groundedness"
  },
  {
    "source": "iso24028",
    "target": "maintainability"
  },
  {
    "source": "iso24028",
    "target": "model-transparency"
  },
  {
    "source": "iso24028",
    "target": "privacy"
  },
  {
    "source": "iso24028",
    "target": "reliability"
  },
  {
    "source": "iso24028",
    "target": "robustness"
  },
  {
    "source": "iso24028",
    "target": "testability"
  },
  {
    "source": "iso24028",
    "target": "transparency"
  },
  {
    "source": "iso24028",
    "target": "safety"
  },
  {
    "source": "iso24028",
    "target": "security"
  },
  {
    "source": "iso24028",
    "target": "accountability"
  },
  {
    "source": "iso24028",
    "target": "accuracy"
  },
  {
    "source": "iso24028",
    "target": "availability"
  },
  {
    "source": "iso24028",
    "target": "reliable"
  },
  {
    "source": "iso24028",
    "target": "suitable"
  },
  {
    "source": "iso24028",
    "target": "secure"
  },
  {
    "source": "iso24028",
    "target": "safe"
  },
  {
    "source": "iso24028",
    "target": "usable"
  },
  {
    "source": "iso24028",
    "target": "efficient"
  },
  {
    "source": "iso24028",
    "target": "operable"
  },
  {
    "source": "iso24028",
    "target": "maintainable"
  },
  {
    "source": "iso25010",
    "target": "capacity"
  },
  {
    "source": "iso25010",
    "target": "co-existence"
  },
  {
    "source": "iso25010",
    "target": "compatibility"
  },
  {
    "source": "iso25010",
    "target": "confidentiality"
  },
  {
    "source": "iso25010",
    "target": "fail-safe"
  },
  {
    "source": "iso25010",
    "target": "fault-tolerance"
  },
  {
    "source": "iso25010",
    "target": "faultlessness"
  },
  {
    "source": "iso25010",
    "target": "flexibility"
  },
  {
    "source": "iso25010",
    "target": "functional-appropriateness"
  },
  {
    "source": "iso25010",
    "target": "functional-completeness"
  },
  {
    "source": "iso25010",
    "target": "functional-suitability"
  },
  {
    "source": "iso25010",
    "target": "hazard-warning"
  },
  {
    "source": "iso25010",
    "target": "inclusivity"
  },
  {
    "source": "iso25010",
    "target": "installability"
  },
  {
    "source": "iso25010",
    "target": "integrity"
  },
  {
    "source": "iso25010",
    "target": "interaction-capability"
  },
  {
    "source": "iso25010",
    "target": "interoperability"
  },
  {
    "source": "iso25010",
    "target": "learnability"
  },
  {
    "source": "iso25010",
    "target": "maintainability"
  },
  {
    "source": "iso25010",
    "target": "modifiability"
  },
  {
    "source": "iso25010",
    "target": "modularity"
  },
  {
    "source": "iso25010",
    "target": "non-repudiation"
  },
  {
    "source": "iso25010",
    "target": "operability"
  },
  {
    "source": "iso25010",
    "target": "operational-constraint"
  },
  {
    "source": "iso25010",
    "target": "recoverability"
  },
  {
    "source": "iso25010",
    "target": "reliability"
  },
  {
    "source": "iso25010",
    "target": "replaceability"
  },
  {
    "source": "iso25010",
    "target": "resistance"
  },
  {
    "source": "iso25010",
    "target": "resource-utilization"
  },
  {
    "source": "iso25010",
    "target": "reusability"
  },
  {
    "source": "iso25010",
    "target": "risk-identification"
  },
  {
    "source": "iso25010",
    "target": "testability"
  },
  {
    "source": "iso25010",
    "target": "time-behaviour"
  },
  {
    "source": "iso25010",
    "target": "safe-integration"
  },
  {
    "source": "iso25010",
    "target": "safety"
  },
  {
    "source": "iso25010",
    "target": "scalability"
  },
  {
    "source": "iso25010",
    "target": "security"
  },
  {
    "source": "iso25010",
    "target": "self-descriptiveness"
  },
  {
    "source": "iso25010",
    "target": "updateability"
  },
  {
    "source": "iso25010",
    "target": "user-assistance"
  },
  {
    "source": "iso25010",
    "target": "user-engagement"
  },
  {
    "source": "iso25010",
    "target": "user-error-protection"
  },
  {
    "source": "iso25010",
    "target": "accountability"
  },
  {
    "source": "iso25010",
    "target": "adaptability"
  },
  {
    "source": "iso25010",
    "target": "analysability"
  },
  {
    "source": "iso25010",
    "target": "appropriateness-recognizability"
  },
  {
    "source": "iso25010",
    "target": "authenticity"
  },
  {
    "source": "iso25010",
    "target": "availability"
  },
  {
    "source": "iso25010",
    "target": "efficient"
  },
  {
    "source": "iso25010",
    "target": "reliable"
  },
  {
    "source": "iso25010",
    "target": "flexible"
  },
  {
    "source": "iso25010",
    "target": "usable"
  },
  {
    "source": "iso25010",
    "target": "operable"
  },
  {
    "source": "iso25010",
    "target": "secure"
  },
  {
    "source": "iso25010",
    "target": "safe"
  },
  {
    "source": "iso25010",
    "target": "suitable"
  },
  {
    "source": "iso25010",
    "target": "maintainable"
  },
  {
    "source": "iso25012",
    "target": "completeness"
  },
  {
    "source": "iso25012",
    "target": "data-quality"
  },
  {
    "source": "iso25012",
    "target": "reliable"
  },
  {
    "source": "iso25012",
    "target": "suitable"
  },
  {
    "source": "iso25012",
    "target": "usable"
  },
  {
    "source": "iso25019",
    "target": "compliance"
  },
  {
    "source": "iso25019",
    "target": "dependability"
  },
  {
    "source": "iso25019",
    "target": "effectiveness"
  },
  {
    "source": "iso25019",
    "target": "efficiency"
  },
  {
    "source": "iso25019",
    "target": "safety"
  },
  {
    "source": "iso25019",
    "target": "suitability"
  },
  {
    "source": "iso25019",
    "target": "usability"
  },
  {
    "source": "iso25019",
    "target": "user-experience"
  },
  {
    "source": "iso25019",
    "target": "accessibility"
  },
  {
    "source": "iso25019",
    "target": "secure"
  },
  {
    "source": "iso25019",
    "target": "safe"
  },
  {
    "source": "iso25019",
    "target": "usable"
  },
  {
    "source": "iso25019",
    "target": "reliable"
  },
  {
    "source": "iso25019",
    "target": "efficient"
  },
  {
    "source": "iso25019",
    "target": "suitable"
  },
  {
    "source": "iso25019",
    "target": "operable"
  },
  {
    "source": "iso25022",
    "target": "effectiveness"
  },
  {
    "source": "iso25022",
    "target": "efficiency"
  },
  {
    "source": "iso25022",
    "target": "usable"
  },
  {
    "source": "iso25022",
    "target": "suitable"
  },
  {
    "source": "iso25022",
    "target": "efficient"
  },
  {
    "source": "iso25024",
    "target": "completeness"
  },
  {
    "source": "iso25024",
    "target": "compliance"
  },
  {
    "source": "iso25024",
    "target": "confidentiality"
  },
  {
    "source": "iso25024",
    "target": "consistency"
  },
  {
    "source": "iso25024",
    "target": "credibility"
  },
  {
    "source": "iso25024",
    "target": "data-integrity"
  },
  {
    "source": "iso25024",
    "target": "integrity"
  },
  {
    "source": "iso25024",
    "target": "interoperability"
  },
  {
    "source": "iso25024",
    "target": "portability"
  },
  {
    "source": "iso25024",
    "target": "precision"
  },
  {
    "source": "iso25024",
    "target": "recoverability"
  },
  {
    "source": "iso25024",
    "target": "reliability"
  },
  {
    "source": "iso25024",
    "target": "timeliness"
  },
  {
    "source": "iso25024",
    "target": "traceability"
  },
  {
    "source": "iso25024",
    "target": "understandability"
  },
  {
    "source": "iso25024",
    "target": "accuracy"
  },
  {
    "source": "iso25024",
    "target": "accessibility"
  },
  {
    "source": "iso25024",
    "target": "availability"
  },
  {
    "source": "iso25024",
    "target": "reliable"
  },
  {
    "source": "iso25024",
    "target": "suitable"
  },
  {
    "source": "iso25024",
    "target": "secure"
  },
  {
    "source": "iso25024",
    "target": "safe"
  },
  {
    "source": "iso25024",
    "target": "usable"
  },
  {
    "source": "iso25024",
    "target": "efficient"
  },
  {
    "source": "iso25024",
    "target": "operable"
  },
  {
    "source": "iso25024",
    "target": "flexible"
  },
  {
    "source": "iso25059",
    "target": "controllability"
  },
  {
    "source": "iso25059",
    "target": "correctness"
  },
  {
    "source": "iso25059",
    "target": "functional-adaptability"
  },
  {
    "source": "iso25059",
    "target": "intervenability"
  },
  {
    "source": "iso25059",
    "target": "robustness"
  },
  {
    "source": "iso25059",
    "target": "transparency"
  },
  {
    "source": "iso25059",
    "target": "sustainability"
  },
  {
    "source": "iso25059",
    "target": "usable"
  },
  {
    "source": "iso25059",
    "target": "operable"
  },
  {
    "source": "iso25059",
    "target": "reliable"
  },
  {
    "source": "iso25059",
    "target": "suitable"
  },
  {
    "source": "iso25059",
    "target": "safe"
  },
  {
    "source": "iso25059",
    "target": "efficient"
  },
  {
    "source": "iso26262",
    "target": "certifiability"
  },
  {
    "source": "iso26262",
    "target": "compliance"
  },
  {
    "source": "iso26262",
    "target": "configurability"
  },
  {
    "source": "iso26262",
    "target": "dependability"
  },
  {
    "source": "iso26262",
    "target": "fault-isolation"
  },
  {
    "source": "iso26262",
    "target": "fault-tolerance"
  },
  {
    "source": "iso26262",
    "target": "integrity"
  },
  {
    "source": "iso26262",
    "target": "maintainability"
  },
  {
    "source": "iso26262",
    "target": "observability"
  },
  {
    "source": "iso26262",
    "target": "portability"
  },
  {
    "source": "iso26262",
    "target": "reliability"
  },
  {
    "source": "iso26262",
    "target": "robustness"
  },
  {
    "source": "iso26262",
    "target": "testability"
  },
  {
    "source": "iso26262",
    "target": "traceability"
  },
  {
    "source": "iso26262",
    "target": "safety"
  },
  {
    "source": "iso26262",
    "target": "security"
  },
  {
    "source": "iso26262",
    "target": "auditability"
  },
  {
    "source": "iso26262",
    "target": "availability"
  },
  {
    "source": "iso26262",
    "target": "suitable"
  },
  {
    "source": "iso26262",
    "target": "reliable"
  },
  {
    "source": "iso26262",
    "target": "safe"
  },
  {
    "source": "iso26262",
    "target": "secure"
  },
  {
    "source": "iso26262",
    "target": "usable"
  },
  {
    "source": "iso26262",
    "target": "efficient"
  },
  {
    "source": "iso26262",
    "target": "flexible"
  },
  {
    "source": "iso26262",
    "target": "maintainable"
  },
  {
    "source": "iso26262",
    "target": "operable"
  },
  {
    "source": "iso26514",
    "target": "clarity"
  },
  {
    "source": "iso26514",
    "target": "conciseness"
  },
  {
    "source": "iso26514",
    "target": "consistency"
  },
  {
    "source": "iso26514",
    "target": "correctness"
  },
  {
    "source": "iso26514",
    "target": "understandability"
  },
  {
    "source": "iso26514",
    "target": "usability"
  },
  {
    "source": "iso26514",
    "target": "accessibility"
  },
  {
    "source": "iso26514",
    "target": "usable"
  },
  {
    "source": "iso26514",
    "target": "reliable"
  },
  {
    "source": "iso26514",
    "target": "efficient"
  },
  {
    "source": "iso26514",
    "target": "suitable"
  },
  {
    "source": "iso26514",
    "target": "operable"
  },
  {
    "source": "iso27001",
    "target": "compliance"
  },
  {
    "source": "iso27001",
    "target": "confidentiality"
  },
  {
    "source": "iso27001",
    "target": "data-integrity"
  },
  {
    "source": "iso27001",
    "target": "governability"
  },
  {
    "source": "iso27001",
    "target": "integrity"
  },
  {
    "source": "iso27001",
    "target": "non-repudiation"
  },
  {
    "source": "iso27001",
    "target": "reliability"
  },
  {
    "source": "iso27001",
    "target": "security"
  },
  {
    "source": "iso27001",
    "target": "accountability"
  },
  {
    "source": "iso27001",
    "target": "authenticity"
  },
  {
    "source": "iso27001",
    "target": "availability"
  },
  {
    "source": "iso27001",
    "target": "secure"
  },
  {
    "source": "iso27001",
    "target": "safe"
  },
  {
    "source": "iso27001",
    "target": "usable"
  },
  {
    "source": "iso27001",
    "target": "reliable"
  },
  {
    "source": "iso27001",
    "target": "efficient"
  },
  {
    "source": "iso27001",
    "target": "suitable"
  },
  {
    "source": "iso27001",
    "target": "operable"
  },
  {
    "source": "iso29100",
    "target": "consent-management"
  },
  {
    "source": "iso29100",
    "target": "data-minimization"
  },
  {
    "source": "iso29100",
    "target": "data-protection"
  },
  {
    "source": "iso29100",
    "target": "interoperability"
  },
  {
    "source": "iso29100",
    "target": "security"
  },
  {
    "source": "iso29100",
    "target": "secure"
  },
  {
    "source": "iso29100",
    "target": "usable"
  },
  {
    "source": "iso29100",
    "target": "operable"
  },
  {
    "source": "iso29100",
    "target": "reliable"
  },
  {
    "source": "iso29119",
    "target": "compliance"
  },
  {
    "source": "iso29119",
    "target": "correctness"
  },
  {
    "source": "iso29119",
    "target": "maintainability"
  },
  {
    "source": "iso29119",
    "target": "reliability"
  },
  {
    "source": "iso29119",
    "target": "reproducibility"
  },
  {
    "source": "iso29119",
    "target": "testability"
  },
  {
    "source": "iso29119",
    "target": "verifiability"
  },
  {
    "source": "iso29119",
    "target": "secure"
  },
  {
    "source": "iso29119",
    "target": "safe"
  },
  {
    "source": "iso29119",
    "target": "usable"
  },
  {
    "source": "iso29119",
    "target": "reliable"
  },
  {
    "source": "iso29119",
    "target": "efficient"
  },
  {
    "source": "iso29119",
    "target": "suitable"
  },
  {
    "source": "iso29119",
    "target": "maintainable"
  },
  {
    "source": "iso38500",
    "target": "compliance"
  },
  {
    "source": "iso38500",
    "target": "governability"
  },
  {
    "source": "iso38500",
    "target": "transparency"
  },
  {
    "source": "iso38500",
    "target": "sustainability"
  },
  {
    "source": "iso38500",
    "target": "accountability"
  },
  {
    "source": "iso38500",
    "target": "auditability"
  },
  {
    "source": "iso38500",
    "target": "secure"
  },
  {
    "source": "iso38500",
    "target": "safe"
  },
  {
    "source": "iso38500",
    "target": "usable"
  },
  {
    "source": "iso38500",
    "target": "reliable"
  },
  {
    "source": "iso38500",
    "target": "efficient"
  },
  {
    "source": "iso38500",
    "target": "suitable"
  },
  {
    "source": "iso38500",
    "target": "operable"
  },
  {
    "source": "iso42001",
    "target": "controllability"
  },
  {
    "source": "iso42001",
    "target": "data-quality"
  },
  {
    "source": "iso42001",
    "target": "fairness"
  },
  {
    "source": "iso42001",
    "target": "explainability"
  },
  {
    "source": "iso42001",
    "target": "governability"
  },
  {
    "source": "iso42001",
    "target": "model-transparency"
  },
  {
    "source": "iso42001",
    "target": "transparency"
  },
  {
    "source": "iso42001",
    "target": "security"
  },
  {
    "source": "iso42001",
    "target": "accountability"
  },
  {
    "source": "iso42001",
    "target": "usable"
  },
  {
    "source": "iso42001",
    "target": "operable"
  },
  {
    "source": "iso42001",
    "target": "reliable"
  },
  {
    "source": "iso42001",
    "target": "suitable"
  },
  {
    "source": "iso42001",
    "target": "safe"
  },
  {
    "source": "iso42001",
    "target": "secure"
  },
  {
    "source": "iso42010",
    "target": "clarity"
  },
  {
    "source": "iso42010",
    "target": "coherence"
  },
  {
    "source": "iso42010",
    "target": "communicability"
  },
  {
    "source": "iso42010",
    "target": "conciseness"
  },
  {
    "source": "iso42010",
    "target": "consistency"
  },
  {
    "source": "iso42010",
    "target": "functional-completeness"
  },
  {
    "source": "iso42010",
    "target": "maintainability"
  },
  {
    "source": "iso42010",
    "target": "modifiability"
  },
  {
    "source": "iso42010",
    "target": "traceability"
  },
  {
    "source": "iso42010",
    "target": "transparency"
  },
  {
    "source": "iso42010",
    "target": "self-descriptiveness"
  },
  {
    "source": "iso42010",
    "target": "understandability"
  },
  {
    "source": "iso42010",
    "target": "verifiability"
  },
  {
    "source": "iso42010",
    "target": "auditability"
  },
  {
    "source": "iso42010",
    "target": "usable"
  },
  {
    "source": "iso42010",
    "target": "reliable"
  },
  {
    "source": "iso42010",
    "target": "maintainable"
  },
  {
    "source": "iso42010",
    "target": "efficient"
  },
  {
    "source": "iso42010",
    "target": "suitable"
  },
  {
    "source": "iso42010",
    "target": "flexible"
  },
  {
    "source": "iso42010",
    "target": "operable"
  },
  {
    "source": "iso42030",
    "target": "clarity"
  },
  {
    "source": "iso42030",
    "target": "coherence"
  },
  {
    "source": "iso42030",
    "target": "communicability"
  },
  {
    "source": "iso42030",
    "target": "compatibility"
  },
  {
    "source": "iso42030",
    "target": "consistency"
  },
  {
    "source": "iso42030",
    "target": "flexibility"
  },
  {
    "source": "iso42030",
    "target": "functional-completeness"
  },
  {
    "source": "iso42030",
    "target": "governability"
  },
  {
    "source": "iso42030",
    "target": "interoperability"
  },
  {
    "source": "iso42030",
    "target": "maintainability"
  },
  {
    "source": "iso42030",
    "target": "modularity"
  },
  {
    "source": "iso42030",
    "target": "performance"
  },
  {
    "source": "iso42030",
    "target": "reliability"
  },
  {
    "source": "iso42030",
    "target": "resilience"
  },
  {
    "source": "iso42030",
    "target": "time-to-market"
  },
  {
    "source": "iso42030",
    "target": "traceability"
  },
  {
    "source": "iso42030",
    "target": "transparency"
  },
  {
    "source": "iso42030",
    "target": "scalability"
  },
  {
    "source": "iso42030",
    "target": "security"
  },
  {
    "source": "iso42030",
    "target": "sustainability"
  },
  {
    "source": "iso42030",
    "target": "understandability"
  },
  {
    "source": "iso42030",
    "target": "accountability"
  },
  {
    "source": "iso42030",
    "target": "analysability"
  },
  {
    "source": "iso42030",
    "target": "auditability"
  },
  {
    "source": "iso42030",
    "target": "usable"
  },
  {
    "source": "iso42030",
    "target": "reliable"
  },
  {
    "source": "iso42030",
    "target": "maintainable"
  },
  {
    "source": "iso42030",
    "target": "operable"
  },
  {
    "source": "iso42030",
    "target": "efficient"
  },
  {
    "source": "iso42030",
    "target": "flexible"
  },
  {
    "source": "iso42030",
    "target": "suitable"
  },
  {
    "source": "iso42030",
    "target": "secure"
  },
  {
    "source": "iso5055",
    "target": "maintainability"
  },
  {
    "source": "iso5055",
    "target": "reliability"
  },
  {
    "source": "iso5055",
    "target": "security"
  },
  {
    "source": "iso5055",
    "target": "maintainable"
  },
  {
    "source": "iso5055",
    "target": "reliable"
  },
  {
    "source": "iso5055",
    "target": "secure"
  },
  {
    "source": "iso8000",
    "target": "completeness"
  },
  {
    "source": "iso8000",
    "target": "consistency"
  },
  {
    "source": "iso8000",
    "target": "correctness"
  },
  {
    "source": "iso8000",
    "target": "data-integrity"
  },
  {
    "source": "iso8000",
    "target": "data-quality"
  },
  {
    "source": "iso8000",
    "target": "traceability"
  },
  {
    "source": "iso8000",
    "target": "accuracy"
  },
  {
    "source": "iso8000",
    "target": "reliable"
  },
  {
    "source": "iso8000",
    "target": "suitable"
  },
  {
    "source": "iso8000",
    "target": "usable"
  },
  {
    "source": "iso8000",
    "target": "efficient"
  },
  {
    "source": "iso8000",
    "target": "secure"
  },
  {
    "source": "iso8000",
    "target": "operable"
  },
  {
    "source": "isoiec12792",
    "target": "model-transparency"
  },
  {
    "source": "isoiec12792",
    "target": "transparency"
  },
  {
    "source": "isoiec12792",
    "target": "reliable"
  },
  {
    "source": "isoiec12792",
    "target": "suitable"
  },
  {
    "source": "isoiec22989",
    "target": "bias-mitigation"
  },
  {
    "source": "isoiec22989",
    "target": "data-quality"
  },
  {
    "source": "isoiec22989",
    "target": "fairness"
  },
  {
    "source": "isoiec22989",
    "target": "explainability"
  },
  {
    "source": "isoiec22989",
    "target": "maintainability"
  },
  {
    "source": "isoiec22989",
    "target": "model-transparency"
  },
  {
    "source": "isoiec22989",
    "target": "privacy"
  },
  {
    "source": "isoiec22989",
    "target": "reliability"
  },
  {
    "source": "isoiec22989",
    "target": "resilience"
  },
  {
    "source": "isoiec22989",
    "target": "robustness"
  },
  {
    "source": "isoiec22989",
    "target": "traceability"
  },
  {
    "source": "isoiec22989",
    "target": "transparency"
  },
  {
    "source": "isoiec22989",
    "target": "safety"
  },
  {
    "source": "isoiec22989",
    "target": "security"
  },
  {
    "source": "isoiec22989",
    "target": "usability"
  },
  {
    "source": "isoiec22989",
    "target": "reliable"
  },
  {
    "source": "isoiec22989",
    "target": "safe"
  },
  {
    "source": "isoiec22989",
    "target": "suitable"
  },
  {
    "source": "isoiec22989",
    "target": "usable"
  },
  {
    "source": "isoiec22989",
    "target": "maintainable"
  },
  {
    "source": "isoiec22989",
    "target": "secure"
  },
  {
    "source": "isoiec22989",
    "target": "operable"
  },
  {
    "source": "jitter",
    "target": "efficient"
  },
  {
    "source": "jitter",
    "target": "reliable"
  },
  {
    "source": "jitter",
    "target": "performance"
  },
  {
    "source": "jitter",
    "target": "latency"
  },
  {
    "source": "jitter",
    "target": "predictability"
  },
  {
    "source": "keep-data-on-error",
    "target": "reliability"
  },
  {
    "source": "keep-data-on-error",
    "target": "robustness"
  },
  {
    "source": "keep-data-on-error",
    "target": "ease-of-use"
  },
  {
    "source": "keep-data-on-error",
    "target": "user-experience"
  },
  {
    "source": "keep-data-on-error",
    "target": "interaction-capability"
  },
  {
    "source": "latency",
    "target": "efficient"
  },
  {
    "source": "latency",
    "target": "usable"
  },
  {
    "source": "latency",
    "target": "operable"
  },
  {
    "source": "latency",
    "target": "performance"
  },
  {
    "source": "latency",
    "target": "time-behaviour"
  },
  {
    "source": "lead-time-for-changes",
    "target": "operable"
  },
  {
    "source": "lead-time-for-changes",
    "target": "controllability"
  },
  {
    "source": "lead-time-for-changes",
    "target": "operability"
  },
  {
    "source": "lead-time-for-changes",
    "target": "testability"
  },
  {
    "source": "lead-time-for-changes",
    "target": "deployability"
  },
  {
    "source": "learnability",
    "target": "usable"
  },
  {
    "source": "learnability",
    "target": "operable"
  },
  {
    "source": "learnability",
    "target": "usability"
  },
  {
    "source": "learnability",
    "target": "user-error-protection"
  },
  {
    "source": "learnability",
    "target": "user-engagement"
  },
  {
    "source": "learnability",
    "target": "conciseness"
  },
  {
    "source": "learnability",
    "target": "understandability"
  },
  {
    "source": "learnability-find-article",
    "target": "usability"
  },
  {
    "source": "learnability-find-article",
    "target": "user-experience"
  },
  {
    "source": "least-privilege",
    "target": "secure"
  },
  {
    "source": "least-privilege",
    "target": "security"
  },
  {
    "source": "least-privilege",
    "target": "confidentiality"
  },
  {
    "source": "least-privilege",
    "target": "integrity"
  },
  {
    "source": "least-privilege",
    "target": "access-control"
  },
  {
    "source": "least-privilege",
    "target": "compliance"
  },
  {
    "source": "least-privilege",
    "target": "fine-grained-authorization"
  },
  {
    "source": "legal-requirements",
    "target": "usable"
  },
  {
    "source": "legal-requirements",
    "target": "operable"
  },
  {
    "source": "legal-requirements",
    "target": "accountability"
  },
  {
    "source": "legal-requirements",
    "target": "adaptability"
  },
  {
    "source": "legal-requirements",
    "target": "operational-constraint"
  },
  {
    "source": "legal-requirements",
    "target": "correctness"
  },
  {
    "source": "legal-requirements",
    "target": "compliance"
  },
  {
    "source": "legal-requirements",
    "target": "auditability"
  },
  {
    "source": "legal-requirements",
    "target": "privacy"
  },
  {
    "source": "legibility",
    "target": "usable"
  },
  {
    "source": "legibility",
    "target": "usability"
  },
  {
    "source": "legibility",
    "target": "understandability"
  },
  {
    "source": "limit-event-response",
    "target": "efficient"
  },
  {
    "source": "limit-event-response",
    "target": "reliable"
  },
  {
    "source": "limit-event-response",
    "target": "stability"
  },
  {
    "source": "limit-event-response",
    "target": "time-behaviour"
  },
  {
    "source": "limit-event-response",
    "target": "resource-efficiency"
  },
  {
    "source": "limit-event-response",
    "target": "energy-efficiency"
  },
  {
    "source": "local-explainability",
    "target": "explainability"
  },
  {
    "source": "localizability",
    "target": "flexible"
  },
  {
    "source": "localizability",
    "target": "usable"
  },
  {
    "source": "localizability",
    "target": "adaptability"
  },
  {
    "source": "localizability",
    "target": "modifiability"
  },
  {
    "source": "localizability",
    "target": "maintainability"
  },
  {
    "source": "localizability",
    "target": "internationalization"
  },
  {
    "source": "localizability",
    "target": "internationalization"
  },
  {
    "source": "localizable-to-n-languages",
    "target": "flexibility"
  },
  {
    "source": "localizable-to-n-languages",
    "target": "maintainability"
  },
  {
    "source": "localizable-to-n-languages",
    "target": "modifiability"
  },
  {
    "source": "localizable-to-n-languages",
    "target": "adaptability"
  },
  {
    "source": "localizable-to-n-languages",
    "target": "accessibility"
  },
  {
    "source": "localizable-to-n-languages",
    "target": "localizability"
  },
  {
    "source": "localizable-to-n-languages",
    "target": "internationalization"
  },
  {
    "source": "localizable-to-n-languages",
    "target": "internationalization"
  },
  {
    "source": "long-running-without-reboot",
    "target": "mean-time-between-failures"
  },
  {
    "source": "long-running-without-reboot",
    "target": "stability"
  },
  {
    "source": "long-running-without-reboot",
    "target": "reliability"
  },
  {
    "source": "long-running-without-reboot",
    "target": "availability"
  },
  {
    "source": "long-running-without-reboot",
    "target": "availability"
  },
  {
    "source": "longevity",
    "target": "reliable"
  },
  {
    "source": "longevity",
    "target": "flexible"
  },
  {
    "source": "longevity",
    "target": "maintainable"
  },
  {
    "source": "longevity",
    "target": "reliability"
  },
  {
    "source": "longevity",
    "target": "adaptability"
  },
  {
    "source": "longevity",
    "target": "modifiability"
  },
  {
    "source": "loose-coupling",
    "target": "efficient"
  },
  {
    "source": "loose-coupling",
    "target": "suitable"
  },
  {
    "source": "loose-coupling",
    "target": "maintainable"
  },
  {
    "source": "loose-coupling",
    "target": "coherence"
  },
  {
    "source": "loose-coupling",
    "target": "modularity"
  },
  {
    "source": "loose-coupling",
    "target": "cohesion"
  },
  {
    "source": "low-change-failure-rate",
    "target": "change-failure-rate"
  },
  {
    "source": "low-change-failure-rate",
    "target": "reliability"
  },
  {
    "source": "low-change-failure-rate",
    "target": "devops-metrics"
  },
  {
    "source": "low-effort-deployment",
    "target": "compatibility"
  },
  {
    "source": "low-effort-deployment",
    "target": "interoperability"
  },
  {
    "source": "low-effort-deployment",
    "target": "portability"
  },
  {
    "source": "low-impact-diagnosis",
    "target": "efficiency"
  },
  {
    "source": "low-impact-diagnosis",
    "target": "time-behaviour"
  },
  {
    "source": "low-impact-diagnosis",
    "target": "resource-efficiency"
  },
  {
    "source": "luggage-routing",
    "target": "flexibility"
  },
  {
    "source": "luggage-routing",
    "target": "changeability"
  },
  {
    "source": "luggage-routing",
    "target": "adaptability"
  },
  {
    "source": "luggage-routing",
    "target": "configurability"
  },
  {
    "source": "maintainability",
    "target": "maintainable"
  },
  {
    "source": "maintainability",
    "target": "flexibility"
  },
  {
    "source": "maintainability",
    "target": "adaptability"
  },
  {
    "source": "maintainability",
    "target": "changeability"
  },
  {
    "source": "maintainability",
    "target": "configurability"
  },
  {
    "source": "maintainability",
    "target": "modularity"
  },
  {
    "source": "maintainable",
    "target": "quality-root"
  },
  {
    "source": "maintainable-checking-strategy",
    "target": "efficiency"
  },
  {
    "source": "maintainable-checking-strategy",
    "target": "maintainability"
  },
  {
    "source": "manage-event-arrival",
    "target": "efficient"
  },
  {
    "source": "manage-event-arrival",
    "target": "reliable"
  },
  {
    "source": "manage-event-arrival",
    "target": "latency"
  },
  {
    "source": "manage-event-arrival",
    "target": "resource-efficiency"
  },
  {
    "source": "manage-event-arrival",
    "target": "energy-efficiency"
  },
  {
    "source": "manage-event-arrival",
    "target": "stability"
  },
  {
    "source": "mean-time-between-failures",
    "target": "operable"
  },
  {
    "source": "mean-time-between-failures",
    "target": "controllability"
  },
  {
    "source": "mean-time-between-failures",
    "target": "operability"
  },
  {
    "source": "mean-time-between-failures",
    "target": "testability"
  },
  {
    "source": "mean-time-between-failures",
    "target": "analysability"
  },
  {
    "source": "mean-time-between-failures",
    "target": "devops-metrics"
  },
  {
    "source": "mean-time-between-failures",
    "target": "mean-time-to-recovery"
  },
  {
    "source": "mean-time-to-recovery",
    "target": "operable"
  },
  {
    "source": "mean-time-to-recovery",
    "target": "suitable"
  },
  {
    "source": "mean-time-to-recovery",
    "target": "controllability"
  },
  {
    "source": "mean-time-to-recovery",
    "target": "operability"
  },
  {
    "source": "mean-time-to-recovery",
    "target": "testability"
  },
  {
    "source": "mean-time-to-recovery",
    "target": "analysability"
  },
  {
    "source": "mean-time-to-recovery",
    "target": "deployability"
  },
  {
    "source": "mean-time-to-recovery",
    "target": "devops-metrics"
  },
  {
    "source": "memory-usage",
    "target": "efficient"
  },
  {
    "source": "memory-usage",
    "target": "efficiency"
  },
  {
    "source": "memory-usage",
    "target": "capacity"
  },
  {
    "source": "memory-usage",
    "target": "time-behaviour"
  },
  {
    "source": "memory-usage",
    "target": "resource-utilization"
  },
  {
    "source": "microservice-architecture",
    "target": "flexible"
  },
  {
    "source": "microservice-architecture",
    "target": "operable"
  },
  {
    "source": "microservice-architecture",
    "target": "deployability"
  },
  {
    "source": "microservice-architecture",
    "target": "scalability"
  },
  {
    "source": "microservice-architecture",
    "target": "evolvability"
  },
  {
    "source": "microservice-architecture",
    "target": "autonomy"
  },
  {
    "source": "microservice-architecture",
    "target": "fault-isolation"
  },
  {
    "source": "microservice-architecture",
    "target": "self-contained-systems"
  },
  {
    "source": "minimize-jitter",
    "target": "jitter"
  },
  {
    "source": "minimize-jitter",
    "target": "predictability"
  },
  {
    "source": "minimize-jitter",
    "target": "latency"
  },
  {
    "source": "misra-c",
    "target": "flexibility"
  },
  {
    "source": "misra-c",
    "target": "efficiency"
  },
  {
    "source": "misra-c",
    "target": "integrity"
  },
  {
    "source": "misra-c",
    "target": "maintainability"
  },
  {
    "source": "misra-c",
    "target": "portability"
  },
  {
    "source": "misra-c",
    "target": "predictability"
  },
  {
    "source": "misra-c",
    "target": "reliability"
  },
  {
    "source": "misra-c",
    "target": "robustness"
  },
  {
    "source": "misra-c",
    "target": "testability"
  },
  {
    "source": "misra-c",
    "target": "safety"
  },
  {
    "source": "misra-c",
    "target": "security"
  },
  {
    "source": "misra-c",
    "target": "understandability"
  },
  {
    "source": "misra-c",
    "target": "analysability"
  },
  {
    "source": "misra-c",
    "target": "auditability"
  },
  {
    "source": "misra-c",
    "target": "flexible"
  },
  {
    "source": "misra-c",
    "target": "efficient"
  },
  {
    "source": "misra-c",
    "target": "secure"
  },
  {
    "source": "misra-c",
    "target": "maintainable"
  },
  {
    "source": "misra-c",
    "target": "operable"
  },
  {
    "source": "misra-c",
    "target": "reliable"
  },
  {
    "source": "misra-c",
    "target": "suitable"
  },
  {
    "source": "misra-c",
    "target": "safe"
  },
  {
    "source": "misra-c",
    "target": "usable"
  },
  {
    "source": "model-transparency",
    "target": "reliable"
  },
  {
    "source": "model-transparency",
    "target": "suitable"
  },
  {
    "source": "model-transparency",
    "target": "transparency"
  },
  {
    "source": "model-transparency",
    "target": "explainability"
  },
  {
    "source": "model-transparency",
    "target": "traceability"
  },
  {
    "source": "model-transparency",
    "target": "accountability"
  },
  {
    "source": "model-transparency",
    "target": "data-quality"
  },
  {
    "source": "modifiability",
    "target": "maintainable"
  },
  {
    "source": "modifiability",
    "target": "flexible"
  },
  {
    "source": "modifiability",
    "target": "flexibility"
  },
  {
    "source": "modifiability",
    "target": "adaptability"
  },
  {
    "source": "modifiability",
    "target": "changeability"
  },
  {
    "source": "modifiability",
    "target": "configurability"
  },
  {
    "source": "modifiability",
    "target": "themability"
  },
  {
    "source": "modular-system-for-data-analysis",
    "target": "composability"
  },
  {
    "source": "modular-system-for-data-analysis",
    "target": "modularity"
  },
  {
    "source": "modular-system-for-data-analysis",
    "target": "extensibility"
  },
  {
    "source": "modular-system-for-data-analysis",
    "target": "stability"
  },
  {
    "source": "modularity",
    "target": "maintainable"
  },
  {
    "source": "modularity",
    "target": "flexibility"
  },
  {
    "source": "modularity",
    "target": "adaptability"
  },
  {
    "source": "modularity",
    "target": "changeability"
  },
  {
    "source": "modularity",
    "target": "configurability"
  },
  {
    "source": "modularity",
    "target": "maintainability"
  },
  {
    "source": "modularity",
    "target": "modifiability"
  },
  {
    "source": "modularity",
    "target": "composability"
  },
  {
    "source": "monolith-loose-coupling-change-blast-radius",
    "target": "loose-coupling"
  },
  {
    "source": "monolith-loose-coupling-change-blast-radius",
    "target": "modularity"
  },
  {
    "source": "monolith-loose-coupling-change-blast-radius",
    "target": "modifiability"
  },
  {
    "source": "monolith-loose-coupling-change-blast-radius",
    "target": "maintainability"
  },
  {
    "source": "monolith-loose-coupling-change-blast-radius",
    "target": "cohesion"
  },
  {
    "source": "mttr-12h",
    "target": "availability"
  },
  {
    "source": "mttr-12h",
    "target": "availability"
  },
  {
    "source": "mttr-12h",
    "target": "reliability"
  },
  {
    "source": "mttr-12h",
    "target": "operability"
  },
  {
    "source": "mttr-12h",
    "target": "mean-time-to-recovery"
  },
  {
    "source": "mttr-12h",
    "target": "devops-metrics"
  },
  {
    "source": "mttr-12h",
    "target": "recoverability"
  },
  {
    "source": "multilinguality-support",
    "target": "usability"
  },
  {
    "source": "multilinguality-support",
    "target": "inclusivity"
  },
  {
    "source": "multilinguality-support",
    "target": "accessibility"
  },
  {
    "source": "multilinguality-support",
    "target": "interaction-capability"
  },
  {
    "source": "multilinguality-support",
    "target": "internationalization"
  },
  {
    "source": "multilinguality-support",
    "target": "localizability"
  },
  {
    "source": "n-version-redundancy",
    "target": "reliable"
  },
  {
    "source": "n-version-redundancy",
    "target": "safe"
  },
  {
    "source": "n-version-redundancy",
    "target": "integrity"
  },
  {
    "source": "n-version-redundancy",
    "target": "fault-tolerance"
  },
  {
    "source": "n-version-redundancy",
    "target": "correctness"
  },
  {
    "source": "near-instant-search-results",
    "target": "efficiency"
  },
  {
    "source": "near-instant-search-results",
    "target": "performance"
  },
  {
    "source": "near-instant-search-results",
    "target": "time-behaviour"
  },
  {
    "source": "near-instant-search-results",
    "target": "speed"
  },
  {
    "source": "near-instant-search-results",
    "target": "interaction-capability"
  },
  {
    "source": "new-features-introduct-no-bugs",
    "target": "predictability"
  },
  {
    "source": "new-features-introduct-no-bugs",
    "target": "reliability"
  },
  {
    "source": "new-features-introduct-no-bugs",
    "target": "changeability"
  },
  {
    "source": "new-user-completes-core-tasks-without-training",
    "target": "learnability"
  },
  {
    "source": "new-user-completes-core-tasks-without-training",
    "target": "usability"
  },
  {
    "source": "new-user-completes-core-tasks-without-training",
    "target": "user-error-protection"
  },
  {
    "source": "new-user-completes-core-tasks-without-training",
    "target": "self-descriptiveness"
  },
  {
    "source": "new-user-completes-core-tasks-without-training",
    "target": "effectiveness"
  },
  {
    "source": "nist80053",
    "target": "data-integrity"
  },
  {
    "source": "nist80053",
    "target": "governability"
  },
  {
    "source": "nist80053",
    "target": "integrity"
  },
  {
    "source": "nist80053",
    "target": "maintainability"
  },
  {
    "source": "nist80053",
    "target": "operability"
  },
  {
    "source": "nist80053",
    "target": "privacy"
  },
  {
    "source": "nist80053",
    "target": "reliability"
  },
  {
    "source": "nist80053",
    "target": "security"
  },
  {
    "source": "nist80053",
    "target": "reliable"
  },
  {
    "source": "nist80053",
    "target": "secure"
  },
  {
    "source": "nist80053",
    "target": "operable"
  },
  {
    "source": "nist80053",
    "target": "maintainable"
  },
  {
    "source": "nist80053",
    "target": "usable"
  },
  {
    "source": "nistairmf",
    "target": "calibration"
  },
  {
    "source": "nistairmf",
    "target": "controllability"
  },
  {
    "source": "nistairmf",
    "target": "drift-detectability"
  },
  {
    "source": "nistairmf",
    "target": "fairness"
  },
  {
    "source": "nistairmf",
    "target": "explainability"
  },
  {
    "source": "nistairmf",
    "target": "groundedness"
  },
  {
    "source": "nistairmf",
    "target": "model-transparency"
  },
  {
    "source": "nistairmf",
    "target": "privacy"
  },
  {
    "source": "nistairmf",
    "target": "reliability"
  },
  {
    "source": "nistairmf",
    "target": "resilience"
  },
  {
    "source": "nistairmf",
    "target": "transparency"
  },
  {
    "source": "nistairmf",
    "target": "safety"
  },
  {
    "source": "nistairmf",
    "target": "security"
  },
  {
    "source": "nistairmf",
    "target": "accountability"
  },
  {
    "source": "nistairmf",
    "target": "reliable"
  },
  {
    "source": "nistairmf",
    "target": "suitable"
  },
  {
    "source": "nistairmf",
    "target": "usable"
  },
  {
    "source": "nistairmf",
    "target": "operable"
  },
  {
    "source": "nistairmf",
    "target": "safe"
  },
  {
    "source": "nistairmf",
    "target": "secure"
  },
  {
    "source": "nistpf",
    "target": "privacy"
  },
  {
    "source": "nistpf",
    "target": "secure"
  },
  {
    "source": "non-repudiation",
    "target": "secure"
  },
  {
    "source": "non-repudiation",
    "target": "integrity"
  },
  {
    "source": "non-repudiation",
    "target": "authenticity"
  },
  {
    "source": "non-repudiation",
    "target": "security"
  },
  {
    "source": "non-repudiation",
    "target": "accountability"
  },
  {
    "source": "observability",
    "target": "operable"
  },
  {
    "source": "observability",
    "target": "analysability"
  },
  {
    "source": "observability",
    "target": "testability"
  },
  {
    "source": "observability",
    "target": "drift-detectability"
  },
  {
    "source": "on-prem-installation-ready-in-30-min",
    "target": "installability"
  },
  {
    "source": "on-prem-installation-ready-in-30-min",
    "target": "deployability"
  },
  {
    "source": "on-prem-installation-ready-in-30-min",
    "target": "operability"
  },
  {
    "source": "on-prem-installation-ready-in-30-min",
    "target": "maintainability"
  },
  {
    "source": "only-authenticated-users-can-access",
    "target": "access-control"
  },
  {
    "source": "only-authenticated-users-can-access",
    "target": "confidentiality"
  },
  {
    "source": "only-authenticated-users-can-access",
    "target": "security"
  },
  {
    "source": "only-authenticated-users-can-access",
    "target": "privacy"
  },
  {
    "source": "only-authenticated-users-can-access",
    "target": "securability"
  },
  {
    "source": "open-host-service",
    "target": "flexible"
  },
  {
    "source": "open-host-service",
    "target": "operable"
  },
  {
    "source": "open-host-service",
    "target": "interoperability"
  },
  {
    "source": "open-host-service",
    "target": "integrability"
  },
  {
    "source": "open-host-service",
    "target": "loose-coupling"
  },
  {
    "source": "open-host-service",
    "target": "evolvability"
  },
  {
    "source": "open-host-service",
    "target": "api-gateway"
  },
  {
    "source": "open-host-service",
    "target": "event-sourcing"
  },
  {
    "source": "operability",
    "target": "usable"
  },
  {
    "source": "operability",
    "target": "operable"
  },
  {
    "source": "operability",
    "target": "usability"
  },
  {
    "source": "operability",
    "target": "user-error-protection"
  },
  {
    "source": "operability",
    "target": "controllability"
  },
  {
    "source": "operability",
    "target": "robustness"
  },
  {
    "source": "operable",
    "target": "quality-root"
  },
  {
    "source": "operational-constraint",
    "target": "safe"
  },
  {
    "source": "operational-constraint",
    "target": "reliable"
  },
  {
    "source": "operational-constraint",
    "target": "availability"
  },
  {
    "source": "operational-constraint",
    "target": "robustness"
  },
  {
    "source": "operational-constraint",
    "target": "flexibility"
  },
  {
    "source": "operational-constraint",
    "target": "safety"
  },
  {
    "source": "operational-environment-requirements",
    "target": "operable"
  },
  {
    "source": "operational-environment-requirements",
    "target": "expected-physical-environment"
  },
  {
    "source": "operational-environment-requirements",
    "target": "operational-constraint"
  },
  {
    "source": "order-queue",
    "target": "fault-tolerance"
  },
  {
    "source": "order-queue",
    "target": "recoverability"
  },
  {
    "source": "order-transaction-consistency",
    "target": "transactionality"
  },
  {
    "source": "order-transaction-consistency",
    "target": "atomicity"
  },
  {
    "source": "order-transaction-consistency",
    "target": "consistency"
  },
  {
    "source": "order-transaction-consistency",
    "target": "data-integrity"
  },
  {
    "source": "owaspasvs",
    "target": "confidentiality"
  },
  {
    "source": "owaspasvs",
    "target": "data-integrity"
  },
  {
    "source": "owaspasvs",
    "target": "injection-resistance"
  },
  {
    "source": "owaspasvs",
    "target": "intrusion-detection"
  },
  {
    "source": "owaspasvs",
    "target": "intrusion-prevention"
  },
  {
    "source": "owaspasvs",
    "target": "non-repudiation"
  },
  {
    "source": "owaspasvs",
    "target": "resistance"
  },
  {
    "source": "owaspasvs",
    "target": "security"
  },
  {
    "source": "owaspasvs",
    "target": "vulnerability"
  },
  {
    "source": "owaspasvs",
    "target": "access-control"
  },
  {
    "source": "owaspasvs",
    "target": "auditability"
  },
  {
    "source": "owaspasvs",
    "target": "authenticity"
  },
  {
    "source": "owaspasvs",
    "target": "secure"
  },
  {
    "source": "owaspasvs",
    "target": "reliable"
  },
  {
    "source": "owaspasvs",
    "target": "operable"
  },
  {
    "source": "parallel-data-modification",
    "target": "performance"
  },
  {
    "source": "patient-data-quality",
    "target": "data-quality"
  },
  {
    "source": "patient-data-quality",
    "target": "accuracy"
  },
  {
    "source": "patient-data-quality",
    "target": "completeness"
  },
  {
    "source": "patient-data-quality",
    "target": "timeliness"
  },
  {
    "source": "patient-data-quality",
    "target": "integrity"
  },
  {
    "source": "patient-safety",
    "target": "safe"
  },
  {
    "source": "patient-safety",
    "target": "reliable"
  },
  {
    "source": "patient-safety",
    "target": "secure"
  },
  {
    "source": "patient-safety",
    "target": "safety"
  },
  {
    "source": "patient-safety",
    "target": "robustness"
  },
  {
    "source": "patient-safety",
    "target": "data-quality"
  },
  {
    "source": "patient-safety",
    "target": "completeness"
  },
  {
    "source": "patient-safety",
    "target": "accuracy"
  },
  {
    "source": "patient-safety",
    "target": "integrity"
  },
  {
    "source": "pcidss",
    "target": "compliance"
  },
  {
    "source": "pcidss",
    "target": "confidentiality"
  },
  {
    "source": "pcidss",
    "target": "data-integrity"
  },
  {
    "source": "pcidss",
    "target": "integrity"
  },
  {
    "source": "pcidss",
    "target": "non-repudiation"
  },
  {
    "source": "pcidss",
    "target": "security"
  },
  {
    "source": "pcidss",
    "target": "access-control"
  },
  {
    "source": "pcidss",
    "target": "accountability"
  },
  {
    "source": "pcidss",
    "target": "authenticity"
  },
  {
    "source": "pcidss",
    "target": "availability"
  },
  {
    "source": "pcidss",
    "target": "secure"
  },
  {
    "source": "pcidss",
    "target": "safe"
  },
  {
    "source": "pcidss",
    "target": "usable"
  },
  {
    "source": "pcidss",
    "target": "reliable"
  },
  {
    "source": "pcidss",
    "target": "efficient"
  },
  {
    "source": "pcidss",
    "target": "suitable"
  },
  {
    "source": "performance",
    "target": "efficient"
  },
  {
    "source": "performance",
    "target": "efficiency"
  },
  {
    "source": "performance",
    "target": "resource-efficiency"
  },
  {
    "source": "performance",
    "target": "speed"
  },
  {
    "source": "performance",
    "target": "timeliness"
  },
  {
    "source": "performance",
    "target": "timeliness"
  },
  {
    "source": "personal-data-lifecycle-protection",
    "target": "data-protection"
  },
  {
    "source": "personal-data-lifecycle-protection",
    "target": "privacy"
  },
  {
    "source": "personal-data-lifecycle-protection",
    "target": "compliance"
  },
  {
    "source": "personal-data-lifecycle-protection",
    "target": "security"
  },
  {
    "source": "personal-data-lifecycle-protection",
    "target": "auditability"
  },
  {
    "source": "personalization",
    "target": "flexible"
  },
  {
    "source": "personalization",
    "target": "customizability"
  },
  {
    "source": "plugin-architecture",
    "target": "flexible"
  },
  {
    "source": "plugin-architecture",
    "target": "extensibility"
  },
  {
    "source": "plugin-architecture",
    "target": "modifiability"
  },
  {
    "source": "plugin-architecture",
    "target": "configurability"
  },
  {
    "source": "plugin-architecture",
    "target": "reusability"
  },
  {
    "source": "plugin-architecture",
    "target": "externalized-business-rules"
  },
  {
    "source": "portability",
    "target": "flexible"
  },
  {
    "source": "portability",
    "target": "operable"
  },
  {
    "source": "portability",
    "target": "compatibility"
  },
  {
    "source": "portability",
    "target": "flexibility"
  },
  {
    "source": "portability",
    "target": "installability"
  },
  {
    "source": "portability",
    "target": "interoperability"
  },
  {
    "source": "portability",
    "target": "maintainability"
  },
  {
    "source": "portability",
    "target": "configurability"
  },
  {
    "source": "portability",
    "target": "replaceability"
  },
  {
    "source": "portable-business-data-checker",
    "target": "portability"
  },
  {
    "source": "portable-business-data-checker",
    "target": "adaptability"
  },
  {
    "source": "portable-business-data-checker",
    "target": "flexibility"
  },
  {
    "source": "precise-vehicle-orientation-gps",
    "target": "accuracy"
  },
  {
    "source": "precise-vehicle-orientation-gps",
    "target": "precision"
  },
  {
    "source": "precise-vehicle-orientation-gps",
    "target": "precision"
  },
  {
    "source": "precise-vehicle-orientation-gps",
    "target": "reliability"
  },
  {
    "source": "precise-vehicle-orientation-gps",
    "target": "correctness"
  },
  {
    "source": "precision",
    "target": "reliable"
  },
  {
    "source": "precision",
    "target": "usable"
  },
  {
    "source": "precision",
    "target": "correctness"
  },
  {
    "source": "precision",
    "target": "accuracy"
  },
  {
    "source": "precision",
    "target": "precision"
  },
  {
    "source": "predictability",
    "target": "reliable"
  },
  {
    "source": "predictability",
    "target": "reliability"
  },
  {
    "source": "predictability",
    "target": "correctness"
  },
  {
    "source": "preserve-facts-derive-interpretations",
    "target": "flexible"
  },
  {
    "source": "preserve-facts-derive-interpretations",
    "target": "maintainable"
  },
  {
    "source": "preserve-facts-derive-interpretations",
    "target": "evolvability"
  },
  {
    "source": "preserve-facts-derive-interpretations",
    "target": "auditability"
  },
  {
    "source": "preserve-facts-derive-interpretations",
    "target": "traceability"
  },
  {
    "source": "preserve-facts-derive-interpretations",
    "target": "analysability"
  },
  {
    "source": "preserve-facts-derive-interpretations",
    "target": "event-sourcing"
  },
  {
    "source": "preserve-facts-derive-interpretations",
    "target": "defer-binding"
  },
  {
    "source": "privacy",
    "target": "secure"
  },
  {
    "source": "privacy",
    "target": "security"
  },
  {
    "source": "privacy",
    "target": "confidentiality"
  },
  {
    "source": "production-anomalies-detectable-within-2-minutes",
    "target": "observability"
  },
  {
    "source": "production-anomalies-detectable-within-2-minutes",
    "target": "analysability"
  },
  {
    "source": "production-anomalies-detectable-within-2-minutes",
    "target": "debuggability"
  },
  {
    "source": "production-anomalies-detectable-within-2-minutes",
    "target": "mean-time-to-recovery"
  },
  {
    "source": "profitability",
    "target": "efficient"
  },
  {
    "source": "profitability",
    "target": "time-to-market"
  },
  {
    "source": "profitability",
    "target": "cost"
  },
  {
    "source": "profitability",
    "target": "affordability"
  },
  {
    "source": "progressive-disclosure",
    "target": "usable"
  },
  {
    "source": "progressive-disclosure",
    "target": "usability"
  },
  {
    "source": "progressive-disclosure",
    "target": "learnability"
  },
  {
    "source": "progressive-disclosure",
    "target": "accessibility"
  },
  {
    "source": "progressive-disclosure",
    "target": "user-experience"
  },
  {
    "source": "protect-data-by-security-procols",
    "target": "safety"
  },
  {
    "source": "protect-data-by-security-procols",
    "target": "cyber-security"
  },
  {
    "source": "protect-data-by-security-procols",
    "target": "security"
  },
  {
    "source": "protect-data-by-security-procols",
    "target": "security"
  },
  {
    "source": "protect-data-by-security-procols",
    "target": "patient-safety"
  },
  {
    "source": "provability",
    "target": "reliable"
  },
  {
    "source": "provability",
    "target": "safe"
  },
  {
    "source": "provability",
    "target": "explainability"
  },
  {
    "source": "provability",
    "target": "verifiability"
  },
  {
    "source": "provability",
    "target": "correctness"
  },
  {
    "source": "provable-insulin-dosage-safety",
    "target": "provability"
  },
  {
    "source": "provable-insulin-dosage-safety",
    "target": "safety"
  },
  {
    "source": "provable-insulin-dosage-safety",
    "target": "reliability"
  },
  {
    "source": "provable-insulin-dosage-safety",
    "target": "certifiability"
  },
  {
    "source": "provable-insulin-dosage-safety",
    "target": "operational-constraint"
  },
  {
    "source": "provable-railway-interlocking-routing-logic",
    "target": "provability"
  },
  {
    "source": "provable-railway-interlocking-routing-logic",
    "target": "verifiability"
  },
  {
    "source": "provable-railway-interlocking-routing-logic",
    "target": "correctness"
  },
  {
    "source": "provable-railway-interlocking-routing-logic",
    "target": "certifiability"
  },
  {
    "source": "provable-railway-interlocking-safety",
    "target": "provability"
  },
  {
    "source": "provable-railway-interlocking-safety",
    "target": "safety"
  },
  {
    "source": "provable-railway-interlocking-safety",
    "target": "reliability"
  },
  {
    "source": "provable-railway-interlocking-safety",
    "target": "certifiability"
  },
  {
    "source": "public-api-intrusion-attempts-blocked",
    "target": "intrusion-prevention"
  },
  {
    "source": "public-api-intrusion-attempts-blocked",
    "target": "intrusion-detection"
  },
  {
    "source": "public-api-intrusion-attempts-blocked",
    "target": "security"
  },
  {
    "source": "public-api-intrusion-attempts-blocked",
    "target": "availability"
  },
  {
    "source": "public-api-intrusion-attempts-blocked",
    "target": "injection-resistance"
  },
  {
    "source": "quarantine",
    "target": "reliable"
  },
  {
    "source": "quarantine",
    "target": "operable"
  },
  {
    "source": "quarantine",
    "target": "availability"
  },
  {
    "source": "quarantine",
    "target": "fault-isolation"
  },
  {
    "source": "quarantine",
    "target": "recoverability"
  },
  {
    "source": "quarantine",
    "target": "stability"
  },
  {
    "source": "quarantine",
    "target": "circuit-breaker"
  },
  {
    "source": "quarantine",
    "target": "standby-failover"
  },
  {
    "source": "query-execution-management",
    "target": "efficiency"
  },
  {
    "source": "query-execution-management",
    "target": "time-behaviour"
  },
  {
    "source": "query-execution-management",
    "target": "memory-usage"
  },
  {
    "source": "query-execution-management",
    "target": "resource-efficiency"
  },
  {
    "source": "query-execution-management",
    "target": "resource-utilization"
  },
  {
    "source": "quick-unit-tests",
    "target": "testability"
  },
  {
    "source": "quickly-locate-bugs",
    "target": "efficiency"
  },
  {
    "source": "quickly-locate-bugs",
    "target": "maintainability"
  },
  {
    "source": "rate-limiting",
    "target": "secure"
  },
  {
    "source": "rate-limiting",
    "target": "reliable"
  },
  {
    "source": "rate-limiting",
    "target": "security"
  },
  {
    "source": "rate-limiting",
    "target": "intrusion-prevention"
  },
  {
    "source": "rate-limiting",
    "target": "availability"
  },
  {
    "source": "rate-limiting",
    "target": "resilience"
  },
  {
    "source": "rate-limiting",
    "target": "stability"
  },
  {
    "source": "rate-limiting",
    "target": "manage-event-arrival"
  },
  {
    "source": "readability",
    "target": "usable"
  },
  {
    "source": "readability",
    "target": "usability"
  },
  {
    "source": "readability",
    "target": "understandability"
  },
  {
    "source": "readability",
    "target": "legibility"
  },
  {
    "source": "readability",
    "target": "code-readability"
  },
  {
    "source": "recognize-assistive-technology",
    "target": "usability"
  },
  {
    "source": "recognize-assistive-technology",
    "target": "inclusivity"
  },
  {
    "source": "recognize-assistive-technology",
    "target": "accessibility"
  },
  {
    "source": "recognize-assistive-technology",
    "target": "interaction-capability"
  },
  {
    "source": "reconciliation-loops",
    "target": "operable"
  },
  {
    "source": "reconciliation-loops",
    "target": "reliable"
  },
  {
    "source": "reconciliation-loops",
    "target": "autonomy"
  },
  {
    "source": "reconciliation-loops",
    "target": "recoverability"
  },
  {
    "source": "reconciliation-loops",
    "target": "drift-detectability"
  },
  {
    "source": "reconciliation-loops",
    "target": "operability"
  },
  {
    "source": "reconciliation-loops",
    "target": "watchdog-supervision"
  },
  {
    "source": "recoverability",
    "target": "reliable"
  },
  {
    "source": "recoverability",
    "target": "usable"
  },
  {
    "source": "recoverability",
    "target": "robustness"
  },
  {
    "source": "recoverability",
    "target": "reliability"
  },
  {
    "source": "recoverability",
    "target": "usability"
  },
  {
    "source": "recoverability",
    "target": "availability"
  },
  {
    "source": "recoverability",
    "target": "faultlessness"
  },
  {
    "source": "recoverability",
    "target": "fault-tolerance"
  },
  {
    "source": "recoverability",
    "target": "autonomy"
  },
  {
    "source": "reduce-coupling",
    "target": "maintainable"
  },
  {
    "source": "reduce-coupling",
    "target": "flexible"
  },
  {
    "source": "reduce-coupling",
    "target": "modifiability"
  },
  {
    "source": "reduce-coupling",
    "target": "evolvability"
  },
  {
    "source": "reduce-coupling",
    "target": "testability"
  },
  {
    "source": "reduce-coupling",
    "target": "modularity"
  },
  {
    "source": "reduce-coupling",
    "target": "increase-cohesion"
  },
  {
    "source": "reduce-energy-consumption-with-new-version",
    "target": "sustainability"
  },
  {
    "source": "reduce-energy-consumption-with-new-version",
    "target": "carbon-emission-efficiency"
  },
  {
    "source": "reduce-energy-consumption-with-new-version",
    "target": "energy-efficiency"
  },
  {
    "source": "redundancy",
    "target": "reliable"
  },
  {
    "source": "redundancy",
    "target": "operable"
  },
  {
    "source": "redundancy",
    "target": "fault-tolerance"
  },
  {
    "source": "redundancy",
    "target": "availability"
  },
  {
    "source": "redundancy",
    "target": "reliability"
  },
  {
    "source": "redundancy",
    "target": "robustness"
  },
  {
    "source": "redundancy",
    "target": "resilience"
  },
  {
    "source": "redundancy",
    "target": "recoverability"
  },
  {
    "source": "reinterpret-domain-concept-from-historical-facts",
    "target": "evolvability"
  },
  {
    "source": "reinterpret-domain-concept-from-historical-facts",
    "target": "traceability"
  },
  {
    "source": "reinterpret-domain-concept-from-historical-facts",
    "target": "auditability"
  },
  {
    "source": "releasability",
    "target": "operable"
  },
  {
    "source": "releasability",
    "target": "efficient"
  },
  {
    "source": "releasability",
    "target": "operability"
  },
  {
    "source": "releasability",
    "target": "deployability"
  },
  {
    "source": "releasability",
    "target": "deployment-frequency"
  },
  {
    "source": "reliability",
    "target": "reliable"
  },
  {
    "source": "reliability",
    "target": "determinism"
  },
  {
    "source": "reliability",
    "target": "availability"
  },
  {
    "source": "reliability",
    "target": "robustness"
  },
  {
    "source": "reliability",
    "target": "fault-tolerance"
  },
  {
    "source": "reliability",
    "target": "dependability"
  },
  {
    "source": "reliability",
    "target": "resilience"
  },
  {
    "source": "reliable",
    "target": "quality-root"
  },
  {
    "source": "reliable-backup-and-restore",
    "target": "patient-safety"
  },
  {
    "source": "reliable-backup-and-restore",
    "target": "safety"
  },
  {
    "source": "reliable-backup-and-restore",
    "target": "reliability"
  },
  {
    "source": "reliable-backup-and-restore",
    "target": "availability"
  },
  {
    "source": "reliable-erh-system",
    "target": "patient-safety"
  },
  {
    "source": "reliable-erh-system",
    "target": "safety"
  },
  {
    "source": "reliable-erh-system",
    "target": "reliability"
  },
  {
    "source": "reliable-erh-system",
    "target": "efficiency"
  },
  {
    "source": "reliable-erh-system",
    "target": "availability"
  },
  {
    "source": "replaceability",
    "target": "operable"
  },
  {
    "source": "replaceability",
    "target": "flexible"
  },
  {
    "source": "replaceability",
    "target": "installability"
  },
  {
    "source": "replaceability",
    "target": "analysability"
  },
  {
    "source": "replaceability",
    "target": "operability"
  },
  {
    "source": "replaceability",
    "target": "deployability"
  },
  {
    "source": "replaceability",
    "target": "interchangeability"
  },
  {
    "source": "replaceability",
    "target": "portability"
  },
  {
    "source": "replaceability",
    "target": "flexibility"
  },
  {
    "source": "replaceability",
    "target": "independence"
  },
  {
    "source": "replaceability",
    "target": "modifiability"
  },
  {
    "source": "replaceability",
    "target": "compatibility"
  },
  {
    "source": "replication-and-quorum-failure-transparency",
    "target": "failure-transparency"
  },
  {
    "source": "replication-and-quorum-failure-transparency",
    "target": "availability"
  },
  {
    "source": "replication-and-quorum-failure-transparency",
    "target": "resilience"
  },
  {
    "source": "replication-and-quorum-failure-transparency",
    "target": "fault-tolerance"
  },
  {
    "source": "replication-and-quorum-failure-transparency",
    "target": "durability"
  },
  {
    "source": "reproducibility",
    "target": "usable"
  },
  {
    "source": "reproducibility",
    "target": "determinism"
  },
  {
    "source": "reproducibility",
    "target": "consistency"
  },
  {
    "source": "reproducibility",
    "target": "understandability"
  },
  {
    "source": "resilience",
    "target": "reliable"
  },
  {
    "source": "resilience",
    "target": "secure"
  },
  {
    "source": "resilience",
    "target": "availability"
  },
  {
    "source": "resilience",
    "target": "autonomy"
  },
  {
    "source": "resistance",
    "target": "secure"
  },
  {
    "source": "resistance",
    "target": "integrity"
  },
  {
    "source": "resistance",
    "target": "security"
  },
  {
    "source": "resistance",
    "target": "injection-resistance"
  },
  {
    "source": "resistance",
    "target": "dependability"
  },
  {
    "source": "resistance",
    "target": "fault-tolerance"
  },
  {
    "source": "resistance",
    "target": "recoverability"
  },
  {
    "source": "resource-efficiency",
    "target": "efficient"
  },
  {
    "source": "resource-efficiency",
    "target": "efficiency"
  },
  {
    "source": "resource-efficiency",
    "target": "resource-utilization"
  },
  {
    "source": "resource-efficiency",
    "target": "performance"
  },
  {
    "source": "resource-utilization",
    "target": "efficient"
  },
  {
    "source": "resource-utilization",
    "target": "efficiency"
  },
  {
    "source": "resource-utilization",
    "target": "resource-efficiency"
  },
  {
    "source": "resource-utilization",
    "target": "speed"
  },
  {
    "source": "resource-utilization",
    "target": "performance"
  },
  {
    "source": "resource-utilization",
    "target": "time-behaviour"
  },
  {
    "source": "resource-utilization",
    "target": "memory-usage"
  },
  {
    "source": "respond-to-15000-requests-per-workday",
    "target": "capacity"
  },
  {
    "source": "respond-to-15000-requests-per-workday",
    "target": "resource-efficiency"
  },
  {
    "source": "response-time",
    "target": "efficient"
  },
  {
    "source": "response-time",
    "target": "performance"
  },
  {
    "source": "response-time",
    "target": "speed"
  },
  {
    "source": "response-time",
    "target": "time-behaviour"
  },
  {
    "source": "response-time-for-image-rendering",
    "target": "response-time"
  },
  {
    "source": "response-time-for-image-rendering",
    "target": "efficiency"
  },
  {
    "source": "response-time-for-image-rendering",
    "target": "performance"
  },
  {
    "source": "response-time-for-image-rendering",
    "target": "time-behaviour"
  },
  {
    "source": "response-time-for-image-rendering",
    "target": "speed"
  },
  {
    "source": "response-time-for-image-rendering",
    "target": "responsiveness"
  },
  {
    "source": "responsive-design",
    "target": "usable"
  },
  {
    "source": "responsive-design",
    "target": "usability"
  },
  {
    "source": "responsive-design",
    "target": "accessibility"
  },
  {
    "source": "responsive-design",
    "target": "adaptability"
  },
  {
    "source": "responsiveness",
    "target": "usable"
  },
  {
    "source": "responsiveness",
    "target": "efficient"
  },
  {
    "source": "responsiveness",
    "target": "response-time"
  },
  {
    "source": "responsiveness",
    "target": "usability"
  },
  {
    "source": "responsiveness",
    "target": "user-experience"
  },
  {
    "source": "restore-filter-after-log-in",
    "target": "functional-appropriateness"
  },
  {
    "source": "restore-filter-after-log-in",
    "target": "personalization"
  },
  {
    "source": "restricted-memory",
    "target": "efficiency"
  },
  {
    "source": "restricted-memory",
    "target": "resource-efficiency"
  },
  {
    "source": "restricted-memory",
    "target": "memory-usage"
  },
  {
    "source": "retail-demand-forecast-drift-before-replenishment",
    "target": "drift-detectability"
  },
  {
    "source": "retail-demand-forecast-drift-before-replenishment",
    "target": "reliability"
  },
  {
    "source": "retail-demand-forecast-drift-before-replenishment",
    "target": "data-quality"
  },
  {
    "source": "retail-demand-forecast-drift-before-replenishment",
    "target": "timeliness"
  },
  {
    "source": "reusability",
    "target": "flexible"
  },
  {
    "source": "reusability",
    "target": "maintainable"
  },
  {
    "source": "reusability",
    "target": "flexibility"
  },
  {
    "source": "reusability",
    "target": "adaptability"
  },
  {
    "source": "reusability",
    "target": "changeability"
  },
  {
    "source": "reusability",
    "target": "configurability"
  },
  {
    "source": "reusability",
    "target": "maintainability"
  },
  {
    "source": "reusability",
    "target": "modifiability"
  },
  {
    "source": "risk-identification",
    "target": "safe"
  },
  {
    "source": "risk-identification",
    "target": "reliable"
  },
  {
    "source": "risk-identification",
    "target": "safety"
  },
  {
    "source": "risk-identification",
    "target": "analysability"
  },
  {
    "source": "robustness",
    "target": "reliable"
  },
  {
    "source": "robustness",
    "target": "resilience"
  },
  {
    "source": "robustness",
    "target": "dependability"
  },
  {
    "source": "robustness",
    "target": "reliability"
  },
  {
    "source": "rollout-new-feature",
    "target": "agility"
  },
  {
    "source": "rollout-new-feature",
    "target": "changeability"
  },
  {
    "source": "rollout-new-feature",
    "target": "maintainability"
  },
  {
    "source": "safe",
    "target": "quality-root"
  },
  {
    "source": "safe-integration",
    "target": "safe"
  },
  {
    "source": "safe-integration",
    "target": "reliable"
  },
  {
    "source": "safe-integration",
    "target": "safety"
  },
  {
    "source": "safe-integration",
    "target": "robustness"
  },
  {
    "source": "safety",
    "target": "safe"
  },
  {
    "source": "safety",
    "target": "reliable"
  },
  {
    "source": "safety",
    "target": "secure"
  },
  {
    "source": "safety",
    "target": "availability"
  },
  {
    "source": "safety",
    "target": "robustness"
  },
  {
    "source": "safety",
    "target": "certifiability"
  },
  {
    "source": "safety-interlocks",
    "target": "safe"
  },
  {
    "source": "safety-interlocks",
    "target": "safety"
  },
  {
    "source": "safety-interlocks",
    "target": "fail-safe"
  },
  {
    "source": "safety-interlocks",
    "target": "controllability"
  },
  {
    "source": "safety-interlocks",
    "target": "integrity"
  },
  {
    "source": "safety-interlocks",
    "target": "hazard-warning"
  },
  {
    "source": "safety-interlocks",
    "target": "user-error-protection"
  },
  {
    "source": "safety-requirements-traceable-to-evidence",
    "target": "verifiability"
  },
  {
    "source": "safety-requirements-traceable-to-evidence",
    "target": "testability"
  },
  {
    "source": "safety-requirements-traceable-to-evidence",
    "target": "certifiability"
  },
  {
    "source": "safety-requirements-traceable-to-evidence",
    "target": "traceability"
  },
  {
    "source": "saga-pattern",
    "target": "reliable"
  },
  {
    "source": "saga-pattern",
    "target": "flexible"
  },
  {
    "source": "saga-pattern",
    "target": "transactionality"
  },
  {
    "source": "saga-pattern",
    "target": "data-integrity"
  },
  {
    "source": "saga-pattern",
    "target": "recoverability"
  },
  {
    "source": "saga-pattern",
    "target": "availability"
  },
  {
    "source": "saga-pattern",
    "target": "loose-coupling"
  },
  {
    "source": "scalability",
    "target": "flexible"
  },
  {
    "source": "scalability",
    "target": "adaptability"
  },
  {
    "source": "scalability",
    "target": "elasticity"
  },
  {
    "source": "scalability",
    "target": "performance"
  },
  {
    "source": "scale-up-in-2-minutes",
    "target": "elasticity"
  },
  {
    "source": "scale-up-in-2-minutes",
    "target": "scalability"
  },
  {
    "source": "scale-up-in-2-minutes",
    "target": "performance"
  },
  {
    "source": "search-and-graph-text-filter-available-on-q42",
    "target": "functionality"
  },
  {
    "source": "search-and-graph-text-filter-available-on-q42",
    "target": "functional-appropriateness"
  },
  {
    "source": "search-and-graph-text-filter-available-on-q42",
    "target": "interaction-capability"
  },
  {
    "source": "search-and-graph-text-filter-available-on-q42",
    "target": "discoverability"
  },
  {
    "source": "secret-management",
    "target": "secure"
  },
  {
    "source": "secret-management",
    "target": "operable"
  },
  {
    "source": "secret-management",
    "target": "security"
  },
  {
    "source": "secret-management",
    "target": "confidentiality"
  },
  {
    "source": "secret-management",
    "target": "access-control"
  },
  {
    "source": "secret-management",
    "target": "auditability"
  },
  {
    "source": "secret-management",
    "target": "compliance"
  },
  {
    "source": "secret-management",
    "target": "operability"
  },
  {
    "source": "securability",
    "target": "secure"
  },
  {
    "source": "securability",
    "target": "security"
  },
  {
    "source": "secure",
    "target": "quality-root"
  },
  {
    "source": "security",
    "target": "secure"
  },
  {
    "source": "security",
    "target": "reliable"
  },
  {
    "source": "security",
    "target": "integrity"
  },
  {
    "source": "security",
    "target": "availability"
  },
  {
    "source": "security",
    "target": "non-repudiation"
  },
  {
    "source": "security",
    "target": "confidentiality"
  },
  {
    "source": "security",
    "target": "accountability"
  },
  {
    "source": "security",
    "target": "authenticity"
  },
  {
    "source": "security",
    "target": "resistance"
  },
  {
    "source": "security",
    "target": "injection-resistance"
  },
  {
    "source": "self-contained-systems",
    "target": "flexible"
  },
  {
    "source": "self-contained-systems",
    "target": "maintainable"
  },
  {
    "source": "self-contained-systems",
    "target": "autonomy"
  },
  {
    "source": "self-contained-systems",
    "target": "loose-coupling"
  },
  {
    "source": "self-contained-systems",
    "target": "evolvability"
  },
  {
    "source": "self-contained-systems",
    "target": "deployability"
  },
  {
    "source": "self-contained-systems",
    "target": "replaceability"
  },
  {
    "source": "self-containedness",
    "target": "flexible"
  },
  {
    "source": "self-containedness",
    "target": "flexibility"
  },
  {
    "source": "self-containedness",
    "target": "adaptability"
  },
  {
    "source": "self-containedness",
    "target": "changeability"
  },
  {
    "source": "self-containedness",
    "target": "configurability"
  },
  {
    "source": "self-containedness",
    "target": "maintainability"
  },
  {
    "source": "self-containedness",
    "target": "modifiability"
  },
  {
    "source": "self-containedness",
    "target": "modularity"
  },
  {
    "source": "self-containedness",
    "target": "autonomy"
  },
  {
    "source": "self-descriptiveness",
    "target": "usable"
  },
  {
    "source": "self-descriptiveness",
    "target": "usability"
  },
  {
    "source": "self-descriptiveness",
    "target": "user-assistance"
  },
  {
    "source": "self-descriptiveness",
    "target": "user-experience"
  },
  {
    "source": "self-descriptiveness",
    "target": "learnability"
  },
  {
    "source": "self-descriptiveness",
    "target": "conciseness"
  },
  {
    "source": "server-fails-operation-without-downtime",
    "target": "reliability"
  },
  {
    "source": "server-fails-operation-without-downtime",
    "target": "availability"
  },
  {
    "source": "server-fails-operation-without-downtime",
    "target": "availability"
  },
  {
    "source": "server-fails-operation-without-downtime",
    "target": "fault-tolerance"
  },
  {
    "source": "server-fails-operation-without-downtime",
    "target": "stability"
  },
  {
    "source": "service-loose-coupling-change-blast-radius",
    "target": "loose-coupling"
  },
  {
    "source": "service-loose-coupling-change-blast-radius",
    "target": "modularity"
  },
  {
    "source": "service-loose-coupling-change-blast-radius",
    "target": "evolvability"
  },
  {
    "source": "service-loose-coupling-change-blast-radius",
    "target": "deployability"
  },
  {
    "source": "service-loose-coupling-change-blast-radius",
    "target": "independence"
  },
  {
    "source": "shared-library-adoption-by-product-teams",
    "target": "reusability"
  },
  {
    "source": "shared-library-adoption-by-product-teams",
    "target": "maintainability"
  },
  {
    "source": "shared-library-adoption-by-product-teams",
    "target": "modifiability"
  },
  {
    "source": "shared-library-adoption-by-product-teams",
    "target": "adaptability"
  },
  {
    "source": "shutdown-time",
    "target": "efficient"
  },
  {
    "source": "shutdown-time",
    "target": "startup-time"
  },
  {
    "source": "shutdown-time",
    "target": "time-behaviour"
  },
  {
    "source": "shutdown-to-safe-state",
    "target": "dependability"
  },
  {
    "source": "shutdown-to-safe-state",
    "target": "safety"
  },
  {
    "source": "shutdown-to-safe-state",
    "target": "operability"
  },
  {
    "source": "shutdown-to-safe-state",
    "target": "fail-safe"
  },
  {
    "source": "shutdown-to-safe-state",
    "target": "reliability"
  },
  {
    "source": "sidecar",
    "target": "flexible"
  },
  {
    "source": "sidecar",
    "target": "operable"
  },
  {
    "source": "sidecar",
    "target": "extensibility"
  },
  {
    "source": "sidecar",
    "target": "backward-compatibility"
  },
  {
    "source": "sidecar",
    "target": "observability"
  },
  {
    "source": "sidecar",
    "target": "interoperability"
  },
  {
    "source": "sidecar",
    "target": "plugin-architecture"
  },
  {
    "source": "sidecar",
    "target": "microservice-architecture"
  },
  {
    "source": "simplicity",
    "target": "efficient"
  },
  {
    "source": "simplicity",
    "target": "usable"
  },
  {
    "source": "simplicity",
    "target": "efficiency"
  },
  {
    "source": "simplicity",
    "target": "modularity"
  },
  {
    "source": "soc2",
    "target": "confidentiality"
  },
  {
    "source": "soc2",
    "target": "non-repudiation"
  },
  {
    "source": "soc2",
    "target": "privacy"
  },
  {
    "source": "soc2",
    "target": "access-control"
  },
  {
    "source": "soc2",
    "target": "accountability"
  },
  {
    "source": "soc2",
    "target": "auditability"
  },
  {
    "source": "soc2",
    "target": "availability"
  },
  {
    "source": "soc2",
    "target": "secure"
  },
  {
    "source": "soc2",
    "target": "operable"
  },
  {
    "source": "soc2",
    "target": "reliable"
  },
  {
    "source": "soc2",
    "target": "usable"
  },
  {
    "source": "sox",
    "target": "compliance"
  },
  {
    "source": "sox",
    "target": "confidentiality"
  },
  {
    "source": "sox",
    "target": "consistency"
  },
  {
    "source": "sox",
    "target": "correctness"
  },
  {
    "source": "sox",
    "target": "data-integrity"
  },
  {
    "source": "sox",
    "target": "data-quality"
  },
  {
    "source": "sox",
    "target": "functional-completeness"
  },
  {
    "source": "sox",
    "target": "observability"
  },
  {
    "source": "sox",
    "target": "performance"
  },
  {
    "source": "sox",
    "target": "recoverability"
  },
  {
    "source": "sox",
    "target": "reliability"
  },
  {
    "source": "sox",
    "target": "traceability"
  },
  {
    "source": "sox",
    "target": "transparency"
  },
  {
    "source": "sox",
    "target": "scalability"
  },
  {
    "source": "sox",
    "target": "security"
  },
  {
    "source": "sox",
    "target": "access-control"
  },
  {
    "source": "sox",
    "target": "accountability"
  },
  {
    "source": "sox",
    "target": "accuracy"
  },
  {
    "source": "sox",
    "target": "auditability"
  },
  {
    "source": "sox",
    "target": "authenticity"
  },
  {
    "source": "sox",
    "target": "availability"
  },
  {
    "source": "sox",
    "target": "secure"
  },
  {
    "source": "sox",
    "target": "safe"
  },
  {
    "source": "sox",
    "target": "usable"
  },
  {
    "source": "sox",
    "target": "reliable"
  },
  {
    "source": "sox",
    "target": "efficient"
  },
  {
    "source": "sox",
    "target": "suitable"
  },
  {
    "source": "sox",
    "target": "operable"
  },
  {
    "source": "sox",
    "target": "flexible"
  },
  {
    "source": "speed",
    "target": "efficient"
  },
  {
    "source": "speed",
    "target": "efficiency"
  },
  {
    "source": "speed",
    "target": "performance"
  },
  {
    "source": "speed",
    "target": "time-behaviour"
  },
  {
    "source": "stability",
    "target": "reliable"
  },
  {
    "source": "stability",
    "target": "reliability"
  },
  {
    "source": "stability",
    "target": "adaptability"
  },
  {
    "source": "stability",
    "target": "changeability"
  },
  {
    "source": "standby-failover",
    "target": "reliable"
  },
  {
    "source": "standby-failover",
    "target": "operable"
  },
  {
    "source": "standby-failover",
    "target": "availability"
  },
  {
    "source": "standby-failover",
    "target": "fault-tolerance"
  },
  {
    "source": "standby-failover",
    "target": "recoverability"
  },
  {
    "source": "standby-failover",
    "target": "data-replication"
  },
  {
    "source": "standby-failover",
    "target": "n-version-redundancy"
  },
  {
    "source": "startup-time",
    "target": "efficient"
  },
  {
    "source": "startup-time",
    "target": "efficiency"
  },
  {
    "source": "startup-time",
    "target": "performance"
  },
  {
    "source": "startup-time",
    "target": "time-behaviour"
  },
  {
    "source": "strong-authentication",
    "target": "secure"
  },
  {
    "source": "strong-authentication",
    "target": "security"
  },
  {
    "source": "strong-authentication",
    "target": "authenticity"
  },
  {
    "source": "strong-authentication",
    "target": "access-control"
  },
  {
    "source": "strong-authentication",
    "target": "accountability"
  },
  {
    "source": "strong-authentication",
    "target": "non-repudiation"
  },
  {
    "source": "strong-authentication",
    "target": "compliance"
  },
  {
    "source": "suitability",
    "target": "suitable"
  },
  {
    "source": "suitability",
    "target": "functional-suitability"
  },
  {
    "source": "suitability",
    "target": "usability"
  },
  {
    "source": "suitability",
    "target": "accessibility"
  },
  {
    "source": "suitable",
    "target": "quality-root"
  },
  {
    "source": "sustainability",
    "target": "efficient"
  },
  {
    "source": "sustainability",
    "target": "reliable"
  },
  {
    "source": "sustainability",
    "target": "energy-efficiency"
  },
  {
    "source": "sustainability",
    "target": "carbon-emission-efficiency"
  },
  {
    "source": "swappable-llm-provider",
    "target": "replaceability"
  },
  {
    "source": "swappable-llm-provider",
    "target": "portability"
  },
  {
    "source": "swappable-llm-provider",
    "target": "interchangeability"
  },
  {
    "source": "swappable-llm-provider",
    "target": "modifiability"
  },
  {
    "source": "swappable-llm-provider",
    "target": "independence"
  },
  {
    "source": "system-runs-offline",
    "target": "reliability"
  },
  {
    "source": "system-runs-offline",
    "target": "autonomy"
  },
  {
    "source": "tamper-evident-digital-signatures",
    "target": "non-repudiation"
  },
  {
    "source": "tamper-evident-digital-signatures",
    "target": "security"
  },
  {
    "source": "tamper-evident-digital-signatures",
    "target": "auditability"
  },
  {
    "source": "tamper-evident-digital-signatures",
    "target": "data-integrity"
  },
  {
    "source": "tamper-evident-digital-signatures",
    "target": "authenticity"
  },
  {
    "source": "tamper-evident-digital-signatures",
    "target": "traceability"
  },
  {
    "source": "test-coverage",
    "target": "suitable"
  },
  {
    "source": "test-coverage",
    "target": "maintainable"
  },
  {
    "source": "test-coverage",
    "target": "maintainability"
  },
  {
    "source": "test-coverage",
    "target": "flexibility"
  },
  {
    "source": "test-coverage",
    "target": "modifiability"
  },
  {
    "source": "test-coverage",
    "target": "analysability"
  },
  {
    "source": "test-coverage",
    "target": "testability"
  },
  {
    "source": "test-coverage-for-critical-business-logic",
    "target": "test-coverage"
  },
  {
    "source": "test-coverage-for-critical-business-logic",
    "target": "testability"
  },
  {
    "source": "test-coverage-for-critical-business-logic",
    "target": "maintainability"
  },
  {
    "source": "test-with-path-coverage-30min",
    "target": "testability"
  },
  {
    "source": "test-with-path-coverage-30min",
    "target": "risk-identification"
  },
  {
    "source": "test-with-path-coverage-30min",
    "target": "cycle-time"
  },
  {
    "source": "testability",
    "target": "suitable"
  },
  {
    "source": "testability",
    "target": "maintainable"
  },
  {
    "source": "testability",
    "target": "determinism"
  },
  {
    "source": "testability",
    "target": "maintainability"
  },
  {
    "source": "testability",
    "target": "flexibility"
  },
  {
    "source": "testability",
    "target": "modifiability"
  },
  {
    "source": "testability",
    "target": "analysability"
  },
  {
    "source": "themability",
    "target": "flexible"
  },
  {
    "source": "themability",
    "target": "maintainable"
  },
  {
    "source": "themability",
    "target": "modifiability"
  },
  {
    "source": "themability",
    "target": "configurability"
  },
  {
    "source": "themability",
    "target": "customizability"
  },
  {
    "source": "themability",
    "target": "personalization"
  },
  {
    "source": "themability",
    "target": "user-interface-aesthetics"
  },
  {
    "source": "themability",
    "target": "accessibility"
  },
  {
    "source": "threat-modeling",
    "target": "secure"
  },
  {
    "source": "threat-modeling",
    "target": "risk-identification"
  },
  {
    "source": "threat-modeling",
    "target": "securability"
  },
  {
    "source": "threat-modeling",
    "target": "confidentiality"
  },
  {
    "source": "threat-modeling",
    "target": "integrity"
  },
  {
    "source": "threat-modeling",
    "target": "intrusion-prevention"
  },
  {
    "source": "threat-modeling",
    "target": "least-privilege"
  },
  {
    "source": "threat-modeling",
    "target": "input-sanitization-output-encoding"
  },
  {
    "source": "throughput",
    "target": "efficient"
  },
  {
    "source": "throughput",
    "target": "performance"
  },
  {
    "source": "throughput",
    "target": "efficiency"
  },
  {
    "source": "throughput",
    "target": "speed"
  },
  {
    "source": "time-behaviour",
    "target": "efficient"
  },
  {
    "source": "time-behaviour",
    "target": "determinism"
  },
  {
    "source": "time-behaviour",
    "target": "efficiency"
  },
  {
    "source": "time-behaviour",
    "target": "resource-efficiency"
  },
  {
    "source": "time-behaviour",
    "target": "speed"
  },
  {
    "source": "time-behaviour",
    "target": "performance"
  },
  {
    "source": "time-to-market",
    "target": "efficient"
  },
  {
    "source": "time-to-market",
    "target": "flexibility"
  },
  {
    "source": "time-to-market",
    "target": "efficiency"
  },
  {
    "source": "time-to-market",
    "target": "deployment-frequency"
  },
  {
    "source": "time-to-market",
    "target": "extensibility"
  },
  {
    "source": "time-to-market",
    "target": "lead-time-for-changes"
  },
  {
    "source": "time-to-market",
    "target": "cycle-time"
  },
  {
    "source": "timeliness",
    "target": "reliable"
  },
  {
    "source": "timeliness",
    "target": "suitable"
  },
  {
    "source": "timeliness",
    "target": "data-quality"
  },
  {
    "source": "timeliness",
    "target": "accuracy"
  },
  {
    "source": "timeliness",
    "target": "completeness"
  },
  {
    "source": "timeliness",
    "target": "consistency"
  },
  {
    "source": "timeliness",
    "target": "credibility"
  },
  {
    "source": "timeout",
    "target": "reliable"
  },
  {
    "source": "timeout",
    "target": "safe"
  },
  {
    "source": "timeout",
    "target": "availability"
  },
  {
    "source": "timeout",
    "target": "fault-tolerance"
  },
  {
    "source": "timeout",
    "target": "fault-isolation"
  },
  {
    "source": "timeout",
    "target": "response-time"
  },
  {
    "source": "timeout",
    "target": "circuit-breaker"
  },
  {
    "source": "tolerant-reader",
    "target": "flexible"
  },
  {
    "source": "tolerant-reader",
    "target": "reliable"
  },
  {
    "source": "tolerant-reader",
    "target": "operable"
  },
  {
    "source": "tolerant-reader",
    "target": "backward-compatibility"
  },
  {
    "source": "tolerant-reader",
    "target": "interoperability"
  },
  {
    "source": "tolerant-reader",
    "target": "robustness"
  },
  {
    "source": "tolerant-reader",
    "target": "evolvability"
  },
  {
    "source": "tolerant-reader",
    "target": "open-host-service"
  },
  {
    "source": "tolerant-reader",
    "target": "event-driven-architecture"
  },
  {
    "source": "traceability",
    "target": "reliable"
  },
  {
    "source": "traceability",
    "target": "operable"
  },
  {
    "source": "traceability",
    "target": "devops-metrics"
  },
  {
    "source": "traceability",
    "target": "operability"
  },
  {
    "source": "traceability",
    "target": "testability"
  },
  {
    "source": "traceability",
    "target": "certifiability"
  },
  {
    "source": "traceability",
    "target": "accountability"
  },
  {
    "source": "transaction-processing-faultlessness",
    "target": "faultlessness"
  },
  {
    "source": "transaction-processing-faultlessness",
    "target": "reliability"
  },
  {
    "source": "transaction-processing-faultlessness",
    "target": "dependability"
  },
  {
    "source": "transaction-processing-faultlessness",
    "target": "correctness"
  },
  {
    "source": "transactional-outbox",
    "target": "reliable"
  },
  {
    "source": "transactional-outbox",
    "target": "atomicity"
  },
  {
    "source": "transactional-outbox",
    "target": "consistency"
  },
  {
    "source": "transactional-outbox",
    "target": "data-integrity"
  },
  {
    "source": "transactional-outbox",
    "target": "reliability"
  },
  {
    "source": "transactional-outbox",
    "target": "event-sourcing"
  },
  {
    "source": "transactional-outbox",
    "target": "saga-pattern"
  },
  {
    "source": "transactional-outbox",
    "target": "asynchronous-messaging"
  },
  {
    "source": "transactionality",
    "target": "reliable"
  },
  {
    "source": "transactionality",
    "target": "determinism"
  },
  {
    "source": "transactionality",
    "target": "atomicity"
  },
  {
    "source": "transactionality",
    "target": "consistency"
  },
  {
    "source": "transactionality",
    "target": "durability"
  },
  {
    "source": "transactionality",
    "target": "data-integrity"
  },
  {
    "source": "transactionality",
    "target": "robustness"
  },
  {
    "source": "transparency",
    "target": "reliable"
  },
  {
    "source": "transparency",
    "target": "clarity"
  },
  {
    "source": "transparency",
    "target": "understandability"
  },
  {
    "source": "transparency",
    "target": "usability"
  },
  {
    "source": "transparency",
    "target": "model-transparency"
  },
  {
    "source": "transparency",
    "target": "interaction-capability"
  },
  {
    "source": "unavailability-max-2-minutes",
    "target": "availability"
  },
  {
    "source": "unavailability-max-2-minutes",
    "target": "reliability"
  },
  {
    "source": "understandability",
    "target": "usable"
  },
  {
    "source": "understandability",
    "target": "operable"
  },
  {
    "source": "understandability",
    "target": "usability"
  },
  {
    "source": "understandability",
    "target": "self-descriptiveness"
  },
  {
    "source": "understandability",
    "target": "user-assistance"
  },
  {
    "source": "understandability",
    "target": "user-experience"
  },
  {
    "source": "understandability",
    "target": "learnability"
  },
  {
    "source": "understandability",
    "target": "conciseness"
  },
  {
    "source": "understandable-acceptance-tests",
    "target": "understandability"
  },
  {
    "source": "understandable-acceptance-tests",
    "target": "learnability"
  },
  {
    "source": "understandable-acceptance-tests",
    "target": "testability"
  },
  {
    "source": "understandable-acceptance-tests",
    "target": "maintainability"
  },
  {
    "source": "understandable-generated-code",
    "target": "understandability"
  },
  {
    "source": "understandable-generated-code",
    "target": "maintainability"
  },
  {
    "source": "understandable-generated-code",
    "target": "readability"
  },
  {
    "source": "understandable-generated-code",
    "target": "code-readability"
  },
  {
    "source": "understandable-generated-code",
    "target": "legibility"
  },
  {
    "source": "up-to-date-api",
    "target": "reliability"
  },
  {
    "source": "up-to-date-api",
    "target": "accuracy"
  },
  {
    "source": "up-to-date-api",
    "target": "correctness"
  },
  {
    "source": "updateability",
    "target": "operable"
  },
  {
    "source": "updateability",
    "target": "maintainable"
  },
  {
    "source": "updateability",
    "target": "maintainability"
  },
  {
    "source": "updateability",
    "target": "upgradeability"
  },
  {
    "source": "updateability",
    "target": "installability"
  },
  {
    "source": "updateability",
    "target": "modifiability"
  },
  {
    "source": "updateability",
    "target": "flexibility"
  },
  {
    "source": "updateability",
    "target": "portability"
  },
  {
    "source": "updateability",
    "target": "configurability"
  },
  {
    "source": "updateability",
    "target": "securability"
  },
  {
    "source": "upgradeability",
    "target": "operable"
  },
  {
    "source": "upgradeability",
    "target": "maintainable"
  },
  {
    "source": "upgradeability",
    "target": "flexibility"
  },
  {
    "source": "upgradeability",
    "target": "operability"
  },
  {
    "source": "upgradeability",
    "target": "predictability"
  },
  {
    "source": "upgradeability",
    "target": "releasability"
  },
  {
    "source": "upgradeability",
    "target": "installability"
  },
  {
    "source": "usability",
    "target": "usable"
  },
  {
    "source": "usability",
    "target": "operable"
  },
  {
    "source": "usability",
    "target": "functionality"
  },
  {
    "source": "usability",
    "target": "attractiveness"
  },
  {
    "source": "usability",
    "target": "operability"
  },
  {
    "source": "usability",
    "target": "user-error-protection"
  },
  {
    "source": "usability",
    "target": "user-engagement"
  },
  {
    "source": "usability",
    "target": "ease-of-use"
  },
  {
    "source": "usability",
    "target": "inclusivity"
  },
  {
    "source": "usable",
    "target": "quality-root"
  },
  {
    "source": "usable-despite-color-blindness",
    "target": "usability"
  },
  {
    "source": "usable-despite-color-blindness",
    "target": "user-experience"
  },
  {
    "source": "usable-despite-color-blindness",
    "target": "compliance"
  },
  {
    "source": "usable-despite-color-blindness",
    "target": "accessibility"
  },
  {
    "source": "usable-despite-color-blindness",
    "target": "inclusivity"
  },
  {
    "source": "usable-despite-color-blindness",
    "target": "interaction-capability"
  },
  {
    "source": "usable-on-factory-floor",
    "target": "anticipated-workplace-environment"
  },
  {
    "source": "usable-on-factory-floor",
    "target": "usability"
  },
  {
    "source": "usable-on-factory-floor",
    "target": "interaction-capability"
  },
  {
    "source": "usable-on-factory-floor",
    "target": "expected-physical-environment"
  },
  {
    "source": "usable-with-gloves",
    "target": "anticipated-workplace-environment"
  },
  {
    "source": "usable-with-gloves",
    "target": "usability"
  },
  {
    "source": "usable-with-gloves",
    "target": "interaction-capability"
  },
  {
    "source": "usable-with-gloves",
    "target": "expected-physical-environment"
  },
  {
    "source": "user-assistance",
    "target": "usable"
  },
  {
    "source": "user-assistance",
    "target": "usability"
  },
  {
    "source": "user-assistance",
    "target": "user-error-protection"
  },
  {
    "source": "user-assistance",
    "target": "user-engagement"
  },
  {
    "source": "user-engagement",
    "target": "usable"
  },
  {
    "source": "user-engagement",
    "target": "usability"
  },
  {
    "source": "user-engagement",
    "target": "user-interface-aesthetics"
  },
  {
    "source": "user-engagement",
    "target": "user-experience"
  },
  {
    "source": "user-error-protection",
    "target": "usable"
  },
  {
    "source": "user-error-protection",
    "target": "operable"
  },
  {
    "source": "user-error-protection",
    "target": "usability"
  },
  {
    "source": "user-error-protection",
    "target": "operability"
  },
  {
    "source": "user-error-protection",
    "target": "robustness"
  },
  {
    "source": "user-experience",
    "target": "usable"
  },
  {
    "source": "user-experience",
    "target": "usability"
  },
  {
    "source": "user-experience",
    "target": "user-interface-aesthetics"
  },
  {
    "source": "user-experience",
    "target": "user-error-protection"
  },
  {
    "source": "user-experience",
    "target": "accessibility"
  },
  {
    "source": "user-interface-aesthetics",
    "target": "usable"
  },
  {
    "source": "user-interface-aesthetics",
    "target": "usability"
  },
  {
    "source": "user-interface-aesthetics",
    "target": "user-engagement"
  },
  {
    "source": "user-interface-aesthetics",
    "target": "user-experience"
  },
  {
    "source": "user-interface-aesthetics",
    "target": "appearance"
  },
  {
    "source": "user-interface-aesthetics",
    "target": "attractiveness"
  },
  {
    "source": "user-interface-aesthetics",
    "target": "consistency"
  },
  {
    "source": "user-interface-aesthetics",
    "target": "themability"
  },
  {
    "source": "user-interface-works-with-current-browsers",
    "target": "flexibility"
  },
  {
    "source": "user-interface-works-with-current-browsers",
    "target": "portability"
  },
  {
    "source": "user-interface-works-with-current-browsers",
    "target": "compatibility"
  },
  {
    "source": "user-interface-works-with-current-browsers",
    "target": "interoperability"
  },
  {
    "source": "user-interface-works-with-current-browsers",
    "target": "interaction-capability"
  },
  {
    "source": "user-tries-primary-function",
    "target": "functional-appropriateness"
  },
  {
    "source": "user-tries-primary-function",
    "target": "functional-completeness"
  },
  {
    "source": "user-tries-primary-function",
    "target": "user-experience"
  },
  {
    "source": "user-tries-primary-function",
    "target": "appropriateness-recognizability"
  },
  {
    "source": "user-tries-primary-function",
    "target": "interaction-capability"
  },
  {
    "source": "user-tries-primary-function",
    "target": "functional-suitability"
  },
  {
    "source": "verifiability",
    "target": "reliable"
  },
  {
    "source": "verifiability",
    "target": "maintainable"
  },
  {
    "source": "verifiability",
    "target": "testability"
  },
  {
    "source": "verifiability",
    "target": "analysability"
  },
  {
    "source": "verifiability",
    "target": "certifiability"
  },
  {
    "source": "versatility",
    "target": "flexible"
  },
  {
    "source": "versatility",
    "target": "suitable"
  },
  {
    "source": "versatility",
    "target": "flexibility"
  },
  {
    "source": "versatility",
    "target": "adaptability"
  },
  {
    "source": "vulnerability",
    "target": "secure"
  },
  {
    "source": "vulnerability",
    "target": "reliable"
  },
  {
    "source": "vulnerability",
    "target": "reliability"
  },
  {
    "source": "vulnerability",
    "target": "availability"
  },
  {
    "source": "vulnerability",
    "target": "fault-tolerance"
  },
  {
    "source": "vulnerability",
    "target": "immunity"
  },
  {
    "source": "watchdog-supervision",
    "target": "safe"
  },
  {
    "source": "watchdog-supervision",
    "target": "reliable"
  },
  {
    "source": "watchdog-supervision",
    "target": "availability"
  },
  {
    "source": "watchdog-supervision",
    "target": "fault-tolerance"
  },
  {
    "source": "watchdog-supervision",
    "target": "recoverability"
  },
  {
    "source": "watchdog-supervision",
    "target": "autonomy"
  },
  {
    "source": "watchdog-supervision",
    "target": "mean-time-to-recovery"
  },
  {
    "source": "watchdog-supervision",
    "target": "safety"
  },
  {
    "source": "wcag22",
    "target": "compliance"
  },
  {
    "source": "wcag22",
    "target": "consistency"
  },
  {
    "source": "wcag22",
    "target": "flexibility"
  },
  {
    "source": "wcag22",
    "target": "inclusivity"
  },
  {
    "source": "wcag22",
    "target": "interaction-capability"
  },
  {
    "source": "wcag22",
    "target": "interoperability"
  },
  {
    "source": "wcag22",
    "target": "operability"
  },
  {
    "source": "wcag22",
    "target": "robustness"
  },
  {
    "source": "wcag22",
    "target": "understandability"
  },
  {
    "source": "wcag22",
    "target": "usability"
  },
  {
    "source": "wcag22",
    "target": "user-error-protection"
  },
  {
    "source": "wcag22",
    "target": "accessibility"
  },
  {
    "source": "wcag22",
    "target": "secure"
  },
  {
    "source": "wcag22",
    "target": "safe"
  },
  {
    "source": "wcag22",
    "target": "usable"
  },
  {
    "source": "wcag22",
    "target": "reliable"
  },
  {
    "source": "wcag22",
    "target": "efficient"
  },
  {
    "source": "wcag22",
    "target": "suitable"
  },
  {
    "source": "wcag22",
    "target": "flexible"
  },
  {
    "source": "wcag22",
    "target": "operable"
  },
  {
    "source": "withstand-ddos-attack",
    "target": "resilience"
  },
  {
    "source": "withstand-ddos-attack",
    "target": "reliability"
  },
  {
    "source": "withstand-ddos-attack",
    "target": "availability"
  },
  {
    "source": "withstand-ddos-attack",
    "target": "availability"
  },
  {
    "source": "withstand-ddos-attack",
    "target": "recoverability"
  },
  {
    "source": "withstand-ddos-attack",
    "target": "intrusion-detection"
  },
  {
    "source": "withstand-ddos-attack",
    "target": "resistance"
  },
  {
    "source": "zero-knowledge-data-storage",
    "target": "confidentiality"
  },
  {
    "source": "zero-knowledge-data-storage",
    "target": "security"
  },
  {
    "source": "zero-knowledge-data-storage",
    "target": "privacy"
  },
  {
    "source": "zone-failure-no-service-interruption",
    "target": "redundancy"
  },
  {
    "source": "zone-failure-no-service-interruption",
    "target": "availability"
  },
  {
    "source": "zone-failure-no-service-interruption",
    "target": "fault-tolerance"
  },
  {
    "source": "zone-failure-no-service-interruption",
    "target": "resilience"
  }
]